import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Config } from 'datatables.net';
import { months } from 'moment';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
import { Subject } from 'rxjs';
import { ReportService } from 'src/app/services/report.service';
import { SocketService } from 'src/app/services/socket.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
})
export class ReportsComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private router: Router,
    private service: ReportService,
    private socket: SocketService
  ) {}

  role: string;

  // configs
  dtOptions: Config = {
    pagingType: 'simple_numbers',
    language: {
      searchPlaceholder: 'Search here...',
    },
  };
  dtTrigger: Subject<any> = new Subject<any>();
  dtTrigger2: Subject<any> = new Subject<any>();
  dtTrigger3: Subject<any> = new Subject<any>();
  maxDateForPicker: Date;

  dropdownSettings = {
    singleSelection: false,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Deselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true,
  };

  // fill filters
  reportTypes: any[] = [];
  advisors: any[] = [];

  // filter
  filterReportType = '';
  filterIsMonthRange = false;
  filterDateSelection = '';
  filterAdvisors: any[] = [];

  data = [];
  arrearsData = [];
  isViewReport = false;
  title = 'Report';
  pdfSrc: string | ArrayBuffer | null = null;

  tableHeaders: any;
  actions: string[] = [];
  paymentDetails: any[] = [];

  // reportRequests = [];

  // payment
  paymentMonth = '';
  paymentDate = new Date();
  paymentAmountPaid = 0;

  titleAdjustment = '';
  isEditAdjustment = false;
  historyAdjustment = [];
  formAdjustment = new FormGroup({
    reportTypeId: new FormControl(0),
    type: new FormControl('credit'),
    month: new FormControl(''),
    // impactedMonth: new FormControl(''),
    amount: new FormControl(''),
    description: new FormControl(''),
    // status: new FormControl(''),
    subId: new FormControl(0),
  });

  ngOnInit(): void {
    this.role = sessionStorage.getItem('role');

    this.getReportTypes();

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    this.maxDateForPicker = new Date(currentYear, currentMonth + 1);

    this.socket.listen('privateNotification').subscribe((data: any) => {
      setTimeout(() => {
        this.applyFilters();
      }, 1000);
    });
  }

  applyFilters() {
    let monthMapping: any = {
      "01": "Jan",
      "02": "Feb",
      "03": "Mar",
      "04": "Apr",
      "05": "May",
      "06": "Jun",
      "07": "Jul",
      "08": "Aug",
      "09": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    };

    let start = '';
    let end = '';
    let startText = 'all'

    if (this.filterIsMonthRange) {
      const startDate = new Date(this.filterDateSelection[0]);
      const startYear = startDate.getFullYear();
      const startMonth = String(startDate.getMonth() + 1).padStart(2, '0');
      const endDate = new Date(this.filterDateSelection[1]);
      const endYear = endDate.getFullYear();
      const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
      start = `${startYear}-${startMonth}`;
      startText = monthMapping[startMonth];
      end = `${endYear}-${endMonth}`;
    } else {
      if (!this.filterDateSelection) {
        return;
      }
      const date = new Date(this.filterDateSelection);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      start = `${year}-${month}`;
      startText = monthMapping[month];
    }

    this.isViewReport = true;

    const adv = this.filterAdvisors.map((el) => el.id);
    if(this.filterReportType == '11') {
      this.getReportsForArrears(
        this.filterReportType,
      this.filterIsMonthRange,
      startText,
      end,
      adv
      )
    }else{
      this.getReports(
        this.filterReportType,
        this.filterIsMonthRange,
      start,
      end,
      adv
    );
  }
  }

  resetFilters() {
    this.isViewReport = false;
    this.filterReportType = '';
    this.filterIsMonthRange = false;
    this.filterDateSelection = '';
    this.filterAdvisors = [];
  }

  viewDetail(item) {
    if (this.filterReportType === '6') {
      this.paymentDetails = item.paymentDetails;
      $('#pad-report-modal').modal('show');
      this.dtTrigger2.next(null);
      $('#DataTables_Table_2').dataTable().fnDestroy();
    }
  }

  viewExcelReport() {
    this.router.navigate(['/report-detail']);
  }

  downloadExcelReport(item) {
    var accessToken = sessionStorage.getItem('accessToken');

    if (item.reportStatus === 'Draft') {
      this.http
        .get(
          // `${environment.reportApiUrl}/report/file?id=${item.id}&reportType=${item.reportTypeId}&fileType=xlsx`,
          `${environment.reportApiUrl}/report/file?id=${item.id}&reportType=${this.filterReportType}&fileType=xlsx`,
          {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
            responseType: 'text',
          }
        )
        .subscribe({
          next: (res: any) => {
            const base64Data = this.sanitizeBase64(res);
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            let filename = '';
            if (item.xlsxName.includes('.') && item.xlsxName.lastIndexOf('.') > 0) {
              filename = item.xlsxName;
            } else {
              filename = `${item.xlsxName}.xlsx`;
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.click();

            window.URL.revokeObjectURL(url);
          },
          error: (error) => {},
        });

      return;
    } else {
      this.http
        .get(
          `${environment.reportApiUrl}/report/file?id=${item.id}&reportType=${item.reportTypeId}&fileType=xlsx`,
          {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
            responseType: 'blob',
          }
        )
        .subscribe({
          next: (res: any) => {
            const blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            let filename = '';
            if (item.xlsxName.includes('.') && item.xlsxName.lastIndexOf('.') > 0) {
              filename = item.xlsxName;
            } else {
              filename = `${item.xlsxName}.xlsx`;
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.click();

            window.URL.revokeObjectURL(url);
          },
          error: (error) => {},
        });
    }
  }

  viewPdf(item: any, i: number) {
    this.pdfSrc = undefined;
    this.title = '';

    var accessToken = sessionStorage.getItem('accessToken');

    if (item.reportStatus === 'Draft') {
      this.http
        .get(
          `${environment.reportApiUrl}/report/file?id=${item.id}&reportType=${item.reportTypeId}&fileType=pdf`,
          {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
            responseType: 'text',
          }
        )
        .subscribe({
          next: (res: any) => {
            const base64Data = this.sanitizeBase64(res);
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
              type: 'application/pdf',
            });

            const fileReader = new FileReader();
            fileReader.onload = () => {
              this.pdfSrc = fileReader.result;
            };
            fileReader.readAsArrayBuffer(blob);
          },
          error: (error) => {},
        });
    } else {
      this.http
        .get(
          `${environment.reportApiUrl}/report/file?id=${item.id}&reportType=${item.reportTypeId}&fileType=pdf`,
          {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
            responseType: 'blob',
          }
        )
        .subscribe({
          next: (res: any) => {
            const blob = new Blob([res], { type: 'application/pdf' });
            const fileReader = new FileReader();
            fileReader.onload = () => {
              this.pdfSrc = fileReader.result;
            };
            fileReader.readAsArrayBuffer(blob);
          },
          error: (error) => {},
        });
    }

    this.title = `Report - ${item.pdfName}`;
    $('#advisor-report-modal').modal('show');
  }

  viewAdjustment(item) {
    console.log('adjustment', item);

    if (item.reportTypeId === 1) {
      this.titleAdjustment = item.pdfName;
    } else {
      this.titleAdjustment = item.xlsxName;
    }

    let subId = 0;
    switch (item.reportTypeId) {
      case 1:
        subId = item.advisorId;
        break;
      case 2:
        break;
      case 3:
        subId = item.partnerId;
        break;
      case 4:
        break;
      case 5:
        break;
      case 6:
        break;
      default:
    }

    this.service.getAdjustment(item.reportTypeId, item.date, subId).subscribe({
      next: (res: any) => {
        if (res) {
          this.isEditAdjustment = true;
          this.formAdjustment.patchValue({
            reportTypeId: item.reportTypeId,
            type: res.type,
            month: item.date,
            amount: res.amount,
            description: res.description,
            subId: subId,
          });
          this.historyAdjustment = res.history;
        } else {
          this.isEditAdjustment = false;
          this.formAdjustment.patchValue({
            reportTypeId: item.reportTypeId,
            month: item.date,
            subId: subId,
          });
        }

        $('#adjustment-modal').modal('show');
      },
      error: (error) => {
        console.log('getAdjustment', error);
      },
    });
  }

  viewFinalize(item) {
    // Swal.fire({
    //   title: 'Alert',
    //   text: `Are you sure you want to finalize the report?`,
    //   showDenyButton: false,
    //   showCancelButton: true,
    //   confirmButtonText: 'Proceed',
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     setTimeout(() => {
    //       this.generateReport();
    //     }, 1000);
    //   }
    // });
    Swal.fire({
      title: 'Alert',
      text: `Coming soon!`,
      showDenyButton: false,
      showCancelButton: false,
    });
    return;
    this.paymentMonth = item.date;
    if (item.paymentDate) {
      this.paymentDate = new Date(item.paymentDate);
    } else {
      this.paymentDate = new Date();
    }
    this.paymentAmountPaid = item.amountPaid;
    $('#payment-modal').modal('show');
  }

  getReports(reportType, isMonthRange, start, end, allies: number[]) {
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(
        `${
          environment.reportApiUrl
        }/report/reports?reportType=${reportType}&isMonthRange=${isMonthRange}&start=${start}&end=${end}&allies=${JSON.stringify(
          allies
        )}`,
        {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        }
      )
      .subscribe({
        next: (res: any) => {
          $('#DataTables_Table_1').dataTable().fnDestroy();
          this.data = res;
          this.dtTrigger.next(null);
        },
        error: (error) => {
          console.log(error);
        },
      });
  }


  getReportsForArrears(reportType, isMonthRange, start, end, allies){
    var accessToken = sessionStorage.getItem('accessToken');
    const data:any = {
    "status": 200,
    "error": "arrears fetched successfully",
    "message": "arrears fetched successfully",
    "date": "2025-05-22T11:48:43.923Z",
    "data": [
        {
            "id": 5084,
            "invoiceNumber": "25-05-0349",
            "customerId": 2973,
            "fusebillCustomerId": "13757999",
            "invoiceDate": "2025-04-30T18:30:00.000Z",
            "dueDate": "2025-04-30T18:30:00.000Z",
            "status": "OVERDUE",
            "invoiceAmount": 962.1,
            "paymentId": null,
            "paymentInfo": null,
            "invoiceHistory": null,
            "amountPaid": 0,
            "paymentFailureCount": null,
            "paymentDate": null,
            "paymentType": "CREDIT CARD",
            "paymentStatus": null,
            "reference": null,
            "created": "2025-05-02T05:10:20.000Z",
            "modified": "2025-05-22T02:45:41.000Z",
            "taxInformation": {
                "overall_taxes": {
                    "Total": 71.26,
                    "PST on Health Insurance": 71.26
                },
                "individual_taxes": {
                    "2973": {
                        "plans": {
                            "taxes": []
                        },
                        "lastName": "Green",
                        "firstName": "Lindy",
                        "customerId": 2973,
                        "staxbillId": "13757999"
                    },
                    "2985": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 8131,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 35.63,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 35.63,
                                    "scope": null,
                                    "total": 35.63,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2025-03-28 21:55:28",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "version": 43,
                                    "coverage": "SINGLE",
                                    "modified": null,
                                    "parentId": "2973",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 35.63,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2985,
                                    "grandTotal": 35.63,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2985\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838737, \"isSubscriptionTax\": true}",
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2025-03-28",
                                    "taxForPlan": 0,
                                    "totalPrice": 35.63,
                                    "createdDate": "2025-03-28 21:55:28",
                                    "customer_id": 2985,
                                    "enrolledDate": "2025-04-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2025-04-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6838737",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (60 to 74)"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 6260,
                                            "price": 35.63,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 8131,
                                            "customer_plan_id": 8131
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Chaiton",
                        "firstName": "Sam",
                        "customerId": 2985,
                        "staxbillId": "13760705"
                    },
                    "2986": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 8133,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 35.63,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 35.63,
                                    "scope": null,
                                    "total": 35.63,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2025-03-28 22:16:48",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "version": 43,
                                    "coverage": "SINGLE",
                                    "modified": null,
                                    "parentId": "2973",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 35.63,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2986,
                                    "grandTotal": 35.63,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2986\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838755, \"isSubscriptionTax\": true}",
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2025-03-28",
                                    "taxForPlan": 0,
                                    "totalPrice": 35.63,
                                    "createdDate": "2025-03-28 22:16:48",
                                    "customer_id": 2986,
                                    "enrolledDate": "2025-04-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2025-04-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6838755",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (60 to 74)"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 6262,
                                            "price": 35.63,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 8133,
                                            "customer_plan_id": 8133
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Green",
                        "firstName": "Lindy",
                        "customerId": 2986,
                        "staxbillId": "13760755"
                    }
                }
            },
            "contactInformation": {
                "state": "ON",
                "stateId": 12,
                "workingProvince": "ON",
                "workingProvinceId": 12
            },
            "planInformation": {
                "2973": {
                    "plans": {
                        "subscriptions": []
                    },
                    "lastName": "Green",
                    "firstName": "Lindy",
                    "customerId": 2973,
                    "staxbillId": "13757999"
                },
                "2985": {
                    "plans": {
                        "subscriptions": [
                            {
                                "id": 8132,
                                "gst": null,
                                "hst": null,
                                "pst": 35.63,
                                "qst": null,
                                "tax": 35.63,
                                "misc": "{\"name\": \"Complete Executive Care (60 to 74) (Ontario) \", \"coverage\": \"SINGLE\", \"description\": \"Health Insurance 13760705 2985 PST on Health Insurance (#709505879) 8.00% $35.63 \"}",
                                "name": "Complete Executive Care (60 to 74)",
                                "type": "100% Company Paid",
                                "count": 1,
                                "price": 445.42,
                                "scope": null,
                                "total": 481.05,
                                "isBulk": false,
                                "planId": 773,
                                "status": "Active",
                                "tierId": null,
                                "created": "2025-03-28 21:55:29",
                                "plan_id": 773,
                                "stateId": 12,
                                "summary": null,
                                "taxCode": null,
                                "taxName": "PST ON HEALTH INSURANCE",
                                "version": 43,
                                "coverage": "SINGLE",
                                "modified": "2025-03-28 21:55:29",
                                "parentId": "2973",
                                "planCode": "completeexecutivecare60to74",
                                "planName": "Complete Executive Care (60 to 74)",
                                "quantity": 1,
                                "taxPrice": 35.63,
                                "totalTax": 35.63,
                                "coverage1": "Single",
                                "packageId": 5,
                                "customerId": 2985,
                                "grandTotal": 481.05,
                                "gstTaxRate": null,
                                "hstTaxRate": null,
                                "planObject": "{\"id\": 773, \"gst\": null, \"hst\": null, \"pst\": 35.63, \"qst\": 0, \"tax\": \"35.63\", \"name\": \"Complete Executive Care (60 to 74)\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"481.05\", \"amount\": \"445.42\", \"amounts\": {\"total\": 445.42, \"company\": 445.42, \"employee\": 0}, \"details\": \"Private Health\", \"options\": [], \"taxName\": \"PST ON HEALTH INSURANCE\", \"totalUI\": \"$481.05\", \"version\": 43, \"amountUI\": \"$445.42\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Complete Executive Care (60 to 74)\", \"products\": [{\"id\": 32228, \"tax\": 35.63, \"name\": \"Complete Executive Care (60 to 74)\", \"price\": 445.42, \"total\": 481.05, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 18, \"productId\": 7, \"description\": \" Single\", \"tax_details\": [{\"plan_id\": 765, \"tax_sku\": \"pstonhealthinsurance\", \"tax_code\": null, \"tax_name\": \"PST ON HEALTH INSURANCE\", \"tax_rate\": 0.08, \"plan_product_id\": 178475, \"tax_description\": \"PST on Health Insurance (#709505879)\", \"business_tax_number\": \"709505879\"}], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 35.63, \"price\": 445.42, \"total\": 481.05, \"planProductIds\": [178475], \"planProductInfos\": [{\"name\": \"PST ON HEALTH INSURANCE\", \"price\": 35.63, \"taxRate\": 0.08, \"isIncluded\": true, \"description\": \"PST on Health Insurance (#709505879)\", \"taxRatePercentage\": \"8.00%\", \"planProductUniqueId\": 178475}]}, \"planProductId\": \"183848\", \"bundledProducts\": [\"Single\"], \"planLevelParent\": 15}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": 35.63, \"groupName\": \"Complete Executive Care\", \"packageId\": 5, \"planLevel\": 18, \"planPrice\": 445.42, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"totalPrice\": \"481.05\", \"description\": \"Health Insurance\", \"packagename\": \"Private Health\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 445.42, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Complete Executive Care\", \"skuTotalPrice\": 481.05, \"taxApplicable\": true, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49875, \"paidByCompany1\": \"32228\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$445.42\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107062, \"planLevelParent\": 15, \"planproductname\": \"Complete Executive Care (60 to 74)\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"18\", \"planLevel_parentId\": \"15\", \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8.00% $35.63 \", \"disallowedPlanLevels\": \"17,23,26,31,46\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                "pstTaxRate": 8,
                                "qstTaxRate": null,
                                "signupDate": "2025-03-28",
                                "taxDetails": {
                                    "tax": 35.63,
                                    "price": 445.42,
                                    "total": 481.05,
                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $35.63 "
                                },
                                "taxForPlan": 35.63,
                                "totalPrice": 445.42,
                                "createdDate": "2025-03-28 21:55:29",
                                "customer_id": 2985,
                                "enrolledDate": "2025-04-01",
                                "taxDetailsDB": {
                                    "gst": "0.00",
                                    "hst": "0.00",
                                    "pst": "35.63",
                                    "tax": "35.63",
                                    "price": "445.42",
                                    "total": "481.05",
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "taxPrice": "35.63",
                                    "gstTaxRate": "0.00",
                                    "hstTaxRate": "0.00",
                                    "pstTaxRate": "8.00",
                                    "taxDescriptionLine": "PST on Health Insurance 8% $35.63"
                                },
                                "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                "bulkPlanLevel": null,
                                "paidByCompany": 1,
                                "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                "activationDate": "2025-04-01 04:00:00",
                                "paidByEmployee": null,
                                "subscriptionId": "6838738",
                                "workingStateId": 12,
                                "bundledProducts": [
                                    "Complete Executive Care (60 to 74)"
                                ],
                                "lastBillingDate": null,
                                "nextBillingDate": null,
                                "terminationDate": null,
                                "cancellationDate": null,
                                "coveredByCompany": null,
                                "nextBillingPrice": null,
                                "restrictedAccess": null,
                                "isSubscriptionTax": false,
                                "reinstatementDate": null,
                                "taxSubscriptionId": "6838737",
                                "terminationReason": null,
                                "reinstatementReason": null,
                                "tax_subscription_id": 6838737,
                                "aitestproExecutionId": null,
                                "customerPlanProducts": [
                                    {
                                        "id": 6261,
                                        "price": 445.42,
                                        "taxSku": null,
                                        "product": {
                                            "id": 7,
                                            "code": "single",
                                            "data": "{\"additional_instructions\": []}",
                                            "logo": null,
                                            "name": "Single",
                                            "color": null,
                                            "price": 7.25,
                                            "glCode": "53211",
                                            "display": "TITLE",
                                            "published": true,
                                            "fusebillId": "126196",
                                            "backgroundColor": "#212A3E",
                                            "includedProducts": null
                                        },
                                        "taxCode": null,
                                        "taxName": null,
                                        "version": 43,
                                        "productId": 7,
                                        "product_id": 7,
                                        "planCoverage": "SINGLE",
                                        "customerPlanId": 8132,
                                        "customer_plan_id": 8132
                                    }
                                ],
                                "backdatedActivationDate": null,
                                "backdatedCancellationDate": null
                            }
                        ]
                    },
                    "lastName": "Chaiton",
                    "firstName": "Sam",
                    "customerId": 2985,
                    "staxbillId": "13760705"
                },
                "2986": {
                    "plans": {
                        "subscriptions": [
                            {
                                "id": 8134,
                                "gst": null,
                                "hst": null,
                                "pst": 35.63,
                                "qst": null,
                                "tax": 35.63,
                                "misc": "{\"name\": \"Complete Executive Care (60 to 74) (Ontario) \", \"coverage\": \"SINGLE\", \"description\": \"Health Insurance 13760755 2986 PST on Health Insurance (#709505879) 8.00% $35.63 \"}",
                                "name": "Complete Executive Care (60 to 74)",
                                "type": "100% Company Paid",
                                "count": 1,
                                "price": 445.42,
                                "scope": null,
                                "total": 481.05,
                                "isBulk": false,
                                "planId": 773,
                                "status": "Active",
                                "tierId": null,
                                "created": "2025-03-28 22:16:48",
                                "plan_id": 773,
                                "stateId": 12,
                                "summary": null,
                                "taxCode": null,
                                "taxName": "PST ON HEALTH INSURANCE",
                                "version": 43,
                                "coverage": "SINGLE",
                                "modified": "2025-03-28 22:16:48",
                                "parentId": "2973",
                                "planCode": "completeexecutivecare60to74",
                                "planName": "Complete Executive Care (60 to 74)",
                                "quantity": 1,
                                "taxPrice": 35.63,
                                "totalTax": 35.63,
                                "coverage1": "Single",
                                "packageId": 5,
                                "customerId": 2986,
                                "grandTotal": 481.05,
                                "gstTaxRate": null,
                                "hstTaxRate": null,
                                "planObject": "{\"id\": 773, \"gst\": null, \"hst\": null, \"pst\": 35.63, \"qst\": 0, \"tax\": \"35.63\", \"name\": \"Complete Executive Care (60 to 74)\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"481.05\", \"amount\": \"445.42\", \"amounts\": {\"total\": 445.42, \"company\": 445.42, \"employee\": 0}, \"details\": \"Private Health\", \"options\": [], \"taxName\": \"PST ON HEALTH INSURANCE\", \"totalUI\": \"$481.05\", \"version\": 43, \"amountUI\": \"$445.42\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Complete Executive Care (60 to 74)\", \"products\": [{\"id\": 32228, \"tax\": 35.63, \"name\": \"Complete Executive Care (60 to 74)\", \"price\": 445.42, \"total\": 481.05, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 18, \"productId\": 7, \"description\": \" Single\", \"tax_details\": [{\"plan_id\": 765, \"tax_sku\": \"pstonhealthinsurance\", \"tax_code\": null, \"tax_name\": \"PST ON HEALTH INSURANCE\", \"tax_rate\": 0.08, \"plan_product_id\": 178475, \"tax_description\": \"PST on Health Insurance (#709505879)\", \"business_tax_number\": \"709505879\"}], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 35.63, \"price\": 445.42, \"total\": 481.05, \"planProductIds\": [178475], \"planProductInfos\": [{\"name\": \"PST ON HEALTH INSURANCE\", \"price\": 35.63, \"taxRate\": 0.08, \"isIncluded\": true, \"description\": \"PST on Health Insurance (#709505879)\", \"taxRatePercentage\": \"8.00%\", \"planProductUniqueId\": 178475}]}, \"planProductId\": \"183848\", \"bundledProducts\": [\"Single\"], \"planLevelParent\": 15}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": 35.63, \"groupName\": \"Complete Executive Care\", \"packageId\": 5, \"planLevel\": 18, \"planPrice\": 445.42, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"totalPrice\": \"481.05\", \"description\": \"Health Insurance\", \"packagename\": \"Private Health\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 445.42, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Complete Executive Care\", \"skuTotalPrice\": 481.05, \"taxApplicable\": true, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49875, \"paidByCompany1\": \"32228\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$445.42\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107062, \"planLevelParent\": 15, \"planproductname\": \"Complete Executive Care (60 to 74)\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"18\", \"planLevel_parentId\": \"15\", \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8.00% $35.63 \", \"disallowedPlanLevels\": \"17,23,26,31,46\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                "pstTaxRate": 8,
                                "qstTaxRate": null,
                                "signupDate": "2025-03-28",
                                "taxDetails": {
                                    "tax": 35.63,
                                    "price": 445.42,
                                    "total": 481.05,
                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $35.63 "
                                },
                                "taxForPlan": 35.63,
                                "totalPrice": 445.42,
                                "createdDate": "2025-03-28 22:16:48",
                                "customer_id": 2986,
                                "enrolledDate": "2025-04-01",
                                "taxDetailsDB": {
                                    "gst": "0.00",
                                    "hst": "0.00",
                                    "pst": "35.63",
                                    "tax": "35.63",
                                    "price": "445.42",
                                    "total": "481.05",
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "taxPrice": "35.63",
                                    "gstTaxRate": "0.00",
                                    "hstTaxRate": "0.00",
                                    "pstTaxRate": "8.00",
                                    "taxDescriptionLine": "PST on Health Insurance 8% $35.63"
                                },
                                "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                "bulkPlanLevel": null,
                                "paidByCompany": 1,
                                "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                "activationDate": "2025-04-01 04:00:00",
                                "paidByEmployee": null,
                                "subscriptionId": "6838756",
                                "workingStateId": 12,
                                "bundledProducts": [
                                    "Complete Executive Care (60 to 74)"
                                ],
                                "lastBillingDate": null,
                                "nextBillingDate": null,
                                "terminationDate": null,
                                "cancellationDate": null,
                                "coveredByCompany": null,
                                "nextBillingPrice": null,
                                "restrictedAccess": null,
                                "isSubscriptionTax": false,
                                "reinstatementDate": null,
                                "taxSubscriptionId": "6838755",
                                "terminationReason": null,
                                "reinstatementReason": null,
                                "tax_subscription_id": 6838755,
                                "aitestproExecutionId": null,
                                "customerPlanProducts": [
                                    {
                                        "id": 6263,
                                        "price": 445.42,
                                        "taxSku": null,
                                        "product": {
                                            "id": 7,
                                            "code": "single",
                                            "data": "{\"additional_instructions\": []}",
                                            "logo": null,
                                            "name": "Single",
                                            "color": null,
                                            "price": 7.25,
                                            "glCode": "53211",
                                            "display": "TITLE",
                                            "published": true,
                                            "fusebillId": "126196",
                                            "backgroundColor": "#212A3E",
                                            "includedProducts": null
                                        },
                                        "taxCode": null,
                                        "taxName": null,
                                        "version": 43,
                                        "productId": 7,
                                        "product_id": 7,
                                        "planCoverage": "SINGLE",
                                        "customerPlanId": 8134,
                                        "customer_plan_id": 8134
                                    }
                                ],
                                "backdatedActivationDate": null,
                                "backdatedCancellationDate": null
                            }
                        ]
                    },
                    "lastName": "Green",
                    "firstName": "Lindy",
                    "customerId": 2986,
                    "staxbillId": "13760755"
                }
            },
            "invoiceObject": {
                "id": 2973,
                "logo": "https://api-admin.groupbenefitz.net/api/ap/app/resources/images/gb_logo_long.png",
                "note": "",
                "plans": {
                    "taxes": [],
                    "subscriptions": []
                },
                "taxes": {
                    "PST on Health Insurance ON": 71.26
                },
                "total": 962.1,
                "credit": 0,
                "status": "Active",
                "address": {
                    "id": 8215,
                    "apt": "",
                    "city": "Toronto",
                    "line1": "C/o Fruitman Kates LLP,  1055 Eglinton Ave West",
                    "line2": "",
                    "state": "ON",
                    "country": "Canada",
                    "stateId": 12,
                    "countryId": 1,
                    "fusebillId": null,
                    "postalCode": "M6C2C9",
                    "addressType": "OFFICE_ADDRESS",
                    "contactType": "COMPANY",
                    "primaryEmail": null,
                    "primaryPhone": null,
                    "secondaryEmail": null,
                    "secondaryPhone": null
                },
                "arrears": 962.1,
                "baMails": [],
                "ciMails": [],
                "version": "gb7.0.0",
                "fileName": "Invoice_13757999_2025-05-01_25-05-0349_POST",
                "filePath": "/var/www/vhosts/api-common.groupbenefitz.net/public/server/MemberInvoices/",
                "fontSize": "8",
                "lastName": "Green",
                "logoPath": "/var/www/vhosts/api-common.groupbenefitz.net/public/resources/images/gb_logo_long.png",
                "subtotal": 890.84,
                "firstName": "Lindy",
                "invoiceNo": "25-05-0349",
                "customerId": 2973,
                "staxbillId": "13757999",
                "accountType": "parent",
                "companyName": "Glowing Investments Inc.",
                "environment": "production",
                "generatePDF": true,
                "invoiceDate": "2025-05",
                "isCorporate": true,
                "paymentType": "CREDIT CARD",
                "employeeList": [
                    {
                        "id": 2985,
                        "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                        "email": "sam@bigitup.com",
                        "plans": {
                            "taxes": [
                                {
                                    "id": 8131,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 35.63,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 35.63,
                                    "scope": null,
                                    "total": 35.63,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2025-03-28 21:55:28",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "version": 43,
                                    "coverage": "SINGLE",
                                    "modified": null,
                                    "parentId": "2973",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 35.63,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2985,
                                    "grandTotal": 35.63,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2985\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838737, \"isSubscriptionTax\": true}",
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2025-03-28",
                                    "taxForPlan": 0,
                                    "totalPrice": 35.63,
                                    "createdDate": "2025-03-28 21:55:28",
                                    "customer_id": 2985,
                                    "enrolledDate": "2025-04-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2025-04-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6838737",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (60 to 74)"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 6260,
                                            "price": 35.63,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 8131,
                                            "customer_plan_id": 8131
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ],
                            "subscriptions": [
                                {
                                    "id": 8132,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 35.63,
                                    "qst": null,
                                    "tax": 35.63,
                                    "misc": "{\"name\": \"Complete Executive Care (60 to 74) (Ontario) \", \"coverage\": \"SINGLE\", \"description\": \"Health Insurance 13760705 2985 PST on Health Insurance (#709505879) 8.00% $35.63 \"}",
                                    "name": "Complete Executive Care (60 to 74)",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 445.42,
                                    "scope": null,
                                    "total": 481.05,
                                    "isBulk": false,
                                    "planId": 773,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2025-03-28 21:55:29",
                                    "plan_id": 773,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "version": 43,
                                    "coverage": "SINGLE",
                                    "modified": "2025-03-28 21:55:29",
                                    "parentId": "2973",
                                    "planCode": "completeexecutivecare60to74",
                                    "planName": "Complete Executive Care (60 to 74)",
                                    "quantity": 1,
                                    "taxPrice": 35.63,
                                    "totalTax": 35.63,
                                    "coverage1": "Single",
                                    "packageId": 5,
                                    "customerId": 2985,
                                    "grandTotal": 481.05,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": "{\"id\": 773, \"gst\": null, \"hst\": null, \"pst\": 35.63, \"qst\": 0, \"tax\": \"35.63\", \"name\": \"Complete Executive Care (60 to 74)\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"481.05\", \"amount\": \"445.42\", \"amounts\": {\"total\": 445.42, \"company\": 445.42, \"employee\": 0}, \"details\": \"Private Health\", \"options\": [], \"taxName\": \"PST ON HEALTH INSURANCE\", \"totalUI\": \"$481.05\", \"version\": 43, \"amountUI\": \"$445.42\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Complete Executive Care (60 to 74)\", \"products\": [{\"id\": 32228, \"tax\": 35.63, \"name\": \"Complete Executive Care (60 to 74)\", \"price\": 445.42, \"total\": 481.05, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 18, \"productId\": 7, \"description\": \" Single\", \"tax_details\": [{\"plan_id\": 765, \"tax_sku\": \"pstonhealthinsurance\", \"tax_code\": null, \"tax_name\": \"PST ON HEALTH INSURANCE\", \"tax_rate\": 0.08, \"plan_product_id\": 178475, \"tax_description\": \"PST on Health Insurance (#709505879)\", \"business_tax_number\": \"709505879\"}], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 35.63, \"price\": 445.42, \"total\": 481.05, \"planProductIds\": [178475], \"planProductInfos\": [{\"name\": \"PST ON HEALTH INSURANCE\", \"price\": 35.63, \"taxRate\": 0.08, \"isIncluded\": true, \"description\": \"PST on Health Insurance (#709505879)\", \"taxRatePercentage\": \"8.00%\", \"planProductUniqueId\": 178475}]}, \"planProductId\": \"183848\", \"bundledProducts\": [\"Single\"], \"planLevelParent\": 15}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": 35.63, \"groupName\": \"Complete Executive Care\", \"packageId\": 5, \"planLevel\": 18, \"planPrice\": 445.42, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"totalPrice\": \"481.05\", \"description\": \"Health Insurance\", \"packagename\": \"Private Health\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 445.42, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Complete Executive Care\", \"skuTotalPrice\": 481.05, \"taxApplicable\": true, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49875, \"paidByCompany1\": \"32228\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$445.42\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107062, \"planLevelParent\": 15, \"planproductname\": \"Complete Executive Care (60 to 74)\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"18\", \"planLevel_parentId\": \"15\", \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8.00% $35.63 \", \"disallowedPlanLevels\": \"17,23,26,31,46\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2025-03-28",
                                    "taxDetails": {
                                        "tax": 35.63,
                                        "price": 445.42,
                                        "total": 481.05,
                                        "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $35.63 "
                                    },
                                    "taxForPlan": 35.63,
                                    "totalPrice": 445.42,
                                    "createdDate": "2025-03-28 21:55:29",
                                    "customer_id": 2985,
                                    "enrolledDate": "2025-04-01",
                                    "taxDetailsDB": {
                                        "gst": "0.00",
                                        "hst": "0.00",
                                        "pst": "35.63",
                                        "tax": "35.63",
                                        "price": "445.42",
                                        "total": "481.05",
                                        "taxName": "PST ON HEALTH INSURANCE",
                                        "taxPrice": "35.63",
                                        "gstTaxRate": "0.00",
                                        "hstTaxRate": "0.00",
                                        "pstTaxRate": "8.00",
                                        "taxDescriptionLine": "PST on Health Insurance 8% $35.63"
                                    },
                                    "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                    "activationDate": "2025-04-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6838738",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (60 to 74)"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": false,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": "6838737",
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": 6838737,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 6261,
                                            "price": 445.42,
                                            "taxSku": null,
                                            "product": {
                                                "id": 7,
                                                "code": "single",
                                                "data": "{\"additional_instructions\": []}",
                                                "logo": null,
                                                "name": "Single",
                                                "color": null,
                                                "price": 7.25,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126196",
                                                "backgroundColor": "#212A3E",
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "productId": 7,
                                            "product_id": 7,
                                            "planCoverage": "SINGLE",
                                            "customerPlanId": 8132,
                                            "customer_plan_id": 8132
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "address": {
                            "id": 8245,
                            "apt": "107",
                            "city": "Toronto",
                            "line1": "385 Brunswick Avenue",
                            "line2": "",
                            "state": "ON",
                            "country": "Canada",
                            "stateId": 12,
                            "countryId": 1,
                            "fusebillId": null,
                            "postalCode": "M5R 3R1",
                            "addressType": "HOME_ADDRESS",
                            "contactType": "CUSTOMER",
                            "primaryEmail": "sam@bigitup.com",
                            "primaryPhone": "+1 (416) 828-5174",
                            "secondaryEmail": null,
                            "secondaryPhone": null
                        },
                        "lastName": "Chaiton",
                        "firstName": "Sam",
                        "customerId": 2985,
                        "staxbillId": "13760705",
                        "accountType": "child",
                        "companyName": "Glowing Investments Inc.",
                        "isCorporate": true,
                        "paymentType": "CREDIT CARD",
                        "employerName": "",
                        "pastInvoices": [],
                        "invoiceAmount": 481.05,
                        "invoiceAmountEP": 0,
                        "workingProvince": "Ontario",
                        "workingProvinceId": 12
                    },
                    {
                        "id": 2986,
                        "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                        "email": "lindygreen57@gmail.com",
                        "plans": {
                            "taxes": [
                                {
                                    "id": 8133,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 35.63,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 35.63,
                                    "scope": null,
                                    "total": 35.63,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2025-03-28 22:16:48",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "version": 43,
                                    "coverage": "SINGLE",
                                    "modified": null,
                                    "parentId": "2973",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 35.63,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2986,
                                    "grandTotal": 35.63,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2986\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838755, \"isSubscriptionTax\": true}",
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2025-03-28",
                                    "taxForPlan": 0,
                                    "totalPrice": 35.63,
                                    "createdDate": "2025-03-28 22:16:48",
                                    "customer_id": 2986,
                                    "enrolledDate": "2025-04-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2025-04-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6838755",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (60 to 74)"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 6262,
                                            "price": 35.63,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 8133,
                                            "customer_plan_id": 8133
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ],
                            "subscriptions": [
                                {
                                    "id": 8134,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 35.63,
                                    "qst": null,
                                    "tax": 35.63,
                                    "misc": "{\"name\": \"Complete Executive Care (60 to 74) (Ontario) \", \"coverage\": \"SINGLE\", \"description\": \"Health Insurance 13760755 2986 PST on Health Insurance (#709505879) 8.00% $35.63 \"}",
                                    "name": "Complete Executive Care (60 to 74)",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 445.42,
                                    "scope": null,
                                    "total": 481.05,
                                    "isBulk": false,
                                    "planId": 773,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2025-03-28 22:16:48",
                                    "plan_id": 773,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "version": 43,
                                    "coverage": "SINGLE",
                                    "modified": "2025-03-28 22:16:48",
                                    "parentId": "2973",
                                    "planCode": "completeexecutivecare60to74",
                                    "planName": "Complete Executive Care (60 to 74)",
                                    "quantity": 1,
                                    "taxPrice": 35.63,
                                    "totalTax": 35.63,
                                    "coverage1": "Single",
                                    "packageId": 5,
                                    "customerId": 2986,
                                    "grandTotal": 481.05,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": "{\"id\": 773, \"gst\": null, \"hst\": null, \"pst\": 35.63, \"qst\": 0, \"tax\": \"35.63\", \"name\": \"Complete Executive Care (60 to 74)\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"481.05\", \"amount\": \"445.42\", \"amounts\": {\"total\": 445.42, \"company\": 445.42, \"employee\": 0}, \"details\": \"Private Health\", \"options\": [], \"taxName\": \"PST ON HEALTH INSURANCE\", \"totalUI\": \"$481.05\", \"version\": 43, \"amountUI\": \"$445.42\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Complete Executive Care (60 to 74)\", \"products\": [{\"id\": 32228, \"tax\": 35.63, \"name\": \"Complete Executive Care (60 to 74)\", \"price\": 445.42, \"total\": 481.05, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 18, \"productId\": 7, \"description\": \" Single\", \"tax_details\": [{\"plan_id\": 765, \"tax_sku\": \"pstonhealthinsurance\", \"tax_code\": null, \"tax_name\": \"PST ON HEALTH INSURANCE\", \"tax_rate\": 0.08, \"plan_product_id\": 178475, \"tax_description\": \"PST on Health Insurance (#709505879)\", \"business_tax_number\": \"709505879\"}], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 35.63, \"price\": 445.42, \"total\": 481.05, \"planProductIds\": [178475], \"planProductInfos\": [{\"name\": \"PST ON HEALTH INSURANCE\", \"price\": 35.63, \"taxRate\": 0.08, \"isIncluded\": true, \"description\": \"PST on Health Insurance (#709505879)\", \"taxRatePercentage\": \"8.00%\", \"planProductUniqueId\": 178475}]}, \"planProductId\": \"183848\", \"bundledProducts\": [\"Single\"], \"planLevelParent\": 15}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": 35.63, \"groupName\": \"Complete Executive Care\", \"packageId\": 5, \"planLevel\": 18, \"planPrice\": 445.42, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"totalPrice\": \"481.05\", \"description\": \"Health Insurance\", \"packagename\": \"Private Health\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 445.42, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Complete Executive Care\", \"skuTotalPrice\": 481.05, \"taxApplicable\": true, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49875, \"paidByCompany1\": \"32228\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$445.42\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107062, \"planLevelParent\": 15, \"planproductname\": \"Complete Executive Care (60 to 74)\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"18\", \"planLevel_parentId\": \"15\", \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8.00% $35.63 \", \"disallowedPlanLevels\": \"17,23,26,31,46\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2025-03-28",
                                    "taxDetails": {
                                        "tax": 35.63,
                                        "price": 445.42,
                                        "total": 481.05,
                                        "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $35.63 "
                                    },
                                    "taxForPlan": 35.63,
                                    "totalPrice": 445.42,
                                    "createdDate": "2025-03-28 22:16:48",
                                    "customer_id": 2986,
                                    "enrolledDate": "2025-04-01",
                                    "taxDetailsDB": {
                                        "gst": "0.00",
                                        "hst": "0.00",
                                        "pst": "35.63",
                                        "tax": "35.63",
                                        "price": "445.42",
                                        "total": "481.05",
                                        "taxName": "PST ON HEALTH INSURANCE",
                                        "taxPrice": "35.63",
                                        "gstTaxRate": "0.00",
                                        "hstTaxRate": "0.00",
                                        "pstTaxRate": "8.00",
                                        "taxDescriptionLine": "PST on Health Insurance 8% $35.63"
                                    },
                                    "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                    "activationDate": "2025-04-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6838756",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (60 to 74)"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": false,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": "6838755",
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": 6838755,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 6263,
                                            "price": 445.42,
                                            "taxSku": null,
                                            "product": {
                                                "id": 7,
                                                "code": "single",
                                                "data": "{\"additional_instructions\": []}",
                                                "logo": null,
                                                "name": "Single",
                                                "color": null,
                                                "price": 7.25,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126196",
                                                "backgroundColor": "#212A3E",
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "productId": 7,
                                            "product_id": 7,
                                            "planCoverage": "SINGLE",
                                            "customerPlanId": 8134,
                                            "customer_plan_id": 8134
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "address": {
                            "id": 8248,
                            "apt": "Unit 107",
                            "city": "Toronto",
                            "line1": "385 Brunswick Avenue",
                            "line2": "",
                            "state": "ON",
                            "country": "Canada",
                            "stateId": 12,
                            "countryId": 1,
                            "fusebillId": null,
                            "postalCode": "M5R 3R1",
                            "addressType": "HOME_ADDRESS",
                            "contactType": "CUSTOMER",
                            "primaryEmail": "lindygreen57@gmail.com",
                            "primaryPhone": "+1 (647) 299-8089",
                            "secondaryEmail": null,
                            "secondaryPhone": null
                        },
                        "lastName": "Green",
                        "firstName": "Lindy",
                        "customerId": 2986,
                        "staxbillId": "13760755",
                        "accountType": "child",
                        "companyName": "Glowing Investments Inc.",
                        "isCorporate": true,
                        "paymentType": "CREDIT CARD",
                        "employerName": "",
                        "pastInvoices": [],
                        "invoiceAmount": 481.05,
                        "invoiceAmountEP": 0,
                        "workingProvince": "Ontario",
                        "workingProvinceId": 12
                    }
                ],
                "employerName": "",
                "invoiceDate2": "2025-05-01",
                "pastInvoices": [
                    {
                        "id": 4638,
                        "status": "OVERDUE",
                        "created": "2025-04-04 13:17:43",
                        "dueDate": "2025-04-01",
                        "modified": "2025-05-01 12:32:10",
                        "paymentId": null,
                        "reference": null,
                        "amountPaid": null,
                        "customerId": 2973,
                        "customer_id": 2973,
                        "invoiceDate": "2025-04-01",
                        "paymentDate": null,
                        "paymentInfo": null,
                        "paymentType": "CREDIT CARD",
                        "invoiceAmount": 962.1,
                        "invoiceNumber": "25-04-2939",
                        "invoiceObject": {
                            "id": 2973,
                            "logo": "https://api-admin.groupbenefitz.net/api/ap/app/resources/images/gb_logo_long.png",
                            "note": "",
                            "plans": {
                                "taxes": [],
                                "subscriptions": []
                            },
                            "taxes": {
                                "PST on Health Insurance ON": 71.26
                            },
                            "total": 962.1,
                            "credit": 0,
                            "status": "Active",
                            "address": {
                                "id": 8215,
                                "apt": "",
                                "city": "Toronto",
                                "line1": "C/o Fruitman Kates LLP,  1055 Eglinton Ave West",
                                "line2": "",
                                "state": "ON",
                                "country": "Canada",
                                "stateId": 12,
                                "countryId": 1,
                                "fusebillId": null,
                                "postalCode": "M6C2C9",
                                "addressType": "OFFICE_ADDRESS",
                                "contactType": "COMPANY",
                                "primaryEmail": null,
                                "primaryPhone": null,
                                "secondaryEmail": null,
                                "secondaryPhone": null
                            },
                            "arrears": 0,
                            "baMails": [],
                            "ciMails": [],
                            "version": "gb7.0.0",
                            "fileName": "Invoice_13757999_2025-04-01_25-04-2939_POST",
                            "filePath": "/var/www/vhosts/api-common.groupbenefitz.net/public/server/MemberInvoices/",
                            "fontSize": "8",
                            "lastName": "Green",
                            "logoPath": "/var/www/vhosts/api-common.groupbenefitz.net/public/resources/images/gb_logo_long.png",
                            "subtotal": 890.84,
                            "firstName": "Lindy",
                            "invoiceNo": "25-04-2939",
                            "customerId": 2973,
                            "staxbillId": "13757999",
                            "accountType": "parent",
                            "companyName": "Glowing Investments Inc.",
                            "environment": "production",
                            "generatePDF": true,
                            "invoiceDate": "2025-04",
                            "isCorporate": true,
                            "paymentType": "CREDIT CARD",
                            "employeeList": [
                                {
                                    "id": 2985,
                                    "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                    "email": "sam@bigitup.com",
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 8131,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 35.63,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 35.63,
                                                "scope": null,
                                                "total": 35.63,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2025-03-28 21:55:28",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "version": 43,
                                                "coverage": "SINGLE",
                                                "modified": null,
                                                "parentId": "2973",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 35.63,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2985,
                                                "grandTotal": 35.63,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2985\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838737, \"isSubscriptionTax\": true}",
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2025-03-28",
                                                "taxForPlan": 0,
                                                "totalPrice": 35.63,
                                                "createdDate": "2025-03-28 21:55:28",
                                                "customer_id": 2985,
                                                "enrolledDate": "2025-04-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2025-04-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6838737",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (60 to 74)"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 6260,
                                                        "price": 35.63,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": 43,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 8131,
                                                        "customer_plan_id": 8131
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ],
                                        "subscriptions": [
                                            {
                                                "id": 8132,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 35.63,
                                                "qst": null,
                                                "tax": 35.63,
                                                "misc": "{\"name\": \"Complete Executive Care (60 to 74) (Ontario) \", \"coverage\": \"SINGLE\", \"description\": \"Health Insurance 13760705 2985 PST on Health Insurance (#709505879) 8.00% $35.63 \"}",
                                                "name": "Complete Executive Care (60 to 74)",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 445.42,
                                                "scope": null,
                                                "total": 481.05,
                                                "isBulk": false,
                                                "planId": 773,
                                                "status": "Active",
                                                "created": "2025-03-28 21:55:29",
                                                "plan_id": 773,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "version": 43,
                                                "coverage": "SINGLE",
                                                "modified": "2025-03-28 21:55:29",
                                                "parentId": "2973",
                                                "planCode": "completeexecutivecare60to74",
                                                "planName": "Complete Executive Care (60 to 74)",
                                                "quantity": 1,
                                                "taxPrice": 35.63,
                                                "totalTax": 35.63,
                                                "coverage1": "Single",
                                                "packageId": 5,
                                                "customerId": 2985,
                                                "grandTotal": 481.05,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": "{\"id\": 773, \"gst\": null, \"hst\": null, \"pst\": 35.63, \"qst\": 0, \"tax\": \"35.63\", \"name\": \"Complete Executive Care (60 to 74)\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"481.05\", \"amount\": \"445.42\", \"amounts\": {\"total\": 445.42, \"company\": 445.42, \"employee\": 0}, \"details\": \"Private Health\", \"options\": [], \"taxName\": \"PST ON HEALTH INSURANCE\", \"totalUI\": \"$481.05\", \"version\": 43, \"amountUI\": \"$445.42\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Complete Executive Care (60 to 74)\", \"products\": [{\"id\": 32228, \"tax\": 35.63, \"name\": \"Complete Executive Care (60 to 74)\", \"price\": 445.42, \"total\": 481.05, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 18, \"productId\": 7, \"description\": \" Single\", \"tax_details\": [{\"plan_id\": 765, \"tax_sku\": \"pstonhealthinsurance\", \"tax_code\": null, \"tax_name\": \"PST ON HEALTH INSURANCE\", \"tax_rate\": 0.08, \"plan_product_id\": 178475, \"tax_description\": \"PST on Health Insurance (#709505879)\", \"business_tax_number\": \"709505879\"}], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 35.63, \"price\": 445.42, \"total\": 481.05, \"planProductIds\": [178475], \"planProductInfos\": [{\"name\": \"PST ON HEALTH INSURANCE\", \"price\": 35.63, \"taxRate\": 0.08, \"isIncluded\": true, \"description\": \"PST on Health Insurance (#709505879)\", \"taxRatePercentage\": \"8.00%\", \"planProductUniqueId\": 178475}]}, \"planProductId\": \"183848\", \"bundledProducts\": [\"Single\"], \"planLevelParent\": 15}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": 35.63, \"groupName\": \"Complete Executive Care\", \"packageId\": 5, \"planLevel\": 18, \"planPrice\": 445.42, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"totalPrice\": \"481.05\", \"description\": \"Health Insurance\", \"packagename\": \"Private Health\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 445.42, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Complete Executive Care\", \"skuTotalPrice\": 481.05, \"taxApplicable\": true, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49875, \"paidByCompany1\": \"32228\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$445.42\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107062, \"planLevelParent\": 15, \"planproductname\": \"Complete Executive Care (60 to 74)\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"18\", \"planLevel_parentId\": \"15\", \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8.00% $35.63 \", \"disallowedPlanLevels\": \"17,23,26,31,46\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2025-03-28",
                                                "taxDetails": {
                                                    "tax": 35.63,
                                                    "price": 445.42,
                                                    "total": 481.05,
                                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $35.63 "
                                                },
                                                "taxForPlan": 35.63,
                                                "totalPrice": 445.42,
                                                "createdDate": "2025-03-28 21:55:29",
                                                "customer_id": 2985,
                                                "enrolledDate": "2025-04-01",
                                                "taxDetailsDB": {
                                                    "gst": "0.00",
                                                    "hst": "0.00",
                                                    "pst": "35.63",
                                                    "tax": "35.63",
                                                    "price": "445.42",
                                                    "total": "481.05",
                                                    "taxName": "PST ON HEALTH INSURANCE",
                                                    "taxPrice": "35.63",
                                                    "gstTaxRate": "0.00",
                                                    "hstTaxRate": "0.00",
                                                    "pstTaxRate": "8.00",
                                                    "taxDescriptionLine": "PST on Health Insurance 8% $35.63"
                                                },
                                                "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                                "activationDate": "2025-04-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6838738",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (60 to 74)"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": false,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": "6838737",
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": 6838737,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 6261,
                                                        "price": 445.42,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 7,
                                                            "code": "single",
                                                            "data": "{\"additional_instructions\": []}",
                                                            "logo": null,
                                                            "name": "Single",
                                                            "color": null,
                                                            "price": 7.25,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126196",
                                                            "backgroundColor": "#212A3E",
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": 43,
                                                        "productId": 7,
                                                        "product_id": 7,
                                                        "planCoverage": "SINGLE",
                                                        "customerPlanId": 8132,
                                                        "customer_plan_id": 8132
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "address": {
                                        "id": 8245,
                                        "apt": "107",
                                        "city": "Toronto",
                                        "line1": "385 Brunswick Avenue",
                                        "line2": "",
                                        "state": "ON",
                                        "country": "Canada",
                                        "stateId": 12,
                                        "countryId": 1,
                                        "fusebillId": null,
                                        "postalCode": "M5R 3R1",
                                        "addressType": "HOME_ADDRESS",
                                        "contactType": "CUSTOMER",
                                        "primaryEmail": "sam@bigitup.com",
                                        "primaryPhone": "+1 (416) 828-5174",
                                        "secondaryEmail": null,
                                        "secondaryPhone": null
                                    },
                                    "lastName": "Chaiton",
                                    "firstName": "Sam",
                                    "customerId": 2985,
                                    "staxbillId": "13760705",
                                    "accountType": "child",
                                    "companyName": "Glowing Investments Inc.",
                                    "isCorporate": true,
                                    "paymentType": "CREDIT CARD",
                                    "employerName": "",
                                    "pastInvoices": [],
                                    "invoiceAmount": 481.05,
                                    "invoiceAmountEP": 0,
                                    "workingProvince": "Ontario",
                                    "workingProvinceId": 12
                                },
                                {
                                    "id": 2986,
                                    "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                    "email": "lindygreen57@gmail.com",
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 8133,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 35.63,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 35.63,
                                                "scope": null,
                                                "total": 35.63,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2025-03-28 22:16:48",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "version": 43,
                                                "coverage": "SINGLE",
                                                "modified": null,
                                                "parentId": "2973",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 35.63,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2986,
                                                "grandTotal": 35.63,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2986\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838755, \"isSubscriptionTax\": true}",
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2025-03-28",
                                                "taxForPlan": 0,
                                                "totalPrice": 35.63,
                                                "createdDate": "2025-03-28 22:16:48",
                                                "customer_id": 2986,
                                                "enrolledDate": "2025-04-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2025-04-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6838755",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (60 to 74)"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 6262,
                                                        "price": 35.63,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": 43,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 8133,
                                                        "customer_plan_id": 8133
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ],
                                        "subscriptions": [
                                            {
                                                "id": 8134,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 35.63,
                                                "qst": null,
                                                "tax": 35.63,
                                                "misc": "{\"name\": \"Complete Executive Care (60 to 74) (Ontario) \", \"coverage\": \"SINGLE\", \"description\": \"Health Insurance 13760755 2986 PST on Health Insurance (#709505879) 8.00% $35.63 \"}",
                                                "name": "Complete Executive Care (60 to 74)",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 445.42,
                                                "scope": null,
                                                "total": 481.05,
                                                "isBulk": false,
                                                "planId": 773,
                                                "status": "Active",
                                                "created": "2025-03-28 22:16:48",
                                                "plan_id": 773,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "version": 43,
                                                "coverage": "SINGLE",
                                                "modified": "2025-03-28 22:16:48",
                                                "parentId": "2973",
                                                "planCode": "completeexecutivecare60to74",
                                                "planName": "Complete Executive Care (60 to 74)",
                                                "quantity": 1,
                                                "taxPrice": 35.63,
                                                "totalTax": 35.63,
                                                "coverage1": "Single",
                                                "packageId": 5,
                                                "customerId": 2986,
                                                "grandTotal": 481.05,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": "{\"id\": 773, \"gst\": null, \"hst\": null, \"pst\": 35.63, \"qst\": 0, \"tax\": \"35.63\", \"name\": \"Complete Executive Care (60 to 74)\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"481.05\", \"amount\": \"445.42\", \"amounts\": {\"total\": 445.42, \"company\": 445.42, \"employee\": 0}, \"details\": \"Private Health\", \"options\": [], \"taxName\": \"PST ON HEALTH INSURANCE\", \"totalUI\": \"$481.05\", \"version\": 43, \"amountUI\": \"$445.42\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Complete Executive Care (60 to 74)\", \"products\": [{\"id\": 32228, \"tax\": 35.63, \"name\": \"Complete Executive Care (60 to 74)\", \"price\": 445.42, \"total\": 481.05, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 18, \"productId\": 7, \"description\": \" Single\", \"tax_details\": [{\"plan_id\": 765, \"tax_sku\": \"pstonhealthinsurance\", \"tax_code\": null, \"tax_name\": \"PST ON HEALTH INSURANCE\", \"tax_rate\": 0.08, \"plan_product_id\": 178475, \"tax_description\": \"PST on Health Insurance (#709505879)\", \"business_tax_number\": \"709505879\"}], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 35.63, \"price\": 445.42, \"total\": 481.05, \"planProductIds\": [178475], \"planProductInfos\": [{\"name\": \"PST ON HEALTH INSURANCE\", \"price\": 35.63, \"taxRate\": 0.08, \"isIncluded\": true, \"description\": \"PST on Health Insurance (#709505879)\", \"taxRatePercentage\": \"8.00%\", \"planProductUniqueId\": 178475}]}, \"planProductId\": \"183848\", \"bundledProducts\": [\"Single\"], \"planLevelParent\": 15}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": 35.63, \"groupName\": \"Complete Executive Care\", \"packageId\": 5, \"planLevel\": 18, \"planPrice\": 445.42, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"totalPrice\": \"481.05\", \"description\": \"Health Insurance\", \"packagename\": \"Private Health\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 445.42, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Complete Executive Care\", \"skuTotalPrice\": 481.05, \"taxApplicable\": true, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49875, \"paidByCompany1\": \"32228\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$445.42\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107062, \"planLevelParent\": 15, \"planproductname\": \"Complete Executive Care (60 to 74)\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"18\", \"planLevel_parentId\": \"15\", \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8.00% $35.63 \", \"disallowedPlanLevels\": \"17,23,26,31,46\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2025-03-28",
                                                "taxDetails": {
                                                    "tax": 35.63,
                                                    "price": 445.42,
                                                    "total": 481.05,
                                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $35.63 "
                                                },
                                                "taxForPlan": 35.63,
                                                "totalPrice": 445.42,
                                                "createdDate": "2025-03-28 22:16:48",
                                                "customer_id": 2986,
                                                "enrolledDate": "2025-04-01",
                                                "taxDetailsDB": {
                                                    "gst": "0.00",
                                                    "hst": "0.00",
                                                    "pst": "35.63",
                                                    "tax": "35.63",
                                                    "price": "445.42",
                                                    "total": "481.05",
                                                    "taxName": "PST ON HEALTH INSURANCE",
                                                    "taxPrice": "35.63",
                                                    "gstTaxRate": "0.00",
                                                    "hstTaxRate": "0.00",
                                                    "pstTaxRate": "8.00",
                                                    "taxDescriptionLine": "PST on Health Insurance 8% $35.63"
                                                },
                                                "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                                "activationDate": "2025-04-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6838756",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (60 to 74)"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": false,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": "6838755",
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": 6838755,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 6263,
                                                        "price": 445.42,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 7,
                                                            "code": "single",
                                                            "data": "{\"additional_instructions\": []}",
                                                            "logo": null,
                                                            "name": "Single",
                                                            "color": null,
                                                            "price": 7.25,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126196",
                                                            "backgroundColor": "#212A3E",
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": 43,
                                                        "productId": 7,
                                                        "product_id": 7,
                                                        "planCoverage": "SINGLE",
                                                        "customerPlanId": 8134,
                                                        "customer_plan_id": 8134
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "address": {
                                        "id": 8248,
                                        "apt": "Unit 107",
                                        "city": "Toronto",
                                        "line1": "385 Brunswick Avenue",
                                        "line2": "",
                                        "state": "ON",
                                        "country": "Canada",
                                        "stateId": 12,
                                        "countryId": 1,
                                        "fusebillId": null,
                                        "postalCode": "M5R 3R1",
                                        "addressType": "HOME_ADDRESS",
                                        "contactType": "CUSTOMER",
                                        "primaryEmail": "lindygreen57@gmail.com",
                                        "primaryPhone": "+1 (647) 299-8089",
                                        "secondaryEmail": null,
                                        "secondaryPhone": null
                                    },
                                    "lastName": "Green",
                                    "firstName": "Lindy",
                                    "customerId": 2986,
                                    "staxbillId": "13760755",
                                    "accountType": "child",
                                    "companyName": "Glowing Investments Inc.",
                                    "isCorporate": true,
                                    "paymentType": "CREDIT CARD",
                                    "employerName": "",
                                    "pastInvoices": [],
                                    "invoiceAmount": 481.05,
                                    "invoiceAmountEP": 0,
                                    "workingProvince": "Ontario",
                                    "workingProvinceId": 12
                                }
                            ],
                            "employerName": "",
                            "invoiceDate2": "2025-04-01",
                            "pastInvoices": [],
                            "invoiceAmount": 962.1,
                            "invoiceStatus": "POST",
                            "lastInvoiceNo": "-",
                            "overall_taxes": {
                                "Total": 71.26,
                                "PST on Health Insurance": 71.26
                            },
                            "displayVersion": true,
                            "havingBulkPlan": false,
                            "havingEmployees": true,
                            "lastInvoiceDate": null,
                            "previousInvoice": false,
                            "tax_information": "{\"individual_taxes\": {\"2973\": {\"customerId\": 2973, \"staxbillId\": \"13757999\", \"firstName\": \"Lindy\", \"lastName\": \"Green\", \"plans\": {\"taxes\": []}}, \"2986\": {\"customerId\": 2986, \"staxbillId\": \"13760755\", \"firstName\": \"Lindy\", \"lastName\": \"Green\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2025-03-28\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-28 22:16:48\", \"subscriptionId\": \"6838755\", \"price\": 35.63, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 35.63, \"totalPrice\": 35.63, \"totalTax\": 0, \"grandTotal\": 35.63, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"Complete Executive Care (60 to 74)\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2986, \"id\": 8133, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 35.63, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 35.63, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST ON HEALTH INSURANCE\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2973\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2025-03-28 22:16:48\", \"modified\": null, \"misc\": null, \"planObject\": \"{\\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": 35.63, \\\"price\\\": 35.63, \\\"planId\\\": 765, \\\"status\\\": \\\"Draft\\\", \\\"taxName\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"version\\\": 43, \\\"parentId\\\": \\\"2973\\\", \\\"taxPrice\\\": 35.63, \\\"customerId\\\": \\\"2986\\\", \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": 8, \\\"paidByCompany\\\": 1, \\\"activationDate\\\": \\\"2025-04-01T04:00:00Z\\\", \\\"subscriptionId\\\": 6838755, \\\"isSubscriptionTax\\\": true}\", \"customer_id\": 2986, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 8133, \"id\": 6262, \"planCoverage\": null, \"price\": 35.63, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8133, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2985\": {\"customerId\": 2985, \"staxbillId\": \"13760705\", \"firstName\": \"Sam\", \"lastName\": \"Chaiton\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2025-03-28\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-28 21:55:28\", \"subscriptionId\": \"6838737\", \"price\": 35.63, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 35.63, \"totalPrice\": 35.63, \"totalTax\": 0, \"grandTotal\": 35.63, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"Complete Executive Care (60 to 74)\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2985, \"id\": 8131, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 35.63, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 35.63, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST ON HEALTH INSURANCE\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2973\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2025-03-28 21:55:28\", \"modified\": null, \"misc\": null, \"planObject\": \"{\\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": 35.63, \\\"price\\\": 35.63, \\\"planId\\\": 765, \\\"status\\\": \\\"Draft\\\", \\\"taxName\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"version\\\": 43, \\\"parentId\\\": \\\"2973\\\", \\\"taxPrice\\\": 35.63, \\\"customerId\\\": \\\"2985\\\", \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": 8, \\\"paidByCompany\\\": 1, \\\"activationDate\\\": \\\"2025-04-01T04:00:00Z\\\", \\\"subscriptionId\\\": 6838737, \\\"isSubscriptionTax\\\": true}\", \"customer_id\": 2985, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 8131, \"id\": 6260, \"planCoverage\": null, \"price\": 35.63, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8131, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}}, \"overall_taxes\": {\"Total\": 71.26, \"PST on Health Insurance\": 71.26}}",
                            "individual_taxes": {
                                "2973": {
                                    "plans": {
                                        "taxes": []
                                    },
                                    "lastName": "Green",
                                    "firstName": "Lindy",
                                    "customerId": 2973,
                                    "staxbillId": "13757999"
                                },
                                "2985": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 8131,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 35.63,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 35.63,
                                                "scope": null,
                                                "total": 35.63,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2025-03-28 21:55:28",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "version": 43,
                                                "coverage": "SINGLE",
                                                "modified": null,
                                                "parentId": "2973",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 35.63,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2985,
                                                "grandTotal": 35.63,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2985\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838737, \"isSubscriptionTax\": true}",
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2025-03-28",
                                                "taxForPlan": 0,
                                                "totalPrice": 35.63,
                                                "createdDate": "2025-03-28 21:55:28",
                                                "customer_id": 2985,
                                                "enrolledDate": "2025-04-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2025-04-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6838737",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (60 to 74)"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 6260,
                                                        "price": 35.63,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": 43,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 8131,
                                                        "customer_plan_id": 8131
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Chaiton",
                                    "firstName": "Sam",
                                    "customerId": 2985,
                                    "staxbillId": "13760705"
                                },
                                "2986": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 8133,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 35.63,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 35.63,
                                                "scope": null,
                                                "total": 35.63,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2025-03-28 22:16:48",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "version": 43,
                                                "coverage": "SINGLE",
                                                "modified": null,
                                                "parentId": "2973",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 35.63,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2986,
                                                "grandTotal": 35.63,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2986\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838755, \"isSubscriptionTax\": true}",
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2025-03-28",
                                                "taxForPlan": 0,
                                                "totalPrice": 35.63,
                                                "createdDate": "2025-03-28 22:16:48",
                                                "customer_id": 2986,
                                                "enrolledDate": "2025-04-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2025-04-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6838755",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (60 to 74)"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 6262,
                                                        "price": 35.63,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": 43,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 8133,
                                                        "customer_plan_id": 8133
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Green",
                                    "firstName": "Lindy",
                                    "customerId": 2986,
                                    "staxbillId": "13760755"
                                }
                            },
                            "plan_information": "{\"2973\": {\"customerId\": 2973, \"staxbillId\": \"13757999\", \"firstName\": \"Lindy\", \"lastName\": \"Green\", \"plans\": {\"subscriptions\": []}}, \"2986\": {\"customerId\": 2986, \"staxbillId\": \"13760755\", \"firstName\": \"Lindy\", \"lastName\": \"Green\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 445.42, \"tax\": 35.63, \"total\": 481.05, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $35.63 \"}, \"taxDetailsDB\": {\"pst\": \"35.63\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"taxPrice\": \"35.63\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $35.63\", \"tax\": \"35.63\", \"price\": \"445.42\", \"total\": \"481.05\"}, \"taxForPlan\": 35.63, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2025-03-28\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-28 22:16:48\", \"subscriptionId\": \"6838756\", \"price\": 445.42, \"quantity\": 1, \"count\": 1, \"tax\": 35.63, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | \", \"total\": 481.05, \"totalPrice\": 445.42, \"totalTax\": 35.63, \"grandTotal\": 481.05, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (60 to 74)\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2986, \"id\": 8134, \"planId\": 773, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 35.63, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 35.63, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST ON HEALTH INSURANCE\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2973\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6838755\", \"isBulk\": false, \"created\": \"2025-03-28 22:16:48\", \"modified\": \"2025-03-28 22:16:48\", \"misc\": \"{\\\"name\\\": \\\"Complete Executive Care (60 to 74) (Ontario) \\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"description\\\": \\\"Health Insurance 13760755 2986 PST on Health Insurance (#709505879) 8.00% $35.63 \\\"}\", \"planObject\": \"{\\\"id\\\": 773, \\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": 35.63, \\\"qst\\\": 0, \\\"tax\\\": \\\"35.63\\\", \\\"name\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"type\\\": \\\"100% Company Paid\\\", \\\"optIn\\\": false, \\\"taxUI\\\": \\\"<span>-</span><span>-</span><span>-</span><span> -</span>\\\", \\\"total\\\": \\\"481.05\\\", \\\"amount\\\": \\\"445.42\\\", \\\"amounts\\\": {\\\"total\\\": 445.42, \\\"company\\\": 445.42, \\\"employee\\\": 0}, \\\"details\\\": \\\"Private Health\\\", \\\"options\\\": [], \\\"taxName\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"totalUI\\\": \\\"$481.05\\\", \\\"version\\\": 43, \\\"amountUI\\\": \\\"$445.42\\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"gstCheck\\\": true, \\\"gstPrice\\\": 0, \\\"hstCheck\\\": true, \\\"hstPrice\\\": 0, \\\"isBundle\\\": true, \\\"planname\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"products\\\": [{\\\"id\\\": 32228, \\\"tax\\\": 35.63, \\\"name\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"price\\\": 445.42, \\\"total\\\": 481.05, \\\"version\\\": 43, \\\"coverage\\\": \\\"SINGLE\\\", \\\"planLevel\\\": 18, \\\"productId\\\": 7, \\\"description\\\": \\\" Single\\\", \\\"tax_details\\\": [{\\\"plan_id\\\": 765, \\\"tax_sku\\\": \\\"pstonhealthinsurance\\\", \\\"tax_code\\\": null, \\\"tax_name\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"tax_rate\\\": 0.08, \\\"plan_product_id\\\": 178475, \\\"tax_description\\\": \\\"PST on Health Insurance (#709505879)\\\", \\\"business_tax_number\\\": \\\"709505879\\\"}], \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"calculatedTax\\\": {\\\"tax\\\": 35.63, \\\"price\\\": 445.42, \\\"total\\\": 481.05, \\\"planProductIds\\\": [178475], \\\"planProductInfos\\\": [{\\\"name\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"price\\\": 35.63, \\\"taxRate\\\": 0.08, \\\"isIncluded\\\": true, \\\"description\\\": \\\"PST on Health Insurance (#709505879)\\\", \\\"taxRatePercentage\\\": \\\"8.00%\\\", \\\"planProductUniqueId\\\": 178475}]}, \\\"planProductId\\\": \\\"183848\\\", \\\"bundledProducts\\\": [\\\"Single\\\"], \\\"planLevelParent\\\": 15}], \\\"pstCheck\\\": true, \\\"pstPrice\\\": 0, \\\"qstCheck\\\": true, \\\"qstPrice\\\": 0, \\\"taxPrice\\\": 35.63, \\\"groupName\\\": \\\"Complete Executive Care\\\", \\\"packageId\\\": 5, \\\"planLevel\\\": 18, \\\"planPrice\\\": 445.42, \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": 8, \\\"totalPrice\\\": \\\"481.05\\\", \\\"description\\\": \\\"Health Insurance\\\", \\\"packagename\\\": \\\"Private Health\\\", \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"companyAmount\\\": 445.42, \\\"insuranceType\\\": \\\"HEALTH\\\", \\\"paidByCompany\\\": 1, \\\"planLevelName\\\": \\\"Complete Executive Care\\\", \\\"skuTotalPrice\\\": 481.05, \\\"taxApplicable\\\": true, \\\"categorization\\\": {\\\"paidByCompany\\\": true, \\\"paidByEmployee\\\": false, \\\"coveredByCompany\\\": false}, \\\"employeeAmount\\\": 0, \\\"enrollmentDate\\\": \\\"2025-04-01\\\", \\\"fusebillPlanID\\\": 49875, \\\"paidByCompany1\\\": \\\"32228\\\", \\\"paidByEmployee\\\": 0, \\\"companyAmountUI\\\": \\\"$445.42\\\", \\\"paidByEmployee1\\\": \\\"true\\\", \\\"planFrequencyID\\\": 107062, \\\"planLevelParent\\\": 15, \\\"planproductname\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"coveredByCompany\\\": 0, \\\"employeeAmountUI\\\": \\\"$0\\\", \\\"coveredByCompany1\\\": \\\"18\\\", \\\"planLevel_parentId\\\": \\\"15\\\", \\\"taxDescriptionLine\\\": \\\"PST on Health Insurance (#709505879) 8.00% $35.63 \\\", \\\"disallowedPlanLevels\\\": \\\"17,23,26,31,46\\\", \\\"companyCoveredBasePlan\\\": {\\\"tax\\\": 0, \\\"total\\\": 0, \\\"amount\\\": 0, \\\"planId\\\": 0, \\\"planName\\\": \\\"NA\\\", \\\"planLevelId\\\": 0}}\", \"customer_id\": 2986, \"plan_id\": 773, \"tax_subscription_id\": 6838755, \"customerPlanProducts\": [{\"customerPlanId\": 8134, \"id\": 6263, \"planCoverage\": \"SINGLE\", \"price\": 445.42, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8134, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"Complete Executive Care (60 to 74)\", \"name\": \"Complete Executive Care (60 to 74)\", \"planCode\": \"completeexecutivecare60to74\", \"packageId\": 5}]}}, \"2985\": {\"customerId\": 2985, \"staxbillId\": \"13760705\", \"firstName\": \"Sam\", \"lastName\": \"Chaiton\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 445.42, \"tax\": 35.63, \"total\": 481.05, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $35.63 \"}, \"taxDetailsDB\": {\"pst\": \"35.63\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"taxPrice\": \"35.63\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $35.63\", \"tax\": \"35.63\", \"price\": \"445.42\", \"total\": \"481.05\"}, \"taxForPlan\": 35.63, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2025-03-28\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-28 21:55:29\", \"subscriptionId\": \"6838738\", \"price\": 445.42, \"quantity\": 1, \"count\": 1, \"tax\": 35.63, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | \", \"total\": 481.05, \"totalPrice\": 445.42, \"totalTax\": 35.63, \"grandTotal\": 481.05, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (60 to 74)\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2985, \"id\": 8132, \"planId\": 773, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 35.63, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 35.63, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST ON HEALTH INSURANCE\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2973\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6838737\", \"isBulk\": false, \"created\": \"2025-03-28 21:55:29\", \"modified\": \"2025-03-28 21:55:29\", \"misc\": \"{\\\"name\\\": \\\"Complete Executive Care (60 to 74) (Ontario) \\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"description\\\": \\\"Health Insurance 13760705 2985 PST on Health Insurance (#709505879) 8.00% $35.63 \\\"}\", \"planObject\": \"{\\\"id\\\": 773, \\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": 35.63, \\\"qst\\\": 0, \\\"tax\\\": \\\"35.63\\\", \\\"name\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"type\\\": \\\"100% Company Paid\\\", \\\"optIn\\\": false, \\\"taxUI\\\": \\\"<span>-</span><span>-</span><span>-</span><span> -</span>\\\", \\\"total\\\": \\\"481.05\\\", \\\"amount\\\": \\\"445.42\\\", \\\"amounts\\\": {\\\"total\\\": 445.42, \\\"company\\\": 445.42, \\\"employee\\\": 0}, \\\"details\\\": \\\"Private Health\\\", \\\"options\\\": [], \\\"taxName\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"totalUI\\\": \\\"$481.05\\\", \\\"version\\\": 43, \\\"amountUI\\\": \\\"$445.42\\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"gstCheck\\\": true, \\\"gstPrice\\\": 0, \\\"hstCheck\\\": true, \\\"hstPrice\\\": 0, \\\"isBundle\\\": true, \\\"planname\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"products\\\": [{\\\"id\\\": 32228, \\\"tax\\\": 35.63, \\\"name\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"price\\\": 445.42, \\\"total\\\": 481.05, \\\"version\\\": 43, \\\"coverage\\\": \\\"SINGLE\\\", \\\"planLevel\\\": 18, \\\"productId\\\": 7, \\\"description\\\": \\\" Single\\\", \\\"tax_details\\\": [{\\\"plan_id\\\": 765, \\\"tax_sku\\\": \\\"pstonhealthinsurance\\\", \\\"tax_code\\\": null, \\\"tax_name\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"tax_rate\\\": 0.08, \\\"plan_product_id\\\": 178475, \\\"tax_description\\\": \\\"PST on Health Insurance (#709505879)\\\", \\\"business_tax_number\\\": \\\"709505879\\\"}], \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"calculatedTax\\\": {\\\"tax\\\": 35.63, \\\"price\\\": 445.42, \\\"total\\\": 481.05, \\\"planProductIds\\\": [178475], \\\"planProductInfos\\\": [{\\\"name\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"price\\\": 35.63, \\\"taxRate\\\": 0.08, \\\"isIncluded\\\": true, \\\"description\\\": \\\"PST on Health Insurance (#709505879)\\\", \\\"taxRatePercentage\\\": \\\"8.00%\\\", \\\"planProductUniqueId\\\": 178475}]}, \\\"planProductId\\\": \\\"183848\\\", \\\"bundledProducts\\\": [\\\"Single\\\"], \\\"planLevelParent\\\": 15}], \\\"pstCheck\\\": true, \\\"pstPrice\\\": 0, \\\"qstCheck\\\": true, \\\"qstPrice\\\": 0, \\\"taxPrice\\\": 35.63, \\\"groupName\\\": \\\"Complete Executive Care\\\", \\\"packageId\\\": 5, \\\"planLevel\\\": 18, \\\"planPrice\\\": 445.42, \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": 8, \\\"totalPrice\\\": \\\"481.05\\\", \\\"description\\\": \\\"Health Insurance\\\", \\\"packagename\\\": \\\"Private Health\\\", \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"companyAmount\\\": 445.42, \\\"insuranceType\\\": \\\"HEALTH\\\", \\\"paidByCompany\\\": 1, \\\"planLevelName\\\": \\\"Complete Executive Care\\\", \\\"skuTotalPrice\\\": 481.05, \\\"taxApplicable\\\": true, \\\"categorization\\\": {\\\"paidByCompany\\\": true, \\\"paidByEmployee\\\": false, \\\"coveredByCompany\\\": false}, \\\"employeeAmount\\\": 0, \\\"enrollmentDate\\\": \\\"2025-04-01\\\", \\\"fusebillPlanID\\\": 49875, \\\"paidByCompany1\\\": \\\"32228\\\", \\\"paidByEmployee\\\": 0, \\\"companyAmountUI\\\": \\\"$445.42\\\", \\\"paidByEmployee1\\\": \\\"true\\\", \\\"planFrequencyID\\\": 107062, \\\"planLevelParent\\\": 15, \\\"planproductname\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"coveredByCompany\\\": 0, \\\"employeeAmountUI\\\": \\\"$0\\\", \\\"coveredByCompany1\\\": \\\"18\\\", \\\"planLevel_parentId\\\": \\\"15\\\", \\\"taxDescriptionLine\\\": \\\"PST on Health Insurance (#709505879) 8.00% $35.63 \\\", \\\"disallowedPlanLevels\\\": \\\"17,23,26,31,46\\\", \\\"companyCoveredBasePlan\\\": {\\\"tax\\\": 0, \\\"total\\\": 0, \\\"amount\\\": 0, \\\"planId\\\": 0, \\\"planName\\\": \\\"NA\\\", \\\"planLevelId\\\": 0}}\", \"customer_id\": 2985, \"plan_id\": 773, \"tax_subscription_id\": 6838737, \"customerPlanProducts\": [{\"customerPlanId\": 8132, \"id\": 6261, \"planCoverage\": \"SINGLE\", \"price\": 445.42, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8132, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"Complete Executive Care (60 to 74)\", \"name\": \"Complete Executive Care (60 to 74)\", \"planCode\": \"completeexecutivecare60to74\", \"packageId\": 5}]}}}",
                            "lastInvoiceAmount": 0,
                            "invoicePaymentDate": "2025-04-01",
                            "lastInvoicePayment": 0,
                            "contact_information": "{\"stateId\": 12, \"workingProvinceId\": 12, \"state\": \"ON\", \"workingProvince\": \"ON\"}",
                            "handleInvoiceHistory": true
                        },
                        "paymentStatus": null,
                        "invoiceHistory": null,
                        "taxInformation": {
                            "overall_taxes": {
                                "Total": 71.26,
                                "PST on Health Insurance": 71.26
                            },
                            "individual_taxes": {
                                "2973": {
                                    "plans": {
                                        "taxes": []
                                    },
                                    "lastName": "Green",
                                    "firstName": "Lindy",
                                    "customerId": 2973,
                                    "staxbillId": "13757999"
                                },
                                "2985": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 8131,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 35.63,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 35.63,
                                                "scope": null,
                                                "total": 35.63,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2025-03-28 21:55:28",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "version": 43,
                                                "coverage": "SINGLE",
                                                "modified": null,
                                                "parentId": "2973",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 35.63,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2985,
                                                "grandTotal": 35.63,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2985\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838737, \"isSubscriptionTax\": true}",
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2025-03-28",
                                                "taxForPlan": 0,
                                                "totalPrice": 35.63,
                                                "createdDate": "2025-03-28 21:55:28",
                                                "customer_id": 2985,
                                                "enrolledDate": "2025-04-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2025-04-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6838737",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (60 to 74)"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 6260,
                                                        "price": 35.63,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": 43,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 8131,
                                                        "customer_plan_id": 8131
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Chaiton",
                                    "firstName": "Sam",
                                    "customerId": 2985,
                                    "staxbillId": "13760705"
                                },
                                "2986": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 8133,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 35.63,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 35.63,
                                                "scope": null,
                                                "total": 35.63,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2025-03-28 22:16:48",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "version": 43,
                                                "coverage": "SINGLE",
                                                "modified": null,
                                                "parentId": "2973",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 35.63,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2986,
                                                "grandTotal": 35.63,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2986\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838755, \"isSubscriptionTax\": true}",
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2025-03-28",
                                                "taxForPlan": 0,
                                                "totalPrice": 35.63,
                                                "createdDate": "2025-03-28 22:16:48",
                                                "customer_id": 2986,
                                                "enrolledDate": "2025-04-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2025-04-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6838755",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (60 to 74)"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 6262,
                                                        "price": 35.63,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": 43,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 8133,
                                                        "customer_plan_id": 8133
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Green",
                                    "firstName": "Lindy",
                                    "customerId": 2986,
                                    "staxbillId": "13760755"
                                }
                            }
                        },
                        "planInformation": {
                            "2973": {
                                "plans": {
                                    "subscriptions": []
                                },
                                "lastName": "Green",
                                "firstName": "Lindy",
                                "customerId": 2973,
                                "staxbillId": "13757999"
                            },
                            "2985": {
                                "plans": {
                                    "subscriptions": [
                                        {
                                            "id": 8132,
                                            "gst": null,
                                            "hst": null,
                                            "pst": 35.63,
                                            "qst": null,
                                            "tax": 35.63,
                                            "misc": "{\"name\": \"Complete Executive Care (60 to 74) (Ontario) \", \"coverage\": \"SINGLE\", \"description\": \"Health Insurance 13760705 2985 PST on Health Insurance (#709505879) 8.00% $35.63 \"}",
                                            "name": "Complete Executive Care (60 to 74)",
                                            "type": "100% Company Paid",
                                            "count": 1,
                                            "price": 445.42,
                                            "scope": null,
                                            "total": 481.05,
                                            "isBulk": false,
                                            "planId": 773,
                                            "status": "Active",
                                            "created": "2025-03-28 21:55:29",
                                            "plan_id": 773,
                                            "stateId": 12,
                                            "summary": null,
                                            "taxCode": null,
                                            "taxName": "PST ON HEALTH INSURANCE",
                                            "version": 43,
                                            "coverage": "SINGLE",
                                            "modified": "2025-03-28 21:55:29",
                                            "parentId": "2973",
                                            "planCode": "completeexecutivecare60to74",
                                            "planName": "Complete Executive Care (60 to 74)",
                                            "quantity": 1,
                                            "taxPrice": 35.63,
                                            "totalTax": 35.63,
                                            "coverage1": "Single",
                                            "packageId": 5,
                                            "customerId": 2985,
                                            "grandTotal": 481.05,
                                            "gstTaxRate": null,
                                            "hstTaxRate": null,
                                            "planObject": "{\"id\": 773, \"gst\": null, \"hst\": null, \"pst\": 35.63, \"qst\": 0, \"tax\": \"35.63\", \"name\": \"Complete Executive Care (60 to 74)\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"481.05\", \"amount\": \"445.42\", \"amounts\": {\"total\": 445.42, \"company\": 445.42, \"employee\": 0}, \"details\": \"Private Health\", \"options\": [], \"taxName\": \"PST ON HEALTH INSURANCE\", \"totalUI\": \"$481.05\", \"version\": 43, \"amountUI\": \"$445.42\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Complete Executive Care (60 to 74)\", \"products\": [{\"id\": 32228, \"tax\": 35.63, \"name\": \"Complete Executive Care (60 to 74)\", \"price\": 445.42, \"total\": 481.05, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 18, \"productId\": 7, \"description\": \" Single\", \"tax_details\": [{\"plan_id\": 765, \"tax_sku\": \"pstonhealthinsurance\", \"tax_code\": null, \"tax_name\": \"PST ON HEALTH INSURANCE\", \"tax_rate\": 0.08, \"plan_product_id\": 178475, \"tax_description\": \"PST on Health Insurance (#709505879)\", \"business_tax_number\": \"709505879\"}], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 35.63, \"price\": 445.42, \"total\": 481.05, \"planProductIds\": [178475], \"planProductInfos\": [{\"name\": \"PST ON HEALTH INSURANCE\", \"price\": 35.63, \"taxRate\": 0.08, \"isIncluded\": true, \"description\": \"PST on Health Insurance (#709505879)\", \"taxRatePercentage\": \"8.00%\", \"planProductUniqueId\": 178475}]}, \"planProductId\": \"183848\", \"bundledProducts\": [\"Single\"], \"planLevelParent\": 15}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": 35.63, \"groupName\": \"Complete Executive Care\", \"packageId\": 5, \"planLevel\": 18, \"planPrice\": 445.42, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"totalPrice\": \"481.05\", \"description\": \"Health Insurance\", \"packagename\": \"Private Health\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 445.42, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Complete Executive Care\", \"skuTotalPrice\": 481.05, \"taxApplicable\": true, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49875, \"paidByCompany1\": \"32228\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$445.42\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107062, \"planLevelParent\": 15, \"planproductname\": \"Complete Executive Care (60 to 74)\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"18\", \"planLevel_parentId\": \"15\", \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8.00% $35.63 \", \"disallowedPlanLevels\": \"17,23,26,31,46\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                            "pstTaxRate": 8,
                                            "qstTaxRate": null,
                                            "signupDate": "2025-03-28",
                                            "taxDetails": {
                                                "tax": 35.63,
                                                "price": 445.42,
                                                "total": 481.05,
                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $35.63 "
                                            },
                                            "taxForPlan": 35.63,
                                            "totalPrice": 445.42,
                                            "createdDate": "2025-03-28 21:55:29",
                                            "customer_id": 2985,
                                            "enrolledDate": "2025-04-01",
                                            "taxDetailsDB": {
                                                "gst": "0.00",
                                                "hst": "0.00",
                                                "pst": "35.63",
                                                "tax": "35.63",
                                                "price": "445.42",
                                                "total": "481.05",
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "taxPrice": "35.63",
                                                "gstTaxRate": "0.00",
                                                "hstTaxRate": "0.00",
                                                "pstTaxRate": "8.00",
                                                "taxDescriptionLine": "PST on Health Insurance 8% $35.63"
                                            },
                                            "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                            "bulkPlanLevel": null,
                                            "paidByCompany": 1,
                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                            "activationDate": "2025-04-01 04:00:00",
                                            "paidByEmployee": null,
                                            "subscriptionId": "6838738",
                                            "workingStateId": 12,
                                            "bundledProducts": [
                                                "Complete Executive Care (60 to 74)"
                                            ],
                                            "lastBillingDate": null,
                                            "nextBillingDate": null,
                                            "terminationDate": null,
                                            "cancellationDate": null,
                                            "coveredByCompany": null,
                                            "nextBillingPrice": null,
                                            "restrictedAccess": null,
                                            "isSubscriptionTax": false,
                                            "reinstatementDate": null,
                                            "taxSubscriptionId": "6838737",
                                            "terminationReason": null,
                                            "reinstatementReason": null,
                                            "tax_subscription_id": 6838737,
                                            "aitestproExecutionId": null,
                                            "customerPlanProducts": [
                                                {
                                                    "id": 6261,
                                                    "price": 445.42,
                                                    "taxSku": null,
                                                    "product": {
                                                        "id": 7,
                                                        "code": "single",
                                                        "data": "{\"additional_instructions\": []}",
                                                        "logo": null,
                                                        "name": "Single",
                                                        "color": null,
                                                        "price": 7.25,
                                                        "glCode": "53211",
                                                        "display": "TITLE",
                                                        "published": true,
                                                        "fusebillId": "126196",
                                                        "backgroundColor": "#212A3E",
                                                        "includedProducts": null
                                                    },
                                                    "taxCode": null,
                                                    "taxName": null,
                                                    "version": 43,
                                                    "productId": 7,
                                                    "product_id": 7,
                                                    "planCoverage": "SINGLE",
                                                    "customerPlanId": 8132,
                                                    "customer_plan_id": 8132
                                                }
                                            ],
                                            "backdatedActivationDate": null,
                                            "backdatedCancellationDate": null
                                        }
                                    ]
                                },
                                "lastName": "Chaiton",
                                "firstName": "Sam",
                                "customerId": 2985,
                                "staxbillId": "13760705"
                            },
                            "2986": {
                                "plans": {
                                    "subscriptions": [
                                        {
                                            "id": 8134,
                                            "gst": null,
                                            "hst": null,
                                            "pst": 35.63,
                                            "qst": null,
                                            "tax": 35.63,
                                            "misc": "{\"name\": \"Complete Executive Care (60 to 74) (Ontario) \", \"coverage\": \"SINGLE\", \"description\": \"Health Insurance 13760755 2986 PST on Health Insurance (#709505879) 8.00% $35.63 \"}",
                                            "name": "Complete Executive Care (60 to 74)",
                                            "type": "100% Company Paid",
                                            "count": 1,
                                            "price": 445.42,
                                            "scope": null,
                                            "total": 481.05,
                                            "isBulk": false,
                                            "planId": 773,
                                            "status": "Active",
                                            "created": "2025-03-28 22:16:48",
                                            "plan_id": 773,
                                            "stateId": 12,
                                            "summary": null,
                                            "taxCode": null,
                                            "taxName": "PST ON HEALTH INSURANCE",
                                            "version": 43,
                                            "coverage": "SINGLE",
                                            "modified": "2025-03-28 22:16:48",
                                            "parentId": "2973",
                                            "planCode": "completeexecutivecare60to74",
                                            "planName": "Complete Executive Care (60 to 74)",
                                            "quantity": 1,
                                            "taxPrice": 35.63,
                                            "totalTax": 35.63,
                                            "coverage1": "Single",
                                            "packageId": 5,
                                            "customerId": 2986,
                                            "grandTotal": 481.05,
                                            "gstTaxRate": null,
                                            "hstTaxRate": null,
                                            "planObject": "{\"id\": 773, \"gst\": null, \"hst\": null, \"pst\": 35.63, \"qst\": 0, \"tax\": \"35.63\", \"name\": \"Complete Executive Care (60 to 74)\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"481.05\", \"amount\": \"445.42\", \"amounts\": {\"total\": 445.42, \"company\": 445.42, \"employee\": 0}, \"details\": \"Private Health\", \"options\": [], \"taxName\": \"PST ON HEALTH INSURANCE\", \"totalUI\": \"$481.05\", \"version\": 43, \"amountUI\": \"$445.42\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Complete Executive Care (60 to 74)\", \"products\": [{\"id\": 32228, \"tax\": 35.63, \"name\": \"Complete Executive Care (60 to 74)\", \"price\": 445.42, \"total\": 481.05, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 18, \"productId\": 7, \"description\": \" Single\", \"tax_details\": [{\"plan_id\": 765, \"tax_sku\": \"pstonhealthinsurance\", \"tax_code\": null, \"tax_name\": \"PST ON HEALTH INSURANCE\", \"tax_rate\": 0.08, \"plan_product_id\": 178475, \"tax_description\": \"PST on Health Insurance (#709505879)\", \"business_tax_number\": \"709505879\"}], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 35.63, \"price\": 445.42, \"total\": 481.05, \"planProductIds\": [178475], \"planProductInfos\": [{\"name\": \"PST ON HEALTH INSURANCE\", \"price\": 35.63, \"taxRate\": 0.08, \"isIncluded\": true, \"description\": \"PST on Health Insurance (#709505879)\", \"taxRatePercentage\": \"8.00%\", \"planProductUniqueId\": 178475}]}, \"planProductId\": \"183848\", \"bundledProducts\": [\"Single\"], \"planLevelParent\": 15}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": 35.63, \"groupName\": \"Complete Executive Care\", \"packageId\": 5, \"planLevel\": 18, \"planPrice\": 445.42, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"totalPrice\": \"481.05\", \"description\": \"Health Insurance\", \"packagename\": \"Private Health\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 445.42, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Complete Executive Care\", \"skuTotalPrice\": 481.05, \"taxApplicable\": true, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49875, \"paidByCompany1\": \"32228\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$445.42\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107062, \"planLevelParent\": 15, \"planproductname\": \"Complete Executive Care (60 to 74)\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"18\", \"planLevel_parentId\": \"15\", \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8.00% $35.63 \", \"disallowedPlanLevels\": \"17,23,26,31,46\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                            "pstTaxRate": 8,
                                            "qstTaxRate": null,
                                            "signupDate": "2025-03-28",
                                            "taxDetails": {
                                                "tax": 35.63,
                                                "price": 445.42,
                                                "total": 481.05,
                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $35.63 "
                                            },
                                            "taxForPlan": 35.63,
                                            "totalPrice": 445.42,
                                            "createdDate": "2025-03-28 22:16:48",
                                            "customer_id": 2986,
                                            "enrolledDate": "2025-04-01",
                                            "taxDetailsDB": {
                                                "gst": "0.00",
                                                "hst": "0.00",
                                                "pst": "35.63",
                                                "tax": "35.63",
                                                "price": "445.42",
                                                "total": "481.05",
                                                "taxName": "PST ON HEALTH INSURANCE",
                                                "taxPrice": "35.63",
                                                "gstTaxRate": "0.00",
                                                "hstTaxRate": "0.00",
                                                "pstTaxRate": "8.00",
                                                "taxDescriptionLine": "PST on Health Insurance 8% $35.63"
                                            },
                                            "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                            "bulkPlanLevel": null,
                                            "paidByCompany": 1,
                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                            "activationDate": "2025-04-01 04:00:00",
                                            "paidByEmployee": null,
                                            "subscriptionId": "6838756",
                                            "workingStateId": 12,
                                            "bundledProducts": [
                                                "Complete Executive Care (60 to 74)"
                                            ],
                                            "lastBillingDate": null,
                                            "nextBillingDate": null,
                                            "terminationDate": null,
                                            "cancellationDate": null,
                                            "coveredByCompany": null,
                                            "nextBillingPrice": null,
                                            "restrictedAccess": null,
                                            "isSubscriptionTax": false,
                                            "reinstatementDate": null,
                                            "taxSubscriptionId": "6838755",
                                            "terminationReason": null,
                                            "reinstatementReason": null,
                                            "tax_subscription_id": 6838755,
                                            "aitestproExecutionId": null,
                                            "customerPlanProducts": [
                                                {
                                                    "id": 6263,
                                                    "price": 445.42,
                                                    "taxSku": null,
                                                    "product": {
                                                        "id": 7,
                                                        "code": "single",
                                                        "data": "{\"additional_instructions\": []}",
                                                        "logo": null,
                                                        "name": "Single",
                                                        "color": null,
                                                        "price": 7.25,
                                                        "glCode": "53211",
                                                        "display": "TITLE",
                                                        "published": true,
                                                        "fusebillId": "126196",
                                                        "backgroundColor": "#212A3E",
                                                        "includedProducts": null
                                                    },
                                                    "taxCode": null,
                                                    "taxName": null,
                                                    "version": 43,
                                                    "productId": 7,
                                                    "product_id": 7,
                                                    "planCoverage": "SINGLE",
                                                    "customerPlanId": 8134,
                                                    "customer_plan_id": 8134
                                                }
                                            ],
                                            "backdatedActivationDate": null,
                                            "backdatedCancellationDate": null
                                        }
                                    ]
                                },
                                "lastName": "Green",
                                "firstName": "Lindy",
                                "customerId": 2986,
                                "staxbillId": "13760755"
                            }
                        },
                        "contactInformation": {
                            "state": "ON",
                            "stateId": 12,
                            "workingProvince": "ON",
                            "workingProvinceId": 12
                        },
                        "fusebillCustomerId": "13757999",
                        "paymentFailureCount": null
                    }
                ],
                "invoiceAmount": 962.1,
                "invoiceStatus": "POST",
                "overall_taxes": {
                    "Total": 71.26,
                    "PST on Health Insurance": 71.26
                },
                "displayVersion": true,
                "havingBulkPlan": false,
                "havingEmployees": true,
                "lastInvoiceDate": "2025-04-01",
                "previousInvoice": true,
                "tax_information": "{\"individual_taxes\": {\"2973\": {\"customerId\": 2973, \"staxbillId\": \"13757999\", \"firstName\": \"Lindy\", \"lastName\": \"Green\", \"plans\": {\"taxes\": []}}, \"2986\": {\"customerId\": 2986, \"staxbillId\": \"13760755\", \"firstName\": \"Lindy\", \"lastName\": \"Green\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2025-03-28\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-28 22:16:48\", \"subscriptionId\": \"6838755\", \"price\": 35.63, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 35.63, \"totalPrice\": 35.63, \"totalTax\": 0, \"grandTotal\": 35.63, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"Complete Executive Care (60 to 74)\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2986, \"id\": 8133, \"planId\": 765, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 35.63, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 35.63, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST ON HEALTH INSURANCE\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2973\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2025-03-28 22:16:48\", \"modified\": null, \"misc\": null, \"planObject\": \"{\\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": 35.63, \\\"price\\\": 35.63, \\\"planId\\\": 765, \\\"status\\\": \\\"Draft\\\", \\\"taxName\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"version\\\": 43, \\\"parentId\\\": \\\"2973\\\", \\\"taxPrice\\\": 35.63, \\\"customerId\\\": \\\"2986\\\", \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": 8, \\\"paidByCompany\\\": 1, \\\"activationDate\\\": \\\"2025-04-01T04:00:00Z\\\", \\\"subscriptionId\\\": 6838755, \\\"isSubscriptionTax\\\": true}\", \"customer_id\": 2986, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 8133, \"id\": 6262, \"planCoverage\": null, \"price\": 35.63, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8133, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2985\": {\"customerId\": 2985, \"staxbillId\": \"13760705\", \"firstName\": \"Sam\", \"lastName\": \"Chaiton\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2025-03-28\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-28 21:55:28\", \"subscriptionId\": \"6838737\", \"price\": 35.63, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 35.63, \"totalPrice\": 35.63, \"totalTax\": 0, \"grandTotal\": 35.63, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"Complete Executive Care (60 to 74)\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2985, \"id\": 8131, \"planId\": 765, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 35.63, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 35.63, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST ON HEALTH INSURANCE\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2973\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2025-03-28 21:55:28\", \"modified\": null, \"misc\": null, \"planObject\": \"{\\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": 35.63, \\\"price\\\": 35.63, \\\"planId\\\": 765, \\\"status\\\": \\\"Draft\\\", \\\"taxName\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"version\\\": 43, \\\"parentId\\\": \\\"2973\\\", \\\"taxPrice\\\": 35.63, \\\"customerId\\\": \\\"2985\\\", \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": 8, \\\"paidByCompany\\\": 1, \\\"activationDate\\\": \\\"2025-04-01T04:00:00Z\\\", \\\"subscriptionId\\\": 6838737, \\\"isSubscriptionTax\\\": true}\", \"customer_id\": 2985, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 8131, \"id\": 6260, \"planCoverage\": null, \"price\": 35.63, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8131, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}}, \"overall_taxes\": {\"Total\": 71.26, \"PST on Health Insurance\": 71.26}}",
                "individual_taxes": {
                    "2973": {
                        "plans": {
                            "taxes": []
                        },
                        "lastName": "Green",
                        "firstName": "Lindy",
                        "customerId": 2973,
                        "staxbillId": "13757999"
                    },
                    "2985": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 8131,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 35.63,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 35.63,
                                    "scope": null,
                                    "total": 35.63,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2025-03-28 21:55:28",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "version": 43,
                                    "coverage": "SINGLE",
                                    "modified": null,
                                    "parentId": "2973",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 35.63,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2985,
                                    "grandTotal": 35.63,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2985\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838737, \"isSubscriptionTax\": true}",
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2025-03-28",
                                    "taxForPlan": 0,
                                    "totalPrice": 35.63,
                                    "createdDate": "2025-03-28 21:55:28",
                                    "customer_id": 2985,
                                    "enrolledDate": "2025-04-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2025-04-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6838737",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (60 to 74)"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 6260,
                                            "price": 35.63,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 8131,
                                            "customer_plan_id": 8131
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Chaiton",
                        "firstName": "Sam",
                        "customerId": 2985,
                        "staxbillId": "13760705"
                    },
                    "2986": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 8133,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 35.63,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 35.63,
                                    "scope": null,
                                    "total": 35.63,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2025-03-28 22:16:48",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST ON HEALTH INSURANCE",
                                    "version": 43,
                                    "coverage": "SINGLE",
                                    "modified": null,
                                    "parentId": "2973",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 35.63,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2986,
                                    "grandTotal": 35.63,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": "{\"gst\": null, \"hst\": null, \"pst\": 35.63, \"price\": 35.63, \"planId\": 765, \"status\": \"Draft\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"version\": 43, \"parentId\": \"2973\", \"taxPrice\": 35.63, \"customerId\": \"2986\", \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": 8, \"paidByCompany\": 1, \"activationDate\": \"2025-04-01T04:00:00Z\", \"subscriptionId\": 6838755, \"isSubscriptionTax\": true}",
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2025-03-28",
                                    "taxForPlan": 0,
                                    "totalPrice": 35.63,
                                    "createdDate": "2025-03-28 22:16:48",
                                    "customer_id": 2986,
                                    "enrolledDate": "2025-04-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2025-04-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6838755",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (60 to 74)"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 6262,
                                            "price": 35.63,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 8133,
                                            "customer_plan_id": 8133
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Green",
                        "firstName": "Lindy",
                        "customerId": 2986,
                        "staxbillId": "13760755"
                    }
                },
                "plan_information": "{\"2973\": {\"customerId\": 2973, \"staxbillId\": \"13757999\", \"firstName\": \"Lindy\", \"lastName\": \"Green\", \"plans\": {\"subscriptions\": []}}, \"2986\": {\"customerId\": 2986, \"staxbillId\": \"13760755\", \"firstName\": \"Lindy\", \"lastName\": \"Green\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 445.42, \"tax\": 35.63, \"total\": 481.05, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $35.63 \"}, \"taxDetailsDB\": {\"pst\": \"35.63\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"taxPrice\": \"35.63\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $35.63\", \"tax\": \"35.63\", \"price\": \"445.42\", \"total\": \"481.05\"}, \"taxForPlan\": 35.63, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2025-03-28\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-28 22:16:48\", \"subscriptionId\": \"6838756\", \"price\": 445.42, \"quantity\": 1, \"count\": 1, \"tax\": 35.63, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | \", \"total\": 481.05, \"totalPrice\": 445.42, \"totalTax\": 35.63, \"grandTotal\": 481.05, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (60 to 74)\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2986, \"id\": 8134, \"planId\": 773, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 35.63, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 35.63, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST ON HEALTH INSURANCE\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2973\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6838755\", \"isBulk\": false, \"created\": \"2025-03-28 22:16:48\", \"modified\": \"2025-03-28 22:16:48\", \"misc\": \"{\\\"name\\\": \\\"Complete Executive Care (60 to 74) (Ontario) \\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"description\\\": \\\"Health Insurance 13760755 2986 PST on Health Insurance (#709505879) 8.00% $35.63 \\\"}\", \"planObject\": \"{\\\"id\\\": 773, \\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": 35.63, \\\"qst\\\": 0, \\\"tax\\\": \\\"35.63\\\", \\\"name\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"type\\\": \\\"100% Company Paid\\\", \\\"optIn\\\": false, \\\"taxUI\\\": \\\"<span>-</span><span>-</span><span>-</span><span> -</span>\\\", \\\"total\\\": \\\"481.05\\\", \\\"amount\\\": \\\"445.42\\\", \\\"amounts\\\": {\\\"total\\\": 445.42, \\\"company\\\": 445.42, \\\"employee\\\": 0}, \\\"details\\\": \\\"Private Health\\\", \\\"options\\\": [], \\\"taxName\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"totalUI\\\": \\\"$481.05\\\", \\\"version\\\": 43, \\\"amountUI\\\": \\\"$445.42\\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"gstCheck\\\": true, \\\"gstPrice\\\": 0, \\\"hstCheck\\\": true, \\\"hstPrice\\\": 0, \\\"isBundle\\\": true, \\\"planname\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"products\\\": [{\\\"id\\\": 32228, \\\"tax\\\": 35.63, \\\"name\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"price\\\": 445.42, \\\"total\\\": 481.05, \\\"version\\\": 43, \\\"coverage\\\": \\\"SINGLE\\\", \\\"planLevel\\\": 18, \\\"productId\\\": 7, \\\"description\\\": \\\" Single\\\", \\\"tax_details\\\": [{\\\"plan_id\\\": 765, \\\"tax_sku\\\": \\\"pstonhealthinsurance\\\", \\\"tax_code\\\": null, \\\"tax_name\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"tax_rate\\\": 0.08, \\\"plan_product_id\\\": 178475, \\\"tax_description\\\": \\\"PST on Health Insurance (#709505879)\\\", \\\"business_tax_number\\\": \\\"709505879\\\"}], \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"calculatedTax\\\": {\\\"tax\\\": 35.63, \\\"price\\\": 445.42, \\\"total\\\": 481.05, \\\"planProductIds\\\": [178475], \\\"planProductInfos\\\": [{\\\"name\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"price\\\": 35.63, \\\"taxRate\\\": 0.08, \\\"isIncluded\\\": true, \\\"description\\\": \\\"PST on Health Insurance (#709505879)\\\", \\\"taxRatePercentage\\\": \\\"8.00%\\\", \\\"planProductUniqueId\\\": 178475}]}, \\\"planProductId\\\": \\\"183848\\\", \\\"bundledProducts\\\": [\\\"Single\\\"], \\\"planLevelParent\\\": 15}], \\\"pstCheck\\\": true, \\\"pstPrice\\\": 0, \\\"qstCheck\\\": true, \\\"qstPrice\\\": 0, \\\"taxPrice\\\": 35.63, \\\"groupName\\\": \\\"Complete Executive Care\\\", \\\"packageId\\\": 5, \\\"planLevel\\\": 18, \\\"planPrice\\\": 445.42, \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": 8, \\\"totalPrice\\\": \\\"481.05\\\", \\\"description\\\": \\\"Health Insurance\\\", \\\"packagename\\\": \\\"Private Health\\\", \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"companyAmount\\\": 445.42, \\\"insuranceType\\\": \\\"HEALTH\\\", \\\"paidByCompany\\\": 1, \\\"planLevelName\\\": \\\"Complete Executive Care\\\", \\\"skuTotalPrice\\\": 481.05, \\\"taxApplicable\\\": true, \\\"categorization\\\": {\\\"paidByCompany\\\": true, \\\"paidByEmployee\\\": false, \\\"coveredByCompany\\\": false}, \\\"employeeAmount\\\": 0, \\\"enrollmentDate\\\": \\\"2025-04-01\\\", \\\"fusebillPlanID\\\": 49875, \\\"paidByCompany1\\\": \\\"32228\\\", \\\"paidByEmployee\\\": 0, \\\"companyAmountUI\\\": \\\"$445.42\\\", \\\"paidByEmployee1\\\": \\\"true\\\", \\\"planFrequencyID\\\": 107062, \\\"planLevelParent\\\": 15, \\\"planproductname\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"coveredByCompany\\\": 0, \\\"employeeAmountUI\\\": \\\"$0\\\", \\\"coveredByCompany1\\\": \\\"18\\\", \\\"planLevel_parentId\\\": \\\"15\\\", \\\"taxDescriptionLine\\\": \\\"PST on Health Insurance (#709505879) 8.00% $35.63 \\\", \\\"disallowedPlanLevels\\\": \\\"17,23,26,31,46\\\", \\\"companyCoveredBasePlan\\\": {\\\"tax\\\": 0, \\\"total\\\": 0, \\\"amount\\\": 0, \\\"planId\\\": 0, \\\"planName\\\": \\\"NA\\\", \\\"planLevelId\\\": 0}}\", \"customer_id\": 2986, \"plan_id\": 773, \"tax_subscription_id\": 6838755, \"customerPlanProducts\": [{\"customerPlanId\": 8134, \"id\": 6263, \"planCoverage\": \"SINGLE\", \"price\": 445.42, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8134, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"Complete Executive Care (60 to 74)\", \"name\": \"Complete Executive Care (60 to 74)\", \"planCode\": \"completeexecutivecare60to74\", \"packageId\": 5}]}}, \"2985\": {\"customerId\": 2985, \"staxbillId\": \"13760705\", \"firstName\": \"Sam\", \"lastName\": \"Chaiton\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 445.42, \"tax\": 35.63, \"total\": 481.05, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $35.63 \"}, \"taxDetailsDB\": {\"pst\": \"35.63\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST ON HEALTH INSURANCE\", \"taxPrice\": \"35.63\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $35.63\", \"tax\": \"35.63\", \"price\": \"445.42\", \"total\": \"481.05\"}, \"taxForPlan\": 35.63, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2025-03-28\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-28 21:55:29\", \"subscriptionId\": \"6838738\", \"price\": 445.42, \"quantity\": 1, \"count\": 1, \"tax\": 35.63, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | \", \"total\": 481.05, \"totalPrice\": 445.42, \"totalTax\": 35.63, \"grandTotal\": 481.05, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (60 to 74)\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2985, \"id\": 8132, \"planId\": 773, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 35.63, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 35.63, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST ON HEALTH INSURANCE\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2973\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6838737\", \"isBulk\": false, \"created\": \"2025-03-28 21:55:29\", \"modified\": \"2025-03-28 21:55:29\", \"misc\": \"{\\\"name\\\": \\\"Complete Executive Care (60 to 74) (Ontario) \\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"description\\\": \\\"Health Insurance 13760705 2985 PST on Health Insurance (#709505879) 8.00% $35.63 \\\"}\", \"planObject\": \"{\\\"id\\\": 773, \\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": 35.63, \\\"qst\\\": 0, \\\"tax\\\": \\\"35.63\\\", \\\"name\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"type\\\": \\\"100% Company Paid\\\", \\\"optIn\\\": false, \\\"taxUI\\\": \\\"<span>-</span><span>-</span><span>-</span><span> -</span>\\\", \\\"total\\\": \\\"481.05\\\", \\\"amount\\\": \\\"445.42\\\", \\\"amounts\\\": {\\\"total\\\": 445.42, \\\"company\\\": 445.42, \\\"employee\\\": 0}, \\\"details\\\": \\\"Private Health\\\", \\\"options\\\": [], \\\"taxName\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"totalUI\\\": \\\"$481.05\\\", \\\"version\\\": 43, \\\"amountUI\\\": \\\"$445.42\\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"gstCheck\\\": true, \\\"gstPrice\\\": 0, \\\"hstCheck\\\": true, \\\"hstPrice\\\": 0, \\\"isBundle\\\": true, \\\"planname\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"products\\\": [{\\\"id\\\": 32228, \\\"tax\\\": 35.63, \\\"name\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"price\\\": 445.42, \\\"total\\\": 481.05, \\\"version\\\": 43, \\\"coverage\\\": \\\"SINGLE\\\", \\\"planLevel\\\": 18, \\\"productId\\\": 7, \\\"description\\\": \\\" Single\\\", \\\"tax_details\\\": [{\\\"plan_id\\\": 765, \\\"tax_sku\\\": \\\"pstonhealthinsurance\\\", \\\"tax_code\\\": null, \\\"tax_name\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"tax_rate\\\": 0.08, \\\"plan_product_id\\\": 178475, \\\"tax_description\\\": \\\"PST on Health Insurance (#709505879)\\\", \\\"business_tax_number\\\": \\\"709505879\\\"}], \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"calculatedTax\\\": {\\\"tax\\\": 35.63, \\\"price\\\": 445.42, \\\"total\\\": 481.05, \\\"planProductIds\\\": [178475], \\\"planProductInfos\\\": [{\\\"name\\\": \\\"PST ON HEALTH INSURANCE\\\", \\\"price\\\": 35.63, \\\"taxRate\\\": 0.08, \\\"isIncluded\\\": true, \\\"description\\\": \\\"PST on Health Insurance (#709505879)\\\", \\\"taxRatePercentage\\\": \\\"8.00%\\\", \\\"planProductUniqueId\\\": 178475}]}, \\\"planProductId\\\": \\\"183848\\\", \\\"bundledProducts\\\": [\\\"Single\\\"], \\\"planLevelParent\\\": 15}], \\\"pstCheck\\\": true, \\\"pstPrice\\\": 0, \\\"qstCheck\\\": true, \\\"qstPrice\\\": 0, \\\"taxPrice\\\": 35.63, \\\"groupName\\\": \\\"Complete Executive Care\\\", \\\"packageId\\\": 5, \\\"planLevel\\\": 18, \\\"planPrice\\\": 445.42, \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": 8, \\\"totalPrice\\\": \\\"481.05\\\", \\\"description\\\": \\\"Health Insurance\\\", \\\"packagename\\\": \\\"Private Health\\\", \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"companyAmount\\\": 445.42, \\\"insuranceType\\\": \\\"HEALTH\\\", \\\"paidByCompany\\\": 1, \\\"planLevelName\\\": \\\"Complete Executive Care\\\", \\\"skuTotalPrice\\\": 481.05, \\\"taxApplicable\\\": true, \\\"categorization\\\": {\\\"paidByCompany\\\": true, \\\"paidByEmployee\\\": false, \\\"coveredByCompany\\\": false}, \\\"employeeAmount\\\": 0, \\\"enrollmentDate\\\": \\\"2025-04-01\\\", \\\"fusebillPlanID\\\": 49875, \\\"paidByCompany1\\\": \\\"32228\\\", \\\"paidByEmployee\\\": 0, \\\"companyAmountUI\\\": \\\"$445.42\\\", \\\"paidByEmployee1\\\": \\\"true\\\", \\\"planFrequencyID\\\": 107062, \\\"planLevelParent\\\": 15, \\\"planproductname\\\": \\\"Complete Executive Care (60 to 74)\\\", \\\"coveredByCompany\\\": 0, \\\"employeeAmountUI\\\": \\\"$0\\\", \\\"coveredByCompany1\\\": \\\"18\\\", \\\"planLevel_parentId\\\": \\\"15\\\", \\\"taxDescriptionLine\\\": \\\"PST on Health Insurance (#709505879) 8.00% $35.63 \\\", \\\"disallowedPlanLevels\\\": \\\"17,23,26,31,46\\\", \\\"companyCoveredBasePlan\\\": {\\\"tax\\\": 0, \\\"total\\\": 0, \\\"amount\\\": 0, \\\"planId\\\": 0, \\\"planName\\\": \\\"NA\\\", \\\"planLevelId\\\": 0}}\", \"customer_id\": 2985, \"plan_id\": 773, \"tax_subscription_id\": 6838737, \"customerPlanProducts\": [{\"customerPlanId\": 8132, \"id\": 6261, \"planCoverage\": \"SINGLE\", \"price\": 445.42, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8132, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"Complete Executive Care (60 to 74)\", \"name\": \"Complete Executive Care (60 to 74)\", \"planCode\": \"completeexecutivecare60to74\", \"packageId\": 5}]}}}",
                "lastInvoiceAmount": 962.1,
                "invoicePaymentDate": "2025-05-01",
                "lastInvoicePayment": 0,
                "contact_information": "{\"stateId\": 12, \"workingProvinceId\": 12, \"state\": \"ON\", \"workingProvince\": \"ON\"}",
                "handleInvoiceHistory": true
            },
            "filename": "25-05-0349.pdf",
            "customer_id": 2973,
            "customerObj": {
                "brokerId": 683,
                "ccExpiry": null,
                "ccExpiryAlertSent": null,
                "companyId": null,
                "companyName": "Glowing Investments Inc.",
                "deleted": null,
                "dob": null,
                "equitableCertificateId": null,
                "equitableRegistrationStatus": null,
                "firstName": "Lindy",
                "fusebillCustomerId": "13757999",
                "fusebillPaymentId": null,
                "gender": "Undisclosed",
                "greenshieldMemberId": null,
                "greenshieldRegistrationStatus": null,
                "groupId": null,
                "id": 2973,
                "isCorporateAccount": true,
                "lastName": "Green",
                "maritalStatus": null,
                "middleName": null,
                "provincialHealthcardName": null,
                "terminationReason": null,
                "terminationDate": null,
                "reinstatementReason": null,
                "reinstatementDate": null,
                "jobTitle": null,
                "monthlyRecurringRevenue": 0,
                "parentId": null,
                "paymentMethod": "ACH",
                "paymentMethodId": "",
                "paymentMethodName": null,
                "registrationDate": "Tue May 06 2025 00:00:00 GMT+0530 (India Standard Time)",
                "backdatedRegistrationDate": null,
                "signature": "data:image/png;base64,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",
                "status": "Active",
                "uniqueSinId": null,
                "userId": null,
                "spendingLimit": null,
                "annualIncome": null,
                "dateOfHiring": null,
                "assignerTier": null,
                "actualTier": null,
                "employeeId": null,
                "billAsCorporate": null,
                "cancellationDate": null,
                "backdatedCancellationDate": null,
                "lockdocsUserId": null,
                "valisignUserId": null,
                "bulkPlanIncluded": false,
                "userName": "lindy_002973",
                "customData": null,
                "user_id": null,
                "parent_id": null,
                "broker_id": 683,
                "actual_tier": null,
                "broker": {
                    "id": 683,
                    "brokerType": "CORPORATE",
                    "contactId": 8215,
                    "deleted": null,
                    "description": null,
                    "discoverable": false,
                    "fusebillCorporateCustomerId": "13757999",
                    "link": null,
                    "logo": null,
                    "disclosureAgreement": null,
                    "termsAndConditions": null,
                    "name": "Glowing Investments Inc.",
                    "parentId": 74,
                    "policyStartDate": "2025-03-31T18:30:00.000Z",
                    "published": true,
                    "salesTrackingCode": "0000000040",
                    "salesTrackingType": "Plan Commission",
                    "settingsAllowGroupBenefitsWallet": 0,
                    "settingsGroupBenefitzWalletType": null,
                    "settingsAllowInvoicePaymentMethod": 0,
                    "settingsEnableTieredHealthBenefits": 0,
                    "settingsHealthSpendingAccount": null,
                    "settingsHealthSpendingAllotment": null,
                    "settingsRolloverEmployeeLimitNextYear": 0,
                    "settingsRolloverUnusedWalletFunds": null,
                    "uniqueId": null,
                    "subdomain": "glowinginvestments",
                    "useCreditCardPaymentMethod": false,
                    "useInvoicePaymentMethod": false,
                    "usePadPaymentMethod": true,
                    "userId": 2678,
                    "waitTime": 0,
                    "settingsEnableLengthOfServiceTiers": null,
                    "settingsEnableAnnualIncomeTiers": null,
                    "expectedEmployeesCount": 2,
                    "payrollDeduction": null,
                    "corporateEmployeeWaittimeOverride": null,
                    "corporateAutoPlanSelection": false,
                    "corporatePlanSelectionLocked": true,
                    "corporateWorkingProvinces": "[12]",
                    "corporateEmployeesInitialSignupWaittime": false,
                    "paymentMethod": "ACH",
                    "paymentMethodId": "",
                    "shared": false,
                    "customData": "{}",
                    "contact_id": 8215,
                    "parent_id": 74,
                    "user_id": 2678
                }
            }
        },
        {
            "id": 5012,
            "invoiceNumber": "25-05-3810",
            "customerId": 2890,
            "fusebillCustomerId": "13735639",
            "invoiceDate": "2025-04-30T18:30:00.000Z",
            "dueDate": "2025-04-30T18:30:00.000Z",
            "status": "OVERDUE",
            "invoiceAmount": 163.69,
            "paymentId": null,
            "paymentInfo": null,
            "invoiceHistory": null,
            "amountPaid": 0,
            "paymentFailureCount": null,
            "paymentDate": null,
            "paymentType": "CREDIT CARD",
            "paymentStatus": null,
            "reference": null,
            "created": "2025-05-01T07:46:33.000Z",
            "modified": "2025-05-22T02:46:17.000Z",
            "taxInformation": {
                "overall_taxes": {
                    "Total": 0
                },
                "individual_taxes": {
                    "2890": {
                        "plans": {
                            "taxes": []
                        },
                        "lastName": "Beatty",
                        "firstName": "Jenny",
                        "customerId": 2890,
                        "staxbillId": "13735639"
                    },
                    "2965": {
                        "plans": {
                            "taxes": []
                        },
                        "lastName": "Beatty",
                        "firstName": "Jenny",
                        "customerId": 2965,
                        "staxbillId": "13754109"
                    }
                }
            },
            "contactInformation": {
                "state": "British Columbia",
                "stateId": 14,
                "workingProvince": "British Columbia",
                "workingProvinceId": 14
            },
            "planInformation": {
                "2890": {
                    "plans": {
                        "subscriptions": []
                    },
                    "lastName": "Beatty",
                    "firstName": "Jenny",
                    "customerId": 2890,
                    "staxbillId": "13735639"
                },
                "2965": {
                    "plans": {
                        "subscriptions": [
                            {
                                "id": 8098,
                                "gst": null,
                                "hst": null,
                                "pst": null,
                                "qst": null,
                                "tax": 0,
                                "misc": "{\"name\": \"Classic Silver (British Columbia) \", \"coverage\": \"SINGLE\", \"description\": \"Health & Dental Insurance 13754109 2965 \"}",
                                "name": "Classic Silver",
                                "type": "100% Company Paid",
                                "count": 1,
                                "price": 163.69,
                                "scope": null,
                                "total": 163.69,
                                "isBulk": false,
                                "planId": 781,
                                "status": "Active",
                                "tierId": null,
                                "created": "2025-03-24 22:13:44",
                                "plan_id": 781,
                                "stateId": 14,
                                "summary": null,
                                "taxCode": null,
                                "taxName": null,
                                "version": 43,
                                "coverage": "SINGLE",
                                "modified": "2025-04-02 19:40:51",
                                "parentId": "2890",
                                "planCode": "classicsilver",
                                "planName": "Classic Silver",
                                "quantity": 1,
                                "taxPrice": 0,
                                "totalTax": 0,
                                "coverage1": "Single ",
                                "packageId": 1,
                                "customerId": 2965,
                                "grandTotal": 163.69,
                                "gstTaxRate": null,
                                "hstTaxRate": null,
                                "planObject": "{\"id\": 781, \"gst\": null, \"hst\": null, \"pst\": null, \"qst\": 0, \"tax\": \"0.00\", \"name\": \"Classic Silver\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"163.69\", \"amount\": \"163.69\", \"amounts\": {\"total\": 163.69, \"company\": 163.69, \"employee\": 0}, \"details\": \"Health & Dental Insurance\", \"options\": [], \"totalUI\": \"$163.69\", \"version\": 43, \"amountUI\": \"$163.69\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Classic Silver\", \"products\": [{\"id\": 31372, \"tax\": 0, \"name\": \"Classic Silver\", \"price\": 163.69, \"total\": 163.69, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 4, \"productId\": 28, \"description\": \" Single Gig\", \"tax_details\": [], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 0, \"price\": 163.69, \"total\": 163.69, \"planProductIds\": [], \"planProductInfos\": []}, \"planProductId\": \"183820\", \"bundledProducts\": [\"Single Gig\"], \"planLevelParent\": 1}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": null, \"groupName\": \"Classic Silver\", \"packageId\": 1, \"planLevel\": 4, \"planPrice\": 163.69, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": null, \"totalPrice\": \"163.69\", \"description\": \"Health & Dental Insurance\", \"packagename\": \"Health & Dental Insurance\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 163.69, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Classic Silver\", \"skuTotalPrice\": 163.69, \"taxApplicable\": false, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49867, \"paidByCompany1\": \"31372\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$163.69\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107054, \"planLevelParent\": 1, \"planproductname\": \"Classic Silver\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"4\", \"planLevel_parentId\": \"1\", \"taxDescriptionLine\": \"\", \"disallowedPlanLevels\": \"53,54,55\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                "pstTaxRate": null,
                                "qstTaxRate": null,
                                "signupDate": "2025-04-02",
                                "taxDetails": {
                                    "tax": 0,
                                    "price": 163.69,
                                    "total": 163.69,
                                    "taxDescriptionLine": ""
                                },
                                "taxForPlan": 0,
                                "totalPrice": 163.69,
                                "createdDate": "2025-03-24 22:13:44",
                                "customer_id": 2965,
                                "enrolledDate": "2025-04-01",
                                "taxDetailsDB": {
                                    "gst": "0.00",
                                    "hst": "0.00",
                                    "pst": "0.00",
                                    "tax": "0.00",
                                    "price": "163.69",
                                    "total": "163.69",
                                    "taxName": null,
                                    "taxPrice": "0.00",
                                    "gstTaxRate": "0.00",
                                    "hstTaxRate": "0.00",
                                    "pstTaxRate": "0.00",
                                    "taxDescriptionLine": ""
                                },
                                "taxStatement": "",
                                "bulkPlanLevel": null,
                                "paidByCompany": 1,
                                "taxStatement1": "",
                                "activationDate": "2025-04-01 04:00:00",
                                "paidByEmployee": null,
                                "subscriptionId": "6831983",
                                "workingStateId": 14,
                                "bundledProducts": [
                                    "Classic Silver"
                                ],
                                "lastBillingDate": null,
                                "nextBillingDate": null,
                                "terminationDate": null,
                                "cancellationDate": null,
                                "coveredByCompany": null,
                                "nextBillingPrice": null,
                                "restrictedAccess": null,
                                "isSubscriptionTax": false,
                                "reinstatementDate": null,
                                "taxSubscriptionId": null,
                                "terminationReason": null,
                                "reinstatementReason": null,
                                "tax_subscription_id": null,
                                "aitestproExecutionId": 17635,
                                "customerPlanProducts": [
                                    {
                                        "id": 6229,
                                        "price": 163.69,
                                        "taxSku": null,
                                        "product": {
                                            "id": 28,
                                            "code": "singlegig",
                                            "data": "{\"additional_instructions\": []}",
                                            "logo": null,
                                            "name": "Single Gig",
                                            "color": null,
                                            "price": null,
                                            "glCode": "73210",
                                            "display": "TITLE",
                                            "published": true,
                                            "fusebillId": "127790",
                                            "backgroundColor": null,
                                            "includedProducts": null
                                        },
                                        "taxCode": null,
                                        "taxName": null,
                                        "version": 43,
                                        "productId": 28,
                                        "product_id": 28,
                                        "planCoverage": "SINGLE",
                                        "customerPlanId": 8098,
                                        "customer_plan_id": 8098
                                    }
                                ],
                                "backdatedActivationDate": null,
                                "backdatedCancellationDate": null
                            }
                        ]
                    },
                    "lastName": "Beatty",
                    "firstName": "Jenny",
                    "customerId": 2965,
                    "staxbillId": "13754109"
                }
            },
            "invoiceObject": {
                "id": 2890,
                "logo": "https://api-admin.groupbenefitz.net/api/ap/app/resources/images/gb_logo_long.png",
                "note": "",
                "email": "jenny@htfchiro.com",
                "plans": {
                    "taxes": [],
                    "subscriptions": []
                },
                "taxes": {},
                "total": 163.69,
                "credit": 0,
                "status": "Active",
                "address": {
                    "id": 7963,
                    "apt": "",
                    "city": "Vancouver",
                    "line1": "2465 Selkirk Dr",
                    "line2": "",
                    "state": "British Columbia",
                    "country": "Canada",
                    "stateId": 14,
                    "countryId": 1,
                    "fusebillId": null,
                    "postalCode": "V1V2R7",
                    "addressType": "OFFICE_ADDRESS",
                    "contactType": "COMPANY",
                    "primaryEmail": "jenny@htfchiro.com",
                    "primaryPhone": "+1 (250) 520-0049",
                    "secondaryEmail": null,
                    "secondaryPhone": null
                },
                "arrears": 0,
                "baMails": [
                    "jenny@htfchiro.com"
                ],
                "ciMails": [],
                "version": "gb7.0.0",
                "fileName": "Invoice_13735639_2025-05-01_25-05-3810_POST",
                "filePath": "/var/www/vhosts/api-common.groupbenefitz.net/public/server/MemberInvoices/",
                "fontSize": "8",
                "lastName": "Beatty",
                "logoPath": "/var/www/vhosts/api-common.groupbenefitz.net/public/resources/images/gb_logo_long.png",
                "subtotal": 163.69,
                "firstName": "Jenny",
                "invoiceNo": "25-05-3810",
                "customerId": 2890,
                "staxbillId": "13735639",
                "accountType": "parent",
                "companyName": "Healing Touch Family Chiropractic",
                "environment": "production",
                "generatePDF": true,
                "invoiceDate": "2025-05",
                "isCorporate": true,
                "paymentType": "CREDIT CARD",
                "employeeList": [
                    {
                        "id": 2965,
                        "note": "Changing subscription plan state from 14 - to 14",
                        "email": "jennifer@sacredandclear.com",
                        "plans": {
                            "taxes": [],
                            "subscriptions": [
                                {
                                    "id": 8098,
                                    "gst": null,
                                    "hst": null,
                                    "pst": null,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": "{\"name\": \"Classic Silver (British Columbia) \", \"coverage\": \"SINGLE\", \"description\": \"Health & Dental Insurance 13754109 2965 \"}",
                                    "name": "Classic Silver",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 163.69,
                                    "scope": null,
                                    "total": 163.69,
                                    "isBulk": false,
                                    "planId": 781,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2025-03-24 22:13:44",
                                    "plan_id": 781,
                                    "stateId": 14,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": null,
                                    "version": 43,
                                    "coverage": "SINGLE",
                                    "modified": "2025-04-02 19:40:51",
                                    "parentId": "2890",
                                    "planCode": "classicsilver",
                                    "planName": "Classic Silver",
                                    "quantity": 1,
                                    "taxPrice": 0,
                                    "totalTax": 0,
                                    "coverage1": "Single ",
                                    "packageId": 1,
                                    "customerId": 2965,
                                    "grandTotal": 163.69,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": "{\"id\": 781, \"gst\": null, \"hst\": null, \"pst\": null, \"qst\": 0, \"tax\": \"0.00\", \"name\": \"Classic Silver\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"163.69\", \"amount\": \"163.69\", \"amounts\": {\"total\": 163.69, \"company\": 163.69, \"employee\": 0}, \"details\": \"Health & Dental Insurance\", \"options\": [], \"totalUI\": \"$163.69\", \"version\": 43, \"amountUI\": \"$163.69\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Classic Silver\", \"products\": [{\"id\": 31372, \"tax\": 0, \"name\": \"Classic Silver\", \"price\": 163.69, \"total\": 163.69, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 4, \"productId\": 28, \"description\": \" Single Gig\", \"tax_details\": [], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 0, \"price\": 163.69, \"total\": 163.69, \"planProductIds\": [], \"planProductInfos\": []}, \"planProductId\": \"183820\", \"bundledProducts\": [\"Single Gig\"], \"planLevelParent\": 1}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": null, \"groupName\": \"Classic Silver\", \"packageId\": 1, \"planLevel\": 4, \"planPrice\": 163.69, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": null, \"totalPrice\": \"163.69\", \"description\": \"Health & Dental Insurance\", \"packagename\": \"Health & Dental Insurance\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 163.69, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Classic Silver\", \"skuTotalPrice\": 163.69, \"taxApplicable\": false, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49867, \"paidByCompany1\": \"31372\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$163.69\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107054, \"planLevelParent\": 1, \"planproductname\": \"Classic Silver\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"4\", \"planLevel_parentId\": \"1\", \"taxDescriptionLine\": \"\", \"disallowedPlanLevels\": \"53,54,55\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                    "pstTaxRate": null,
                                    "qstTaxRate": null,
                                    "signupDate": "2025-04-02",
                                    "taxDetails": {
                                        "tax": 0,
                                        "price": 163.69,
                                        "total": 163.69,
                                        "taxDescriptionLine": ""
                                    },
                                    "taxForPlan": 0,
                                    "totalPrice": 163.69,
                                    "createdDate": "2025-03-24 22:13:44",
                                    "customer_id": 2965,
                                    "enrolledDate": "2025-04-01",
                                    "taxDetailsDB": {
                                        "gst": "0.00",
                                        "hst": "0.00",
                                        "pst": "0.00",
                                        "tax": "0.00",
                                        "price": "163.69",
                                        "total": "163.69",
                                        "taxName": null,
                                        "taxPrice": "0.00",
                                        "gstTaxRate": "0.00",
                                        "hstTaxRate": "0.00",
                                        "pstTaxRate": "0.00",
                                        "taxDescriptionLine": ""
                                    },
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2025-04-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6831983",
                                    "workingStateId": 14,
                                    "bundledProducts": [
                                        "Classic Silver"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": false,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 17635,
                                    "customerPlanProducts": [
                                        {
                                            "id": 6229,
                                            "price": 163.69,
                                            "taxSku": null,
                                            "product": {
                                                "id": 28,
                                                "code": "singlegig",
                                                "data": "{\"additional_instructions\": []}",
                                                "logo": null,
                                                "name": "Single Gig",
                                                "color": null,
                                                "price": null,
                                                "glCode": "73210",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "127790",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "productId": 28,
                                            "product_id": 28,
                                            "planCoverage": "SINGLE",
                                            "customerPlanId": 8098,
                                            "customer_plan_id": 8098
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "address": {
                            "id": 8186,
                            "apt": "",
                            "city": "Kelowna",
                            "line1": "2465 Selkirk Drive",
                            "line2": "",
                            "state": "BC",
                            "country": "Canada",
                            "stateId": 14,
                            "countryId": 1,
                            "fusebillId": null,
                            "postalCode": "V1V 2R7",
                            "addressType": "HOME_ADDRESS",
                            "contactType": "CUSTOMER",
                            "primaryEmail": "jennifer@sacredandclear.com",
                            "primaryPhone": "+1 (250) 520-0049",
                            "secondaryEmail": null,
                            "secondaryPhone": null
                        },
                        "lastName": "Beatty",
                        "firstName": "Jenny",
                        "customerId": 2965,
                        "staxbillId": "13754109",
                        "accountType": "child",
                        "companyName": "Healing Touch Family Chiropractic",
                        "isCorporate": true,
                        "paymentType": "CREDIT CARD",
                        "employerName": "",
                        "pastInvoices": [],
                        "invoiceAmount": 163.69,
                        "invoiceAmountEP": 0,
                        "workingProvince": "British Columbia",
                        "workingProvinceId": 14
                    }
                ],
                "employerName": "",
                "invoiceDate2": "2025-05-01",
                "pastInvoices": [
                    {
                        "id": 4633,
                        "status": "PAID",
                        "created": "2025-04-04 13:17:35",
                        "dueDate": "2025-04-01",
                        "modified": "2025-04-30 09:25:02",
                        "paymentId": null,
                        "reference": null,
                        "amountPaid": 163.69,
                        "customerId": 2890,
                        "customer_id": 2890,
                        "invoiceDate": "2025-04-01",
                        "paymentDate": null,
                        "paymentInfo": null,
                        "paymentType": "CREDIT CARD",
                        "invoiceAmount": 163.69,
                        "invoiceNumber": "25-04-4740",
                        "invoiceObject": {
                            "id": 2890,
                            "logo": "https://api-admin.groupbenefitz.net/api/ap/app/resources/images/gb_logo_long.png",
                            "note": "",
                            "email": "jenny@htfchiro.com",
                            "plans": {
                                "taxes": [],
                                "subscriptions": []
                            },
                            "taxes": {},
                            "total": 163.69,
                            "credit": 0,
                            "status": "Active",
                            "address": {
                                "id": 7963,
                                "apt": "",
                                "city": "Vancouver",
                                "line1": "2465 Selkirk Dr",
                                "line2": "",
                                "state": "British Columbia",
                                "country": "Canada",
                                "stateId": 14,
                                "countryId": 1,
                                "fusebillId": null,
                                "postalCode": "V1V2R7",
                                "addressType": "OFFICE_ADDRESS",
                                "contactType": "COMPANY",
                                "primaryEmail": "jenny@htfchiro.com",
                                "primaryPhone": "+1 (250) 520-0049",
                                "secondaryEmail": null,
                                "secondaryPhone": null
                            },
                            "arrears": 0,
                            "baMails": [
                                "jenny@htfchiro.com"
                            ],
                            "ciMails": [],
                            "version": "gb7.0.0",
                            "fileName": "Invoice_13735639_2025-04-01_25-04-4740_POST",
                            "filePath": "/var/www/vhosts/api-common.groupbenefitz.net/public/server/MemberInvoices/",
                            "fontSize": "8",
                            "lastName": "Beatty",
                            "logoPath": "/var/www/vhosts/api-common.groupbenefitz.net/public/resources/images/gb_logo_long.png",
                            "subtotal": 163.69,
                            "firstName": "Jenny",
                            "invoiceNo": "25-04-4740",
                            "customerId": 2890,
                            "staxbillId": "13735639",
                            "accountType": "parent",
                            "companyName": "Healing Touch Family Chiropractic",
                            "environment": "production",
                            "generatePDF": true,
                            "invoiceDate": "2025-04",
                            "isCorporate": true,
                            "paymentType": "CREDIT CARD",
                            "employeeList": [
                                {
                                    "id": 2965,
                                    "note": "Changing subscription plan state from 14 - to 14",
                                    "email": "jennifer@sacredandclear.com",
                                    "plans": {
                                        "taxes": [],
                                        "subscriptions": [
                                            {
                                                "id": 8098,
                                                "gst": null,
                                                "hst": null,
                                                "pst": null,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": "{\"name\": \"Classic Silver (British Columbia) \", \"coverage\": \"SINGLE\", \"description\": \"Health & Dental Insurance 13754109 2965 \"}",
                                                "name": "Classic Silver",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 163.69,
                                                "scope": null,
                                                "total": 163.69,
                                                "isBulk": false,
                                                "planId": 781,
                                                "status": "Active",
                                                "created": "2025-03-24 22:13:44",
                                                "plan_id": 781,
                                                "stateId": 14,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": null,
                                                "version": 43,
                                                "coverage": "SINGLE",
                                                "modified": "2025-04-02 19:40:51",
                                                "parentId": "2890",
                                                "planCode": "classicsilver",
                                                "planName": "Classic Silver",
                                                "quantity": 1,
                                                "taxPrice": 0,
                                                "totalTax": 0,
                                                "coverage1": "Single ",
                                                "packageId": 1,
                                                "customerId": 2965,
                                                "grandTotal": 163.69,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": "{\"id\": 781, \"gst\": null, \"hst\": null, \"pst\": null, \"qst\": 0, \"tax\": \"0.00\", \"name\": \"Classic Silver\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"163.69\", \"amount\": \"163.69\", \"amounts\": {\"total\": 163.69, \"company\": 163.69, \"employee\": 0}, \"details\": \"Health & Dental Insurance\", \"options\": [], \"totalUI\": \"$163.69\", \"version\": 43, \"amountUI\": \"$163.69\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Classic Silver\", \"products\": [{\"id\": 31372, \"tax\": 0, \"name\": \"Classic Silver\", \"price\": 163.69, \"total\": 163.69, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 4, \"productId\": 28, \"description\": \" Single Gig\", \"tax_details\": [], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 0, \"price\": 163.69, \"total\": 163.69, \"planProductIds\": [], \"planProductInfos\": []}, \"planProductId\": \"183820\", \"bundledProducts\": [\"Single Gig\"], \"planLevelParent\": 1}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": null, \"groupName\": \"Classic Silver\", \"packageId\": 1, \"planLevel\": 4, \"planPrice\": 163.69, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": null, \"totalPrice\": \"163.69\", \"description\": \"Health & Dental Insurance\", \"packagename\": \"Health & Dental Insurance\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 163.69, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Classic Silver\", \"skuTotalPrice\": 163.69, \"taxApplicable\": false, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49867, \"paidByCompany1\": \"31372\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$163.69\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107054, \"planLevelParent\": 1, \"planproductname\": \"Classic Silver\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"4\", \"planLevel_parentId\": \"1\", \"taxDescriptionLine\": \"\", \"disallowedPlanLevels\": \"53,54,55\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                                "pstTaxRate": null,
                                                "qstTaxRate": null,
                                                "signupDate": "2025-04-02",
                                                "taxDetails": {
                                                    "tax": 0,
                                                    "price": 163.69,
                                                    "total": 163.69,
                                                    "taxDescriptionLine": ""
                                                },
                                                "taxForPlan": 0,
                                                "totalPrice": 163.69,
                                                "createdDate": "2025-03-24 22:13:44",
                                                "customer_id": 2965,
                                                "enrolledDate": "2025-04-01",
                                                "taxDetailsDB": {
                                                    "gst": "0.00",
                                                    "hst": "0.00",
                                                    "pst": "0.00",
                                                    "tax": "0.00",
                                                    "price": "163.69",
                                                    "total": "163.69",
                                                    "taxName": null,
                                                    "taxPrice": "0.00",
                                                    "gstTaxRate": "0.00",
                                                    "hstTaxRate": "0.00",
                                                    "pstTaxRate": "0.00",
                                                    "taxDescriptionLine": ""
                                                },
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2025-04-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6831983",
                                                "workingStateId": 14,
                                                "bundledProducts": [
                                                    "Classic Silver"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": false,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 17635,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 6229,
                                                        "price": 163.69,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 28,
                                                            "code": "singlegig",
                                                            "data": "{\"additional_instructions\": []}",
                                                            "logo": null,
                                                            "name": "Single Gig",
                                                            "color": null,
                                                            "price": null,
                                                            "glCode": "73210",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "127790",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": 43,
                                                        "productId": 28,
                                                        "product_id": 28,
                                                        "planCoverage": "SINGLE",
                                                        "customerPlanId": 8098,
                                                        "customer_plan_id": 8098
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "address": {
                                        "id": 8186,
                                        "apt": "",
                                        "city": "Kelowna",
                                        "line1": "2465 Selkirk Drive",
                                        "line2": "",
                                        "state": "BC",
                                        "country": "Canada",
                                        "stateId": 14,
                                        "countryId": 1,
                                        "fusebillId": null,
                                        "postalCode": "V1V 2R7",
                                        "addressType": "HOME_ADDRESS",
                                        "contactType": "CUSTOMER",
                                        "primaryEmail": "jennifer@sacredandclear.com",
                                        "primaryPhone": "+1 (250) 520-0049",
                                        "secondaryEmail": null,
                                        "secondaryPhone": null
                                    },
                                    "lastName": "Beatty",
                                    "firstName": "Jenny",
                                    "customerId": 2965,
                                    "staxbillId": "13754109",
                                    "accountType": "child",
                                    "companyName": "Healing Touch Family Chiropractic",
                                    "isCorporate": true,
                                    "paymentType": "CREDIT CARD",
                                    "employerName": "",
                                    "pastInvoices": [],
                                    "invoiceAmount": 163.69,
                                    "invoiceAmountEP": 0,
                                    "workingProvince": "British Columbia",
                                    "workingProvinceId": 14
                                }
                            ],
                            "employerName": "",
                            "invoiceDate2": "2025-04-01",
                            "pastInvoices": [],
                            "invoiceAmount": 163.69,
                            "invoiceStatus": "POST",
                            "lastInvoiceNo": "-",
                            "overall_taxes": {
                                "Total": 0
                            },
                            "displayVersion": true,
                            "havingBulkPlan": false,
                            "havingEmployees": true,
                            "lastInvoiceDate": null,
                            "previousInvoice": false,
                            "tax_information": "{\"individual_taxes\": {\"2890\": {\"customerId\": 2890, \"staxbillId\": \"13735639\", \"firstName\": \"Jenny\", \"lastName\": \"Beatty\", \"plans\": {\"taxes\": []}}, \"2965\": {\"customerId\": 2965, \"staxbillId\": \"13754109\", \"firstName\": \"Jenny\", \"lastName\": \"Beatty\", \"plans\": {\"taxes\": []}}}, \"overall_taxes\": {\"Total\": 0}}",
                            "individual_taxes": {
                                "2890": {
                                    "plans": {
                                        "taxes": []
                                    },
                                    "lastName": "Beatty",
                                    "firstName": "Jenny",
                                    "customerId": 2890,
                                    "staxbillId": "13735639"
                                },
                                "2965": {
                                    "plans": {
                                        "taxes": []
                                    },
                                    "lastName": "Beatty",
                                    "firstName": "Jenny",
                                    "customerId": 2965,
                                    "staxbillId": "13754109"
                                }
                            },
                            "plan_information": "{\"2890\": {\"customerId\": 2890, \"staxbillId\": \"13735639\", \"firstName\": \"Jenny\", \"lastName\": \"Beatty\", \"plans\": {\"subscriptions\": []}}, \"2965\": {\"customerId\": 2965, \"staxbillId\": \"13754109\", \"firstName\": \"Jenny\", \"lastName\": \"Beatty\", \"plans\": {\"subscriptions\": [{\"stateId\": 14, \"workingStateId\": 14, \"taxDetails\": {\"price\": 163.69, \"tax\": 0, \"total\": 163.69, \"taxDescriptionLine\": \"\"}, \"taxDetailsDB\": {\"pst\": \"0.00\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"0.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": null, \"taxPrice\": \"0.00\", \"taxDescriptionLine\": \"\", \"tax\": \"0.00\", \"price\": \"163.69\", \"total\": \"163.69\"}, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"Single \", \"signupDate\": \"2025-04-02\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-24 22:13:44\", \"subscriptionId\": \"6831983\", \"price\": 163.69, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 163.69, \"totalPrice\": 163.69, \"totalTax\": 0, \"grandTotal\": 163.69, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"Classic Silver\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2965, \"id\": 8098, \"planId\": 781, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": null, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": null, \"qstTaxRate\": null, \"taxPrice\": 0, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": null, \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 17635, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2890\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2025-03-24 22:13:44\", \"modified\": \"2025-04-02 19:40:51\", \"misc\": \"{\\\"name\\\": \\\"Classic Silver (British Columbia) \\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"description\\\": \\\"Health & Dental Insurance 13754109 2965 \\\"}\", \"planObject\": \"{\\\"id\\\": 781, \\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": null, \\\"qst\\\": 0, \\\"tax\\\": \\\"0.00\\\", \\\"name\\\": \\\"Classic Silver\\\", \\\"type\\\": \\\"100% Company Paid\\\", \\\"optIn\\\": false, \\\"taxUI\\\": \\\"<span>-</span><span>-</span><span>-</span><span> -</span>\\\", \\\"total\\\": \\\"163.69\\\", \\\"amount\\\": \\\"163.69\\\", \\\"amounts\\\": {\\\"total\\\": 163.69, \\\"company\\\": 163.69, \\\"employee\\\": 0}, \\\"details\\\": \\\"Health & Dental Insurance\\\", \\\"options\\\": [], \\\"totalUI\\\": \\\"$163.69\\\", \\\"version\\\": 43, \\\"amountUI\\\": \\\"$163.69\\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"gstCheck\\\": true, \\\"gstPrice\\\": 0, \\\"hstCheck\\\": true, \\\"hstPrice\\\": 0, \\\"isBundle\\\": true, \\\"planname\\\": \\\"Classic Silver\\\", \\\"products\\\": [{\\\"id\\\": 31372, \\\"tax\\\": 0, \\\"name\\\": \\\"Classic Silver\\\", \\\"price\\\": 163.69, \\\"total\\\": 163.69, \\\"version\\\": 43, \\\"coverage\\\": \\\"SINGLE\\\", \\\"planLevel\\\": 4, \\\"productId\\\": 28, \\\"description\\\": \\\" Single Gig\\\", \\\"tax_details\\\": [], \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"calculatedTax\\\": {\\\"tax\\\": 0, \\\"price\\\": 163.69, \\\"total\\\": 163.69, \\\"planProductIds\\\": [], \\\"planProductInfos\\\": []}, \\\"planProductId\\\": \\\"183820\\\", \\\"bundledProducts\\\": [\\\"Single Gig\\\"], \\\"planLevelParent\\\": 1}], \\\"pstCheck\\\": true, \\\"pstPrice\\\": 0, \\\"qstCheck\\\": true, \\\"qstPrice\\\": 0, \\\"taxPrice\\\": null, \\\"groupName\\\": \\\"Classic Silver\\\", \\\"packageId\\\": 1, \\\"planLevel\\\": 4, \\\"planPrice\\\": 163.69, \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": null, \\\"totalPrice\\\": \\\"163.69\\\", \\\"description\\\": \\\"Health & Dental Insurance\\\", \\\"packagename\\\": \\\"Health & Dental Insurance\\\", \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"companyAmount\\\": 163.69, \\\"insuranceType\\\": \\\"HEALTH\\\", \\\"paidByCompany\\\": 1, \\\"planLevelName\\\": \\\"Classic Silver\\\", \\\"skuTotalPrice\\\": 163.69, \\\"taxApplicable\\\": false, \\\"categorization\\\": {\\\"paidByCompany\\\": true, \\\"paidByEmployee\\\": false, \\\"coveredByCompany\\\": false}, \\\"employeeAmount\\\": 0, \\\"enrollmentDate\\\": \\\"2025-04-01\\\", \\\"fusebillPlanID\\\": 49867, \\\"paidByCompany1\\\": \\\"31372\\\", \\\"paidByEmployee\\\": 0, \\\"companyAmountUI\\\": \\\"$163.69\\\", \\\"paidByEmployee1\\\": \\\"true\\\", \\\"planFrequencyID\\\": 107054, \\\"planLevelParent\\\": 1, \\\"planproductname\\\": \\\"Classic Silver\\\", \\\"coveredByCompany\\\": 0, \\\"employeeAmountUI\\\": \\\"$0\\\", \\\"coveredByCompany1\\\": \\\"4\\\", \\\"planLevel_parentId\\\": \\\"1\\\", \\\"taxDescriptionLine\\\": \\\"\\\", \\\"disallowedPlanLevels\\\": \\\"53,54,55\\\", \\\"companyCoveredBasePlan\\\": {\\\"tax\\\": 0, \\\"total\\\": 0, \\\"amount\\\": 0, \\\"planId\\\": 0, \\\"planName\\\": \\\"NA\\\", \\\"planLevelId\\\": 0}}\", \"customer_id\": 2965, \"plan_id\": 781, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 8098, \"id\": 6229, \"planCoverage\": \"SINGLE\", \"price\": 163.69, \"productId\": 28, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8098, \"product_id\": 28, \"product\": {\"backgroundColor\": null, \"code\": \"singlegig\", \"color\": null, \"fusebillId\": \"127790\", \"glCode\": \"73210\", \"id\": 28, \"name\": \"Single Gig\", \"price\": null, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"Classic Silver\", \"name\": \"Classic Silver\", \"planCode\": \"classicsilver\", \"packageId\": 1}]}}}",
                            "lastInvoiceAmount": 0,
                            "invoicePaymentDate": "2025-04-01",
                            "lastInvoicePayment": 0,
                            "contact_information": "{\"stateId\": 14, \"workingProvinceId\": 14, \"state\": \"British Columbia\", \"workingProvince\": \"British Columbia\"}",
                            "handleInvoiceHistory": true
                        },
                        "paymentStatus": null,
                        "invoiceHistory": null,
                        "taxInformation": {
                            "overall_taxes": {
                                "Total": 0
                            },
                            "individual_taxes": {
                                "2890": {
                                    "plans": {
                                        "taxes": []
                                    },
                                    "lastName": "Beatty",
                                    "firstName": "Jenny",
                                    "customerId": 2890,
                                    "staxbillId": "13735639"
                                },
                                "2965": {
                                    "plans": {
                                        "taxes": []
                                    },
                                    "lastName": "Beatty",
                                    "firstName": "Jenny",
                                    "customerId": 2965,
                                    "staxbillId": "13754109"
                                }
                            }
                        },
                        "planInformation": {
                            "2890": {
                                "plans": {
                                    "subscriptions": []
                                },
                                "lastName": "Beatty",
                                "firstName": "Jenny",
                                "customerId": 2890,
                                "staxbillId": "13735639"
                            },
                            "2965": {
                                "plans": {
                                    "subscriptions": [
                                        {
                                            "id": 8098,
                                            "gst": null,
                                            "hst": null,
                                            "pst": null,
                                            "qst": null,
                                            "tax": 0,
                                            "misc": "{\"name\": \"Classic Silver (British Columbia) \", \"coverage\": \"SINGLE\", \"description\": \"Health & Dental Insurance 13754109 2965 \"}",
                                            "name": "Classic Silver",
                                            "type": "100% Company Paid",
                                            "count": 1,
                                            "price": 163.69,
                                            "scope": null,
                                            "total": 163.69,
                                            "isBulk": false,
                                            "planId": 781,
                                            "status": "Active",
                                            "created": "2025-03-24 22:13:44",
                                            "plan_id": 781,
                                            "stateId": 14,
                                            "summary": null,
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": 43,
                                            "coverage": "SINGLE",
                                            "modified": "2025-04-02 19:40:51",
                                            "parentId": "2890",
                                            "planCode": "classicsilver",
                                            "planName": "Classic Silver",
                                            "quantity": 1,
                                            "taxPrice": 0,
                                            "totalTax": 0,
                                            "coverage1": "Single ",
                                            "packageId": 1,
                                            "customerId": 2965,
                                            "grandTotal": 163.69,
                                            "gstTaxRate": null,
                                            "hstTaxRate": null,
                                            "planObject": "{\"id\": 781, \"gst\": null, \"hst\": null, \"pst\": null, \"qst\": 0, \"tax\": \"0.00\", \"name\": \"Classic Silver\", \"type\": \"100% Company Paid\", \"optIn\": false, \"taxUI\": \"<span>-</span><span>-</span><span>-</span><span> -</span>\", \"total\": \"163.69\", \"amount\": \"163.69\", \"amounts\": {\"total\": 163.69, \"company\": 163.69, \"employee\": 0}, \"details\": \"Health & Dental Insurance\", \"options\": [], \"totalUI\": \"$163.69\", \"version\": 43, \"amountUI\": \"$163.69\", \"coverage\": \"SINGLE\", \"gstCheck\": true, \"gstPrice\": 0, \"hstCheck\": true, \"hstPrice\": 0, \"isBundle\": true, \"planname\": \"Classic Silver\", \"products\": [{\"id\": 31372, \"tax\": 0, \"name\": \"Classic Silver\", \"price\": 163.69, \"total\": 163.69, \"version\": 43, \"coverage\": \"SINGLE\", \"planLevel\": 4, \"productId\": 28, \"description\": \" Single Gig\", \"tax_details\": [], \"planCoverage\": \"SINGLE\", \"calculatedTax\": {\"tax\": 0, \"price\": 163.69, \"total\": 163.69, \"planProductIds\": [], \"planProductInfos\": []}, \"planProductId\": \"183820\", \"bundledProducts\": [\"Single Gig\"], \"planLevelParent\": 1}], \"pstCheck\": true, \"pstPrice\": 0, \"qstCheck\": true, \"qstPrice\": 0, \"taxPrice\": null, \"groupName\": \"Classic Silver\", \"packageId\": 1, \"planLevel\": 4, \"planPrice\": 163.69, \"gstTaxRate\": null, \"hstTaxRate\": null, \"pstTaxRate\": null, \"totalPrice\": \"163.69\", \"description\": \"Health & Dental Insurance\", \"packagename\": \"Health & Dental Insurance\", \"planCoverage\": \"SINGLE\", \"companyAmount\": 163.69, \"insuranceType\": \"HEALTH\", \"paidByCompany\": 1, \"planLevelName\": \"Classic Silver\", \"skuTotalPrice\": 163.69, \"taxApplicable\": false, \"categorization\": {\"paidByCompany\": true, \"paidByEmployee\": false, \"coveredByCompany\": false}, \"employeeAmount\": 0, \"enrollmentDate\": \"2025-04-01\", \"fusebillPlanID\": 49867, \"paidByCompany1\": \"31372\", \"paidByEmployee\": 0, \"companyAmountUI\": \"$163.69\", \"paidByEmployee1\": \"true\", \"planFrequencyID\": 107054, \"planLevelParent\": 1, \"planproductname\": \"Classic Silver\", \"coveredByCompany\": 0, \"employeeAmountUI\": \"$0\", \"coveredByCompany1\": \"4\", \"planLevel_parentId\": \"1\", \"taxDescriptionLine\": \"\", \"disallowedPlanLevels\": \"53,54,55\", \"companyCoveredBasePlan\": {\"tax\": 0, \"total\": 0, \"amount\": 0, \"planId\": 0, \"planName\": \"NA\", \"planLevelId\": 0}}",
                                            "pstTaxRate": null,
                                            "qstTaxRate": null,
                                            "signupDate": "2025-04-02",
                                            "taxDetails": {
                                                "tax": 0,
                                                "price": 163.69,
                                                "total": 163.69,
                                                "taxDescriptionLine": ""
                                            },
                                            "taxForPlan": 0,
                                            "totalPrice": 163.69,
                                            "createdDate": "2025-03-24 22:13:44",
                                            "customer_id": 2965,
                                            "enrolledDate": "2025-04-01",
                                            "taxDetailsDB": {
                                                "gst": "0.00",
                                                "hst": "0.00",
                                                "pst": "0.00",
                                                "tax": "0.00",
                                                "price": "163.69",
                                                "total": "163.69",
                                                "taxName": null,
                                                "taxPrice": "0.00",
                                                "gstTaxRate": "0.00",
                                                "hstTaxRate": "0.00",
                                                "pstTaxRate": "0.00",
                                                "taxDescriptionLine": ""
                                            },
                                            "taxStatement": "",
                                            "bulkPlanLevel": null,
                                            "paidByCompany": 1,
                                            "taxStatement1": "",
                                            "activationDate": "2025-04-01 04:00:00",
                                            "paidByEmployee": null,
                                            "subscriptionId": "6831983",
                                            "workingStateId": 14,
                                            "bundledProducts": [
                                                "Classic Silver"
                                            ],
                                            "lastBillingDate": null,
                                            "nextBillingDate": null,
                                            "terminationDate": null,
                                            "cancellationDate": null,
                                            "coveredByCompany": null,
                                            "nextBillingPrice": null,
                                            "restrictedAccess": null,
                                            "isSubscriptionTax": false,
                                            "reinstatementDate": null,
                                            "taxSubscriptionId": null,
                                            "terminationReason": null,
                                            "reinstatementReason": null,
                                            "tax_subscription_id": null,
                                            "aitestproExecutionId": 17635,
                                            "customerPlanProducts": [
                                                {
                                                    "id": 6229,
                                                    "price": 163.69,
                                                    "taxSku": null,
                                                    "product": {
                                                        "id": 28,
                                                        "code": "singlegig",
                                                        "data": "{\"additional_instructions\": []}",
                                                        "logo": null,
                                                        "name": "Single Gig",
                                                        "color": null,
                                                        "price": null,
                                                        "glCode": "73210",
                                                        "display": "TITLE",
                                                        "published": true,
                                                        "fusebillId": "127790",
                                                        "backgroundColor": null,
                                                        "includedProducts": null
                                                    },
                                                    "taxCode": null,
                                                    "taxName": null,
                                                    "version": 43,
                                                    "productId": 28,
                                                    "product_id": 28,
                                                    "planCoverage": "SINGLE",
                                                    "customerPlanId": 8098,
                                                    "customer_plan_id": 8098
                                                }
                                            ],
                                            "backdatedActivationDate": null,
                                            "backdatedCancellationDate": null
                                        }
                                    ]
                                },
                                "lastName": "Beatty",
                                "firstName": "Jenny",
                                "customerId": 2965,
                                "staxbillId": "13754109"
                            }
                        },
                        "contactInformation": {
                            "state": "British Columbia",
                            "stateId": 14,
                            "workingProvince": "British Columbia",
                            "workingProvinceId": 14
                        },
                        "fusebillCustomerId": "13735639",
                        "paymentFailureCount": null
                    }
                ],
                "invoiceAmount": 163.69,
                "invoiceStatus": "POST",
                "overall_taxes": {
                    "Total": 0
                },
                "displayVersion": true,
                "havingBulkPlan": false,
                "havingEmployees": true,
                "lastInvoiceDate": "2025-04-01",
                "previousInvoice": true,
                "tax_information": "{\"individual_taxes\": {\"2890\": {\"customerId\": 2890, \"staxbillId\": \"13735639\", \"firstName\": \"Jenny\", \"lastName\": \"Beatty\", \"plans\": {\"taxes\": []}}, \"2965\": {\"customerId\": 2965, \"staxbillId\": \"13754109\", \"firstName\": \"Jenny\", \"lastName\": \"Beatty\", \"plans\": {\"taxes\": []}}}, \"overall_taxes\": {\"Total\": 0}}",
                "individual_taxes": {
                    "2890": {
                        "plans": {
                            "taxes": []
                        },
                        "lastName": "Beatty",
                        "firstName": "Jenny",
                        "customerId": 2890,
                        "staxbillId": "13735639"
                    },
                    "2965": {
                        "plans": {
                            "taxes": []
                        },
                        "lastName": "Beatty",
                        "firstName": "Jenny",
                        "customerId": 2965,
                        "staxbillId": "13754109"
                    }
                },
                "plan_information": "{\"2890\": {\"customerId\": 2890, \"staxbillId\": \"13735639\", \"firstName\": \"Jenny\", \"lastName\": \"Beatty\", \"plans\": {\"subscriptions\": []}}, \"2965\": {\"customerId\": 2965, \"staxbillId\": \"13754109\", \"firstName\": \"Jenny\", \"lastName\": \"Beatty\", \"plans\": {\"subscriptions\": [{\"stateId\": 14, \"workingStateId\": 14, \"taxDetails\": {\"price\": 163.69, \"tax\": 0, \"total\": 163.69, \"taxDescriptionLine\": \"\"}, \"taxDetailsDB\": {\"pst\": \"0.00\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"0.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": null, \"taxPrice\": \"0.00\", \"taxDescriptionLine\": \"\", \"tax\": \"0.00\", \"price\": \"163.69\", \"total\": \"163.69\"}, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"Single \", \"signupDate\": \"2025-04-02\", \"enrolledDate\": \"2025-04-01\", \"activationDate\": \"2025-04-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2025-03-24 22:13:44\", \"subscriptionId\": \"6831983\", \"price\": 163.69, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 163.69, \"totalPrice\": 163.69, \"totalTax\": 0, \"grandTotal\": 163.69, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"Classic Silver\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2965, \"id\": 8098, \"planId\": 781, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": null, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": null, \"qstTaxRate\": null, \"taxPrice\": 0, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": null, \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 17635, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"2890\", \"scope\": null, \"version\": 43, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2025-03-24 22:13:44\", \"modified\": \"2025-04-02 19:40:51\", \"misc\": \"{\\\"name\\\": \\\"Classic Silver (British Columbia) \\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"description\\\": \\\"Health & Dental Insurance 13754109 2965 \\\"}\", \"planObject\": \"{\\\"id\\\": 781, \\\"gst\\\": null, \\\"hst\\\": null, \\\"pst\\\": null, \\\"qst\\\": 0, \\\"tax\\\": \\\"0.00\\\", \\\"name\\\": \\\"Classic Silver\\\", \\\"type\\\": \\\"100% Company Paid\\\", \\\"optIn\\\": false, \\\"taxUI\\\": \\\"<span>-</span><span>-</span><span>-</span><span> -</span>\\\", \\\"total\\\": \\\"163.69\\\", \\\"amount\\\": \\\"163.69\\\", \\\"amounts\\\": {\\\"total\\\": 163.69, \\\"company\\\": 163.69, \\\"employee\\\": 0}, \\\"details\\\": \\\"Health & Dental Insurance\\\", \\\"options\\\": [], \\\"totalUI\\\": \\\"$163.69\\\", \\\"version\\\": 43, \\\"amountUI\\\": \\\"$163.69\\\", \\\"coverage\\\": \\\"SINGLE\\\", \\\"gstCheck\\\": true, \\\"gstPrice\\\": 0, \\\"hstCheck\\\": true, \\\"hstPrice\\\": 0, \\\"isBundle\\\": true, \\\"planname\\\": \\\"Classic Silver\\\", \\\"products\\\": [{\\\"id\\\": 31372, \\\"tax\\\": 0, \\\"name\\\": \\\"Classic Silver\\\", \\\"price\\\": 163.69, \\\"total\\\": 163.69, \\\"version\\\": 43, \\\"coverage\\\": \\\"SINGLE\\\", \\\"planLevel\\\": 4, \\\"productId\\\": 28, \\\"description\\\": \\\" Single Gig\\\", \\\"tax_details\\\": [], \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"calculatedTax\\\": {\\\"tax\\\": 0, \\\"price\\\": 163.69, \\\"total\\\": 163.69, \\\"planProductIds\\\": [], \\\"planProductInfos\\\": []}, \\\"planProductId\\\": \\\"183820\\\", \\\"bundledProducts\\\": [\\\"Single Gig\\\"], \\\"planLevelParent\\\": 1}], \\\"pstCheck\\\": true, \\\"pstPrice\\\": 0, \\\"qstCheck\\\": true, \\\"qstPrice\\\": 0, \\\"taxPrice\\\": null, \\\"groupName\\\": \\\"Classic Silver\\\", \\\"packageId\\\": 1, \\\"planLevel\\\": 4, \\\"planPrice\\\": 163.69, \\\"gstTaxRate\\\": null, \\\"hstTaxRate\\\": null, \\\"pstTaxRate\\\": null, \\\"totalPrice\\\": \\\"163.69\\\", \\\"description\\\": \\\"Health & Dental Insurance\\\", \\\"packagename\\\": \\\"Health & Dental Insurance\\\", \\\"planCoverage\\\": \\\"SINGLE\\\", \\\"companyAmount\\\": 163.69, \\\"insuranceType\\\": \\\"HEALTH\\\", \\\"paidByCompany\\\": 1, \\\"planLevelName\\\": \\\"Classic Silver\\\", \\\"skuTotalPrice\\\": 163.69, \\\"taxApplicable\\\": false, \\\"categorization\\\": {\\\"paidByCompany\\\": true, \\\"paidByEmployee\\\": false, \\\"coveredByCompany\\\": false}, \\\"employeeAmount\\\": 0, \\\"enrollmentDate\\\": \\\"2025-04-01\\\", \\\"fusebillPlanID\\\": 49867, \\\"paidByCompany1\\\": \\\"31372\\\", \\\"paidByEmployee\\\": 0, \\\"companyAmountUI\\\": \\\"$163.69\\\", \\\"paidByEmployee1\\\": \\\"true\\\", \\\"planFrequencyID\\\": 107054, \\\"planLevelParent\\\": 1, \\\"planproductname\\\": \\\"Classic Silver\\\", \\\"coveredByCompany\\\": 0, \\\"employeeAmountUI\\\": \\\"$0\\\", \\\"coveredByCompany1\\\": \\\"4\\\", \\\"planLevel_parentId\\\": \\\"1\\\", \\\"taxDescriptionLine\\\": \\\"\\\", \\\"disallowedPlanLevels\\\": \\\"53,54,55\\\", \\\"companyCoveredBasePlan\\\": {\\\"tax\\\": 0, \\\"total\\\": 0, \\\"amount\\\": 0, \\\"planId\\\": 0, \\\"planName\\\": \\\"NA\\\", \\\"planLevelId\\\": 0}}\", \"customer_id\": 2965, \"plan_id\": 781, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 8098, \"id\": 6229, \"planCoverage\": \"SINGLE\", \"price\": 163.69, \"productId\": 28, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": 43, \"customer_plan_id\": 8098, \"product_id\": 28, \"product\": {\"backgroundColor\": null, \"code\": \"singlegig\", \"color\": null, \"fusebillId\": \"127790\", \"glCode\": \"73210\", \"id\": 28, \"name\": \"Single Gig\", \"price\": null, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"Classic Silver\", \"name\": \"Classic Silver\", \"planCode\": \"classicsilver\", \"packageId\": 1}]}}}",
                "lastInvoiceAmount": 163.69,
                "invoicePaymentDate": "2025-05-01",
                "lastInvoicePayment": 163.69,
                "contact_information": "{\"stateId\": 14, \"workingProvinceId\": 14, \"state\": \"British Columbia\", \"workingProvince\": \"British Columbia\"}",
                "handleInvoiceHistory": true
            },
            "filename": "25-05-3810.pdf",
            "customer_id": 2890,
            "customerObj": {
                "brokerId": 668,
                "ccExpiry": null,
                "ccExpiryAlertSent": null,
                "companyId": null,
                "companyName": "Healing Touch Family Chiropractic",
                "deleted": null,
                "dob": null,
                "equitableCertificateId": null,
                "equitableRegistrationStatus": null,
                "firstName": "Jenny",
                "fusebillCustomerId": "13735639",
                "fusebillPaymentId": null,
                "gender": "Undisclosed",
                "greenshieldMemberId": null,
                "greenshieldRegistrationStatus": null,
                "groupId": null,
                "id": 2890,
                "isCorporateAccount": true,
                "lastName": "Beatty",
                "maritalStatus": null,
                "middleName": null,
                "provincialHealthcardName": null,
                "terminationReason": null,
                "terminationDate": null,
                "reinstatementReason": null,
                "reinstatementDate": null,
                "jobTitle": null,
                "monthlyRecurringRevenue": 0,
                "parentId": null,
                "paymentMethod": "ACH",
                "paymentMethodId": "3303824",
                "paymentMethodName": null,
                "registrationDate": "Tue Mar 25 2025 00:00:00 GMT+0530 (India Standard Time)",
                "backdatedRegistrationDate": null,
                "signature": "data:image/png;base64,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",
                "status": "Active",
                "uniqueSinId": null,
                "userId": null,
                "spendingLimit": null,
                "annualIncome": null,
                "dateOfHiring": null,
                "assignerTier": null,
                "actualTier": null,
                "employeeId": null,
                "billAsCorporate": null,
                "cancellationDate": null,
                "backdatedCancellationDate": null,
                "lockdocsUserId": null,
                "valisignUserId": null,
                "bulkPlanIncluded": false,
                "userName": "jenny_002890",
                "customData": null,
                "user_id": null,
                "parent_id": null,
                "broker_id": 668,
                "actual_tier": null,
                "broker": {
                    "id": 668,
                    "brokerType": "CORPORATE",
                    "contactId": 7963,
                    "deleted": null,
                    "description": null,
                    "discoverable": false,
                    "fusebillCorporateCustomerId": "13735639",
                    "link": null,
                    "logo": null,
                    "disclosureAgreement": null,
                    "termsAndConditions": null,
                    "name": "Healing Touch Family Chiropractic",
                    "parentId": 455,
                    "policyStartDate": "2025-03-31T18:30:00.000Z",
                    "published": true,
                    "salesTrackingCode": "0000000163",
                    "salesTrackingType": "Plan Commission",
                    "settingsAllowGroupBenefitsWallet": 0,
                    "settingsGroupBenefitzWalletType": null,
                    "settingsAllowInvoicePaymentMethod": 0,
                    "settingsEnableTieredHealthBenefits": 0,
                    "settingsHealthSpendingAccount": null,
                    "settingsHealthSpendingAllotment": null,
                    "settingsRolloverEmployeeLimitNextYear": 0,
                    "settingsRolloverUnusedWalletFunds": null,
                    "uniqueId": null,
                    "subdomain": "healingtouch",
                    "useCreditCardPaymentMethod": true,
                    "useInvoicePaymentMethod": false,
                    "usePadPaymentMethod": false,
                    "userId": 2563,
                    "waitTime": 0,
                    "settingsEnableLengthOfServiceTiers": null,
                    "settingsEnableAnnualIncomeTiers": null,
                    "expectedEmployeesCount": 1,
                    "payrollDeduction": null,
                    "corporateEmployeeWaittimeOverride": null,
                    "corporateAutoPlanSelection": false,
                    "corporatePlanSelectionLocked": true,
                    "corporateWorkingProvinces": "[14]",
                    "corporateEmployeesInitialSignupWaittime": false,
                    "paymentMethod": "ACH",
                    "paymentMethodId": "3303824",
                    "shared": false,
                    "customData": null,
                    "contact_id": 7963,
                    "parent_id": 455,
                    "user_id": 2563
                }
            }
        },
        {
            "id": 4879,
            "invoiceNumber": "25-05-8170",
            "customerId": 198,
            "fusebillCustomerId": "11663678",
            "invoiceDate": "2025-04-30T18:30:00.000Z",
            "dueDate": "2025-04-30T18:30:00.000Z",
            "status": "OVERDUE",
            "invoiceAmount": 1654.08,
            "paymentId": null,
            "paymentInfo": null,
            "invoiceHistory": null,
            "amountPaid": 0,
            "paymentFailureCount": null,
            "paymentDate": null,
            "paymentType": "CREDIT CARD",
            "paymentStatus": null,
            "reference": null,
            "created": "2025-05-01T07:41:59.000Z",
            "modified": "2025-05-22T02:49:26.000Z",
            "taxInformation": {
                "overall_taxes": {
                    "Total": 122.51,
                    "PST on Health Insurance": 122.51
                },
                "individual_taxes": {
                    "198": {
                        "plans": {
                            "taxes": []
                        },
                        "lastName": "Avery",
                        "firstName": "Christopher",
                        "customerId": 198,
                        "staxbillId": "11663678"
                    },
                    "2000": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 5879,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 56.42,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 56.42,
                                    "scope": null,
                                    "total": 56.42,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 10:44:17",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-21 12:52:52",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 56.42,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2000,
                                    "grandTotal": 56.42,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2023-01-23",
                                    "taxForPlan": 0,
                                    "totalPrice": 56.42,
                                    "createdDate": "2024-05-30 10:44:17",
                                    "customer_id": 2000,
                                    "enrolledDate": "2023-03-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6356148",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (<60)",
                                        "Protect 200",
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4191,
                                            "price": 56.42,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 5879,
                                            "customer_plan_id": 5879
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Avery",
                        "firstName": "Christopher",
                        "customerId": 2000,
                        "staxbillId": "13195516"
                    },
                    "2002": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 5883,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 22.03,
                                    "scope": null,
                                    "total": 22.03,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 18:31:45",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 18:28:09",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2002,
                                    "grandTotal": 22.03,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-05-30",
                                    "taxForPlan": 0,
                                    "totalPrice": 22.03,
                                    "createdDate": "2024-05-30 18:31:45",
                                    "customer_id": 2002,
                                    "enrolledDate": "2024-06-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6357070",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 1,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4195,
                                            "price": 22.03,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 5883,
                                            "customer_plan_id": 5883
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Harris",
                        "firstName": "Shannon",
                        "customerId": 2002,
                        "staxbillId": "13196440"
                    },
                    "2124": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 6049,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 22.03,
                                    "scope": null,
                                    "total": 22.03,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-06-18 11:51:55",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 18:28:09",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2124,
                                    "grandTotal": 22.03,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-06-18",
                                    "taxForPlan": 0,
                                    "totalPrice": 22.03,
                                    "createdDate": "2024-06-18 11:51:55",
                                    "customer_id": 2124,
                                    "enrolledDate": "2024-07-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-07-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6378369",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 1,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4342,
                                            "price": 22.03,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 6049,
                                            "customer_plan_id": 6049
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Illes",
                        "firstName": "Agnes",
                        "customerId": 2124,
                        "staxbillId": "13248991"
                    },
                    "2132": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 6061,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 22.03,
                                    "scope": null,
                                    "total": 22.03,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-06-20 15:39:18",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 18:28:09",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2132,
                                    "grandTotal": 22.03,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-06-20",
                                    "taxForPlan": 0,
                                    "totalPrice": 22.03,
                                    "createdDate": "2024-06-20 15:39:18",
                                    "customer_id": 2132,
                                    "enrolledDate": "2024-07-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-07-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6381134",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 1,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4357,
                                            "price": 22.03,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 6061,
                                            "customer_plan_id": 6061
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Cullum",
                        "firstName": "Alexandra",
                        "customerId": 2132,
                        "staxbillId": "13252945"
                    }
                }
            },
            "contactInformation": {
                "state": "Ontario",
                "stateId": 12,
                "workingProvince": "Ontario",
                "workingProvinceId": 12
            },
            "planInformation": {
                "198": {
                    "plans": {
                        "subscriptions": []
                    },
                    "lastName": "Avery",
                    "firstName": "Christopher",
                    "customerId": 198,
                    "staxbillId": "11663678"
                },
                "2000": {
                    "plans": {
                        "subscriptions": [
                            {
                                "id": 5882,
                                "gst": null,
                                "hst": null,
                                "pst": 22.03,
                                "qst": null,
                                "tax": 0,
                                "misc": null,
                                "name": "All-in Gold",
                                "type": "100% Company Paid",
                                "count": 1,
                                "price": 275.43,
                                "scope": null,
                                "total": 275.43,
                                "isBulk": false,
                                "planId": 786,
                                "status": "Active",
                                "tierId": null,
                                "created": "2024-05-30 10:44:17",
                                "plan_id": 786,
                                "stateId": 12,
                                "summary": null,
                                "taxCode": null,
                                "taxName": "PST on Health Insurance",
                                "version": null,
                                "coverage": "SINGLE",
                                "modified": "2025-01-21 12:52:52",
                                "parentId": "198",
                                "planCode": "allingold",
                                "planName": "All-in Gold",
                                "quantity": 1,
                                "taxPrice": 22.03,
                                "totalTax": 0,
                                "coverage1": "Single",
                                "packageId": 1,
                                "customerId": 2000,
                                "grandTotal": 275.43,
                                "gstTaxRate": null,
                                "hstTaxRate": null,
                                "planObject": null,
                                "pstTaxRate": 8,
                                "qstTaxRate": null,
                                "signupDate": "2023-01-23",
                                "taxDetails": {
                                    "tax": 0,
                                    "price": 0,
                                    "total": 0,
                                    "taxDescriptionLine": ""
                                },
                                "taxForPlan": 0,
                                "totalPrice": 275.43,
                                "createdDate": "2024-05-30 10:44:17",
                                "customer_id": 2000,
                                "enrolledDate": "2023-03-01",
                                "taxDetailsDB": {
                                    "gst": "0.00",
                                    "hst": "0.00",
                                    "pst": "22.03",
                                    "tax": "22.03",
                                    "price": "275.43",
                                    "total": "297.46",
                                    "taxName": "PST on Health Insurance",
                                    "taxPrice": "22.03",
                                    "gstTaxRate": "0.00",
                                    "hstTaxRate": "0.00",
                                    "pstTaxRate": "8.00",
                                    "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                },
                                "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                "bulkPlanLevel": null,
                                "paidByCompany": 1,
                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                "activationDate": "2024-06-01 04:00:00",
                                "paidByEmployee": null,
                                "subscriptionId": "6356146",
                                "workingStateId": 12,
                                "bundledProducts": [
                                    "Complete Executive Care (<60)",
                                    "Protect 200",
                                    "All-in Gold"
                                ],
                                "lastBillingDate": null,
                                "nextBillingDate": null,
                                "terminationDate": null,
                                "cancellationDate": null,
                                "coveredByCompany": null,
                                "nextBillingPrice": null,
                                "restrictedAccess": null,
                                "isSubscriptionTax": false,
                                "reinstatementDate": null,
                                "taxSubscriptionId": "6356148",
                                "terminationReason": null,
                                "reinstatementReason": null,
                                "tax_subscription_id": 6356148,
                                "aitestproExecutionId": null,
                                "customerPlanProducts": [
                                    {
                                        "id": 4194,
                                        "price": 275.43,
                                        "taxSku": null,
                                        "product": {
                                            "id": 7,
                                            "code": "single",
                                            "data": "{\"additional_instructions\": []}",
                                            "logo": null,
                                            "name": "Single",
                                            "color": null,
                                            "price": 7.25,
                                            "glCode": "53211",
                                            "display": "TITLE",
                                            "published": true,
                                            "fusebillId": "126196",
                                            "backgroundColor": "#212A3E",
                                            "includedProducts": null
                                        },
                                        "taxCode": null,
                                        "taxName": null,
                                        "version": null,
                                        "productId": 7,
                                        "product_id": 7,
                                        "planCoverage": "SINGLE",
                                        "customerPlanId": 5882,
                                        "customer_plan_id": 5882
                                    }
                                ],
                                "backdatedActivationDate": null,
                                "backdatedCancellationDate": null
                            },
                            {
                                "id": 5881,
                                "gst": null,
                                "hst": null,
                                "pst": 4.8,
                                "qst": null,
                                "tax": 4.8,
                                "misc": null,
                                "name": "GroupBenefitz Protect",
                                "type": "100% Company Paid",
                                "count": 1,
                                "price": 60,
                                "scope": null,
                                "total": 64.8,
                                "isBulk": false,
                                "planId": 776,
                                "status": "Active",
                                "tierId": null,
                                "created": "2024-05-30 10:44:17",
                                "plan_id": 776,
                                "stateId": 12,
                                "summary": null,
                                "taxCode": null,
                                "taxName": "PST on Health Insurance",
                                "version": null,
                                "coverage": "SINGLE",
                                "modified": "2025-01-21 12:52:52",
                                "parentId": "198",
                                "planCode": "groupbenefitzprotectsinglesku",
                                "planName": "GroupBenefitz Protect",
                                "quantity": 1,
                                "taxPrice": 4.8,
                                "totalTax": 4.8,
                                "coverage1": "-",
                                "packageId": 4,
                                "customerId": 2000,
                                "grandTotal": 64.8,
                                "gstTaxRate": null,
                                "hstTaxRate": null,
                                "planObject": null,
                                "pstTaxRate": 8,
                                "qstTaxRate": null,
                                "signupDate": "2023-01-23",
                                "taxDetails": {
                                    "tax": 4.8,
                                    "price": 60,
                                    "total": 64.8,
                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $4.80 "
                                },
                                "taxForPlan": 4.8,
                                "totalPrice": 60,
                                "createdDate": "2024-05-30 10:44:17",
                                "customer_id": 2000,
                                "enrolledDate": "2023-03-01",
                                "taxDetailsDB": {
                                    "gst": "0.00",
                                    "hst": "0.00",
                                    "pst": "4.80",
                                    "tax": "4.80",
                                    "price": "60.00",
                                    "total": "64.80",
                                    "taxName": "PST on Health Insurance",
                                    "taxPrice": "4.80",
                                    "gstTaxRate": "0.00",
                                    "hstTaxRate": "0.00",
                                    "pstTaxRate": "8.00",
                                    "taxDescriptionLine": "PST on Health Insurance 8% $4.80"
                                },
                                "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                "bulkPlanLevel": null,
                                "paidByCompany": 1,
                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                "activationDate": "2024-06-01 04:00:00",
                                "paidByEmployee": null,
                                "subscriptionId": "6356147",
                                "workingStateId": 12,
                                "bundledProducts": [
                                    "Complete Executive Care (<60)",
                                    "Protect 200",
                                    "All-in Gold"
                                ],
                                "lastBillingDate": null,
                                "nextBillingDate": null,
                                "terminationDate": null,
                                "cancellationDate": null,
                                "coveredByCompany": null,
                                "nextBillingPrice": null,
                                "restrictedAccess": null,
                                "isSubscriptionTax": false,
                                "reinstatementDate": null,
                                "taxSubscriptionId": "6356148",
                                "terminationReason": null,
                                "reinstatementReason": null,
                                "tax_subscription_id": 6356148,
                                "aitestproExecutionId": null,
                                "customerPlanProducts": [
                                    {
                                        "id": 4193,
                                        "price": 60,
                                        "taxSku": null,
                                        "product": {
                                            "id": 17,
                                            "code": "protect200",
                                            "data": "{\"additional_instructions\": []}",
                                            "logo": null,
                                            "name": "Protect 200",
                                            "color": null,
                                            "price": 60,
                                            "glCode": "53210",
                                            "display": "TITLE",
                                            "published": true,
                                            "fusebillId": "127797",
                                            "backgroundColor": null,
                                            "includedProducts": null
                                        },
                                        "taxCode": null,
                                        "taxName": null,
                                        "version": null,
                                        "productId": 17,
                                        "product_id": 17,
                                        "planCoverage": null,
                                        "customerPlanId": 5881,
                                        "customer_plan_id": 5881
                                    }
                                ],
                                "backdatedActivationDate": null,
                                "backdatedCancellationDate": null
                            },
                            {
                                "id": 5880,
                                "gst": null,
                                "hst": null,
                                "pst": 29.59,
                                "qst": null,
                                "tax": 29.59,
                                "misc": null,
                                "name": "Complete Executive Care (<60)",
                                "type": "100% Company Paid",
                                "count": 1,
                                "price": 369.85,
                                "scope": null,
                                "total": 399.44,
                                "isBulk": false,
                                "planId": 772,
                                "status": "Active",
                                "tierId": null,
                                "created": "2024-05-30 10:44:17",
                                "plan_id": 772,
                                "stateId": 12,
                                "summary": null,
                                "taxCode": null,
                                "taxName": "PST on Health Insurance",
                                "version": null,
                                "coverage": "SINGLE",
                                "modified": "2025-01-21 12:52:52",
                                "parentId": "198",
                                "planCode": "completeexecutivecare60",
                                "planName": "Complete Executive Care (<60)",
                                "quantity": 1,
                                "taxPrice": 29.59,
                                "totalTax": 29.59,
                                "coverage1": "Single",
                                "packageId": 5,
                                "customerId": 2000,
                                "grandTotal": 399.44,
                                "gstTaxRate": null,
                                "hstTaxRate": null,
                                "planObject": null,
                                "pstTaxRate": 8,
                                "qstTaxRate": null,
                                "signupDate": "2023-01-23",
                                "taxDetails": {
                                    "tax": 29.59,
                                    "price": 369.85,
                                    "total": 399.44,
                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $29.59 "
                                },
                                "taxForPlan": 29.59,
                                "totalPrice": 369.85,
                                "createdDate": "2024-05-30 10:44:17",
                                "customer_id": 2000,
                                "enrolledDate": "2023-03-01",
                                "taxDetailsDB": {
                                    "gst": "0.00",
                                    "hst": "0.00",
                                    "pst": "29.59",
                                    "tax": "29.59",
                                    "price": "369.85",
                                    "total": "399.44",
                                    "taxName": "PST on Health Insurance",
                                    "taxPrice": "29.59",
                                    "gstTaxRate": "0.00",
                                    "hstTaxRate": "0.00",
                                    "pstTaxRate": "8.00",
                                    "taxDescriptionLine": "PST on Health Insurance 8% $29.59"
                                },
                                "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                "bulkPlanLevel": null,
                                "paidByCompany": 1,
                                "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                "activationDate": "2024-06-01 04:00:00",
                                "paidByEmployee": null,
                                "subscriptionId": "6356145",
                                "workingStateId": 12,
                                "bundledProducts": [
                                    "Complete Executive Care (<60)",
                                    "Protect 200",
                                    "All-in Gold"
                                ],
                                "lastBillingDate": null,
                                "nextBillingDate": null,
                                "terminationDate": null,
                                "cancellationDate": null,
                                "coveredByCompany": null,
                                "nextBillingPrice": null,
                                "restrictedAccess": null,
                                "isSubscriptionTax": false,
                                "reinstatementDate": null,
                                "taxSubscriptionId": "6356148",
                                "terminationReason": null,
                                "reinstatementReason": null,
                                "tax_subscription_id": 6356148,
                                "aitestproExecutionId": null,
                                "customerPlanProducts": [
                                    {
                                        "id": 4192,
                                        "price": 369.85,
                                        "taxSku": null,
                                        "product": {
                                            "id": 7,
                                            "code": "single",
                                            "data": "{\"additional_instructions\": []}",
                                            "logo": null,
                                            "name": "Single",
                                            "color": null,
                                            "price": 7.25,
                                            "glCode": "53211",
                                            "display": "TITLE",
                                            "published": true,
                                            "fusebillId": "126196",
                                            "backgroundColor": "#212A3E",
                                            "includedProducts": null
                                        },
                                        "taxCode": null,
                                        "taxName": null,
                                        "version": null,
                                        "productId": 7,
                                        "product_id": 7,
                                        "planCoverage": null,
                                        "customerPlanId": 5880,
                                        "customer_plan_id": 5880
                                    }
                                ],
                                "backdatedActivationDate": null,
                                "backdatedCancellationDate": null
                            }
                        ]
                    },
                    "lastName": "Avery",
                    "firstName": "Christopher",
                    "customerId": 2000,
                    "staxbillId": "13195516"
                },
                "2002": {
                    "plans": {
                        "subscriptions": [
                            {
                                "id": 5884,
                                "gst": 0,
                                "hst": 0,
                                "pst": 22.03,
                                "qst": 0,
                                "tax": 47.56,
                                "misc": null,
                                "name": "All-in Gold",
                                "type": "100% Company Paid",
                                "count": 1,
                                "price": 275.43,
                                "scope": null,
                                "total": 322.99,
                                "isBulk": false,
                                "planId": 786,
                                "status": "Active",
                                "tierId": null,
                                "created": "2024-05-30 18:31:46",
                                "plan_id": 786,
                                "stateId": 12,
                                "summary": null,
                                "taxCode": null,
                                "taxName": "PST on Health Insurance",
                                "version": null,
                                "coverage": "SINGLE",
                                "modified": "2025-01-20 17:47:28",
                                "parentId": "198",
                                "planCode": "allingold",
                                "planName": "All-in Gold",
                                "quantity": 1,
                                "taxPrice": 22.03,
                                "totalTax": 47.56,
                                "coverage1": "Single",
                                "packageId": 1,
                                "customerId": 2002,
                                "grandTotal": 322.99,
                                "gstTaxRate": null,
                                "hstTaxRate": null,
                                "planObject": null,
                                "pstTaxRate": 8,
                                "qstTaxRate": null,
                                "signupDate": "2024-05-30",
                                "taxDetails": {
                                    "tax": 47.56,
                                    "price": 550.86,
                                    "total": 598.42,
                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                },
                                "taxForPlan": 47.56,
                                "totalPrice": 275.43,
                                "createdDate": "2024-05-30 18:31:46",
                                "customer_id": 2002,
                                "enrolledDate": "2024-06-01",
                                "taxDetailsDB": {
                                    "gst": "0.00",
                                    "hst": "0.00",
                                    "pst": "22.03",
                                    "tax": "22.03",
                                    "price": "275.43",
                                    "total": "297.46",
                                    "taxName": "PST on Health Insurance",
                                    "taxPrice": "22.03",
                                    "gstTaxRate": "0.00",
                                    "hstTaxRate": "0.00",
                                    "pstTaxRate": "8.00",
                                    "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                },
                                "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                "bulkPlanLevel": null,
                                "paidByCompany": 1,
                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                "activationDate": "2024-06-01 04:00:00",
                                "paidByEmployee": null,
                                "subscriptionId": "6357071",
                                "workingStateId": 12,
                                "bundledProducts": [
                                    "All-in Gold"
                                ],
                                "lastBillingDate": null,
                                "nextBillingDate": null,
                                "terminationDate": null,
                                "cancellationDate": null,
                                "coveredByCompany": null,
                                "nextBillingPrice": null,
                                "restrictedAccess": null,
                                "isSubscriptionTax": false,
                                "reinstatementDate": null,
                                "taxSubscriptionId": "6357070",
                                "terminationReason": null,
                                "reinstatementReason": null,
                                "tax_subscription_id": 6357070,
                                "aitestproExecutionId": 10600,
                                "customerPlanProducts": [
                                    {
                                        "id": 4196,
                                        "price": 275.43,
                                        "taxSku": null,
                                        "product": {
                                            "id": 7,
                                            "code": "single",
                                            "data": "{\"additional_instructions\": []}",
                                            "logo": null,
                                            "name": "Single",
                                            "color": null,
                                            "price": 7.25,
                                            "glCode": "53211",
                                            "display": "TITLE",
                                            "published": true,
                                            "fusebillId": "126196",
                                            "backgroundColor": "#212A3E",
                                            "includedProducts": null
                                        },
                                        "taxCode": null,
                                        "taxName": null,
                                        "version": null,
                                        "productId": 7,
                                        "product_id": 7,
                                        "planCoverage": "SINGLE",
                                        "customerPlanId": 5884,
                                        "customer_plan_id": 5884
                                    }
                                ],
                                "backdatedActivationDate": null,
                                "backdatedCancellationDate": null
                            }
                        ]
                    },
                    "lastName": "Harris",
                    "firstName": "Shannon",
                    "customerId": 2002,
                    "staxbillId": "13196440"
                },
                "2124": {
                    "plans": {
                        "subscriptions": [
                            {
                                "id": 6050,
                                "gst": 0,
                                "hst": 0,
                                "pst": 22.03,
                                "qst": 0,
                                "tax": 47.56,
                                "misc": null,
                                "name": "All-in Gold",
                                "type": "100% Company Paid",
                                "count": 1,
                                "price": 275.43,
                                "scope": null,
                                "total": 322.99,
                                "isBulk": false,
                                "planId": 786,
                                "status": "Active",
                                "tierId": null,
                                "created": "2024-06-18 11:51:56",
                                "plan_id": 786,
                                "stateId": 12,
                                "summary": null,
                                "taxCode": null,
                                "taxName": "PST on Health Insurance",
                                "version": null,
                                "coverage": "SINGLE",
                                "modified": "2025-01-20 17:47:31",
                                "parentId": "198",
                                "planCode": "allingold",
                                "planName": "All-in Gold",
                                "quantity": 1,
                                "taxPrice": 22.03,
                                "totalTax": 47.56,
                                "coverage1": "Single",
                                "packageId": 1,
                                "customerId": 2124,
                                "grandTotal": 322.99,
                                "gstTaxRate": null,
                                "hstTaxRate": null,
                                "planObject": null,
                                "pstTaxRate": 8,
                                "qstTaxRate": null,
                                "signupDate": "2024-06-18",
                                "taxDetails": {
                                    "tax": 47.56,
                                    "price": 550.86,
                                    "total": 598.42,
                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                },
                                "taxForPlan": 47.56,
                                "totalPrice": 275.43,
                                "createdDate": "2024-06-18 11:51:56",
                                "customer_id": 2124,
                                "enrolledDate": "2024-07-01",
                                "taxDetailsDB": {
                                    "gst": "0.00",
                                    "hst": "0.00",
                                    "pst": "22.03",
                                    "tax": "22.03",
                                    "price": "275.43",
                                    "total": "297.46",
                                    "taxName": "PST on Health Insurance",
                                    "taxPrice": "22.03",
                                    "gstTaxRate": "0.00",
                                    "hstTaxRate": "0.00",
                                    "pstTaxRate": "8.00",
                                    "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                },
                                "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                "bulkPlanLevel": null,
                                "paidByCompany": 1,
                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                "activationDate": "2024-07-01 04:00:00",
                                "paidByEmployee": null,
                                "subscriptionId": "6378370",
                                "workingStateId": 12,
                                "bundledProducts": [
                                    "All-in Gold"
                                ],
                                "lastBillingDate": null,
                                "nextBillingDate": null,
                                "terminationDate": null,
                                "cancellationDate": null,
                                "coveredByCompany": null,
                                "nextBillingPrice": null,
                                "restrictedAccess": null,
                                "isSubscriptionTax": false,
                                "reinstatementDate": null,
                                "taxSubscriptionId": "6378369",
                                "terminationReason": null,
                                "reinstatementReason": null,
                                "tax_subscription_id": 6378369,
                                "aitestproExecutionId": 10904,
                                "customerPlanProducts": [
                                    {
                                        "id": 4343,
                                        "price": 275.43,
                                        "taxSku": null,
                                        "product": {
                                            "id": 7,
                                            "code": "single",
                                            "data": "{\"additional_instructions\": []}",
                                            "logo": null,
                                            "name": "Single",
                                            "color": null,
                                            "price": 7.25,
                                            "glCode": "53211",
                                            "display": "TITLE",
                                            "published": true,
                                            "fusebillId": "126196",
                                            "backgroundColor": "#212A3E",
                                            "includedProducts": null
                                        },
                                        "taxCode": null,
                                        "taxName": null,
                                        "version": null,
                                        "productId": 7,
                                        "product_id": 7,
                                        "planCoverage": "SINGLE",
                                        "customerPlanId": 6050,
                                        "customer_plan_id": 6050
                                    }
                                ],
                                "backdatedActivationDate": null,
                                "backdatedCancellationDate": null
                            }
                        ]
                    },
                    "lastName": "Illes",
                    "firstName": "Agnes",
                    "customerId": 2124,
                    "staxbillId": "13248991"
                },
                "2132": {
                    "plans": {
                        "subscriptions": [
                            {
                                "id": 6062,
                                "gst": 0,
                                "hst": 0,
                                "pst": 22.03,
                                "qst": 0,
                                "tax": 47.56,
                                "misc": null,
                                "name": "All-in Gold",
                                "type": "100% Company Paid",
                                "count": 1,
                                "price": 275.43,
                                "scope": null,
                                "total": 322.99,
                                "isBulk": false,
                                "planId": 786,
                                "status": "Active",
                                "tierId": null,
                                "created": "2024-06-20 15:39:19",
                                "plan_id": 786,
                                "stateId": 12,
                                "summary": null,
                                "taxCode": null,
                                "taxName": "PST on Health Insurance",
                                "version": null,
                                "coverage": "SINGLE",
                                "modified": "2025-01-20 17:47:31",
                                "parentId": "198",
                                "planCode": "allingold",
                                "planName": "All-in Gold",
                                "quantity": 1,
                                "taxPrice": 22.03,
                                "totalTax": 47.56,
                                "coverage1": "Single",
                                "packageId": 1,
                                "customerId": 2132,
                                "grandTotal": 322.99,
                                "gstTaxRate": null,
                                "hstTaxRate": null,
                                "planObject": null,
                                "pstTaxRate": 8,
                                "qstTaxRate": null,
                                "signupDate": "2024-06-20",
                                "taxDetails": {
                                    "tax": 47.56,
                                    "price": 550.86,
                                    "total": 598.42,
                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                },
                                "taxForPlan": 47.56,
                                "totalPrice": 275.43,
                                "createdDate": "2024-06-20 15:39:19",
                                "customer_id": 2132,
                                "enrolledDate": "2024-07-01",
                                "taxDetailsDB": {
                                    "gst": "0.00",
                                    "hst": "0.00",
                                    "pst": "22.03",
                                    "tax": "22.03",
                                    "price": "275.43",
                                    "total": "297.46",
                                    "taxName": "PST on Health Insurance",
                                    "taxPrice": "22.03",
                                    "gstTaxRate": "0.00",
                                    "hstTaxRate": "0.00",
                                    "pstTaxRate": "8.00",
                                    "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                },
                                "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                "bulkPlanLevel": null,
                                "paidByCompany": 1,
                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                "activationDate": "2024-07-01 04:00:00",
                                "paidByEmployee": null,
                                "subscriptionId": "6381135",
                                "workingStateId": 12,
                                "bundledProducts": [
                                    "All-in Gold"
                                ],
                                "lastBillingDate": null,
                                "nextBillingDate": null,
                                "terminationDate": null,
                                "cancellationDate": null,
                                "coveredByCompany": null,
                                "nextBillingPrice": null,
                                "restrictedAccess": null,
                                "isSubscriptionTax": false,
                                "reinstatementDate": null,
                                "taxSubscriptionId": "6381134",
                                "terminationReason": null,
                                "reinstatementReason": null,
                                "tax_subscription_id": 6381134,
                                "aitestproExecutionId": 11006,
                                "customerPlanProducts": [
                                    {
                                        "id": 4358,
                                        "price": 275.43,
                                        "taxSku": null,
                                        "product": {
                                            "id": 7,
                                            "code": "single",
                                            "data": "{\"additional_instructions\": []}",
                                            "logo": null,
                                            "name": "Single",
                                            "color": null,
                                            "price": 7.25,
                                            "glCode": "53211",
                                            "display": "TITLE",
                                            "published": true,
                                            "fusebillId": "126196",
                                            "backgroundColor": "#212A3E",
                                            "includedProducts": null
                                        },
                                        "taxCode": null,
                                        "taxName": null,
                                        "version": null,
                                        "productId": 7,
                                        "product_id": 7,
                                        "planCoverage": "SINGLE",
                                        "customerPlanId": 6062,
                                        "customer_plan_id": 6062
                                    }
                                ],
                                "backdatedActivationDate": null,
                                "backdatedCancellationDate": null
                            }
                        ]
                    },
                    "lastName": "Cullum",
                    "firstName": "Alexandra",
                    "customerId": 2132,
                    "staxbillId": "13252945"
                }
            },
            "invoiceObject": {
                "id": 198,
                "logo": "https://api-admin.groupbenefitz.net/api/ap/app/resources/images/gb_logo_long.png",
                "note": "",
                "email": "avery@averylaw.ca",
                "plans": {
                    "taxes": [],
                    "subscriptions": []
                },
                "taxes": {
                    "PST on Health Insurance ON": 122.51
                },
                "total": 1654.08,
                "credit": 0,
                "status": "Active",
                "address": {
                    "id": 492,
                    "apt": null,
                    "city": "Oshawa",
                    "line1": "1018 Highbrooke Ct",
                    "line2": "",
                    "state": "Ontario",
                    "country": "Canada",
                    "stateId": 12,
                    "countryId": 1,
                    "fusebillId": "8860011",
                    "postalCode": "L1K 2K6",
                    "addressType": "BILLING_ADDRESS",
                    "contactType": "CUSTOMER",
                    "primaryEmail": "avery@averylaw.ca",
                    "primaryPhone": "+1 (416) 895-4964",
                    "secondaryEmail": null,
                    "secondaryPhone": null
                },
                "arrears": 0,
                "baMails": [
                    "avery@averylaw.ca"
                ],
                "ciMails": [],
                "version": "gb7.0.0",
                "fileName": "Invoice_11663678_2025-05-01_25-05-8170_POST",
                "filePath": "/var/www/vhosts/api-common.groupbenefitz.net/public/server/MemberInvoices/",
                "fontSize": "8",
                "lastName": "Avery",
                "logoPath": "/var/www/vhosts/api-common.groupbenefitz.net/public/resources/images/gb_logo_long.png",
                "subtotal": 1531.5700000000002,
                "firstName": "Christopher",
                "invoiceNo": "25-05-8170",
                "customerId": 198,
                "staxbillId": "11663678",
                "accountType": "parent",
                "companyName": "Avery Law",
                "environment": "production",
                "generatePDF": true,
                "invoiceDate": "2025-05",
                "isCorporate": true,
                "paymentType": "CREDIT CARD",
                "employeeList": [
                    {
                        "id": 2000,
                        "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                        "email": "avery@averylaw.ca",
                        "plans": {
                            "taxes": [
                                {
                                    "id": 5879,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 56.42,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 56.42,
                                    "scope": null,
                                    "total": 56.42,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 10:44:17",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-21 12:52:52",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 56.42,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2000,
                                    "grandTotal": 56.42,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2023-01-23",
                                    "taxForPlan": 0,
                                    "totalPrice": 56.42,
                                    "createdDate": "2024-05-30 10:44:17",
                                    "customer_id": 2000,
                                    "enrolledDate": "2023-03-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6356148",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (<60)",
                                        "Protect 200",
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4191,
                                            "price": 56.42,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 5879,
                                            "customer_plan_id": 5879
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ],
                            "subscriptions": [
                                {
                                    "id": 5882,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "All-in Gold",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 275.43,
                                    "scope": null,
                                    "total": 275.43,
                                    "isBulk": false,
                                    "planId": 786,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 10:44:17",
                                    "plan_id": 786,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-21 12:52:52",
                                    "parentId": "198",
                                    "planCode": "allingold",
                                    "planName": "All-in Gold",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "Single",
                                    "packageId": 1,
                                    "customerId": 2000,
                                    "grandTotal": 275.43,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2023-01-23",
                                    "taxDetails": {
                                        "tax": 0,
                                        "price": 0,
                                        "total": 0,
                                        "taxDescriptionLine": ""
                                    },
                                    "taxForPlan": 0,
                                    "totalPrice": 275.43,
                                    "createdDate": "2024-05-30 10:44:17",
                                    "customer_id": 2000,
                                    "enrolledDate": "2023-03-01",
                                    "taxDetailsDB": {
                                        "gst": "0.00",
                                        "hst": "0.00",
                                        "pst": "22.03",
                                        "tax": "22.03",
                                        "price": "275.43",
                                        "total": "297.46",
                                        "taxName": "PST on Health Insurance",
                                        "taxPrice": "22.03",
                                        "gstTaxRate": "0.00",
                                        "hstTaxRate": "0.00",
                                        "pstTaxRate": "8.00",
                                        "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                    },
                                    "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6356146",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (<60)",
                                        "Protect 200",
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": false,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": "6356148",
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": 6356148,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4194,
                                            "price": 275.43,
                                            "taxSku": null,
                                            "product": {
                                                "id": 7,
                                                "code": "single",
                                                "data": "{\"additional_instructions\": []}",
                                                "logo": null,
                                                "name": "Single",
                                                "color": null,
                                                "price": 7.25,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126196",
                                                "backgroundColor": "#212A3E",
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 7,
                                            "product_id": 7,
                                            "planCoverage": "SINGLE",
                                            "customerPlanId": 5882,
                                            "customer_plan_id": 5882
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                },
                                {
                                    "id": 5881,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 4.8,
                                    "qst": null,
                                    "tax": 4.8,
                                    "misc": null,
                                    "name": "GroupBenefitz Protect",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 60,
                                    "scope": null,
                                    "total": 64.8,
                                    "isBulk": false,
                                    "planId": 776,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 10:44:17",
                                    "plan_id": 776,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-21 12:52:52",
                                    "parentId": "198",
                                    "planCode": "groupbenefitzprotectsinglesku",
                                    "planName": "GroupBenefitz Protect",
                                    "quantity": 1,
                                    "taxPrice": 4.8,
                                    "totalTax": 4.8,
                                    "coverage1": "-",
                                    "packageId": 4,
                                    "customerId": 2000,
                                    "grandTotal": 64.8,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2023-01-23",
                                    "taxDetails": {
                                        "tax": 4.8,
                                        "price": 60,
                                        "total": 64.8,
                                        "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $4.80 "
                                    },
                                    "taxForPlan": 4.8,
                                    "totalPrice": 60,
                                    "createdDate": "2024-05-30 10:44:17",
                                    "customer_id": 2000,
                                    "enrolledDate": "2023-03-01",
                                    "taxDetailsDB": {
                                        "gst": "0.00",
                                        "hst": "0.00",
                                        "pst": "4.80",
                                        "tax": "4.80",
                                        "price": "60.00",
                                        "total": "64.80",
                                        "taxName": "PST on Health Insurance",
                                        "taxPrice": "4.80",
                                        "gstTaxRate": "0.00",
                                        "hstTaxRate": "0.00",
                                        "pstTaxRate": "8.00",
                                        "taxDescriptionLine": "PST on Health Insurance 8% $4.80"
                                    },
                                    "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6356147",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (<60)",
                                        "Protect 200",
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": false,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": "6356148",
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": 6356148,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4193,
                                            "price": 60,
                                            "taxSku": null,
                                            "product": {
                                                "id": 17,
                                                "code": "protect200",
                                                "data": "{\"additional_instructions\": []}",
                                                "logo": null,
                                                "name": "Protect 200",
                                                "color": null,
                                                "price": 60,
                                                "glCode": "53210",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "127797",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 17,
                                            "product_id": 17,
                                            "planCoverage": null,
                                            "customerPlanId": 5881,
                                            "customer_plan_id": 5881
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                },
                                {
                                    "id": 5880,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 29.59,
                                    "qst": null,
                                    "tax": 29.59,
                                    "misc": null,
                                    "name": "Complete Executive Care (<60)",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 369.85,
                                    "scope": null,
                                    "total": 399.44,
                                    "isBulk": false,
                                    "planId": 772,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 10:44:17",
                                    "plan_id": 772,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-21 12:52:52",
                                    "parentId": "198",
                                    "planCode": "completeexecutivecare60",
                                    "planName": "Complete Executive Care (<60)",
                                    "quantity": 1,
                                    "taxPrice": 29.59,
                                    "totalTax": 29.59,
                                    "coverage1": "Single",
                                    "packageId": 5,
                                    "customerId": 2000,
                                    "grandTotal": 399.44,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2023-01-23",
                                    "taxDetails": {
                                        "tax": 29.59,
                                        "price": 369.85,
                                        "total": 399.44,
                                        "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $29.59 "
                                    },
                                    "taxForPlan": 29.59,
                                    "totalPrice": 369.85,
                                    "createdDate": "2024-05-30 10:44:17",
                                    "customer_id": 2000,
                                    "enrolledDate": "2023-03-01",
                                    "taxDetailsDB": {
                                        "gst": "0.00",
                                        "hst": "0.00",
                                        "pst": "29.59",
                                        "tax": "29.59",
                                        "price": "369.85",
                                        "total": "399.44",
                                        "taxName": "PST on Health Insurance",
                                        "taxPrice": "29.59",
                                        "gstTaxRate": "0.00",
                                        "hstTaxRate": "0.00",
                                        "pstTaxRate": "8.00",
                                        "taxDescriptionLine": "PST on Health Insurance 8% $29.59"
                                    },
                                    "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6356145",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (<60)",
                                        "Protect 200",
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": false,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": "6356148",
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": 6356148,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4192,
                                            "price": 369.85,
                                            "taxSku": null,
                                            "product": {
                                                "id": 7,
                                                "code": "single",
                                                "data": "{\"additional_instructions\": []}",
                                                "logo": null,
                                                "name": "Single",
                                                "color": null,
                                                "price": 7.25,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126196",
                                                "backgroundColor": "#212A3E",
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 7,
                                            "product_id": 7,
                                            "planCoverage": null,
                                            "customerPlanId": 5880,
                                            "customer_plan_id": 5880
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "address": {
                            "id": 6703,
                            "apt": "",
                            "city": "Oshawa",
                            "line1": "1018 Highbrooke Ct",
                            "line2": "",
                            "state": "Ontario",
                            "country": "Canada",
                            "stateId": 12,
                            "countryId": 1,
                            "fusebillId": "1",
                            "postalCode": "L1K 2K6",
                            "addressType": "HOME_ADDRESS",
                            "contactType": "CUSTOMER",
                            "primaryEmail": "avery@averylaw.ca",
                            "primaryPhone": "+1 (416) 895-4964",
                            "secondaryEmail": "",
                            "secondaryPhone": ""
                        },
                        "lastName": "Avery",
                        "firstName": "Christopher",
                        "customerId": 2000,
                        "staxbillId": "13195516",
                        "accountType": "child",
                        "companyName": "AveryLaw",
                        "isCorporate": true,
                        "paymentType": "NONE",
                        "employerName": "",
                        "pastInvoices": [],
                        "invoiceAmount": 761.7,
                        "invoiceAmountEP": 0,
                        "workingProvince": "Ontario",
                        "workingProvinceId": 12
                    },
                    {
                        "id": 2002,
                        "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                        "email": "shannonmpdharris@gmail.com",
                        "plans": {
                            "taxes": [
                                {
                                    "id": 5883,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 22.03,
                                    "scope": null,
                                    "total": 22.03,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 18:31:45",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 18:28:09",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2002,
                                    "grandTotal": 22.03,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-05-30",
                                    "taxForPlan": 0,
                                    "totalPrice": 22.03,
                                    "createdDate": "2024-05-30 18:31:45",
                                    "customer_id": 2002,
                                    "enrolledDate": "2024-06-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6357070",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 1,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4195,
                                            "price": 22.03,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 5883,
                                            "customer_plan_id": 5883
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ],
                            "subscriptions": [
                                {
                                    "id": 5884,
                                    "gst": 0,
                                    "hst": 0,
                                    "pst": 22.03,
                                    "qst": 0,
                                    "tax": 47.56,
                                    "misc": null,
                                    "name": "All-in Gold",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 275.43,
                                    "scope": null,
                                    "total": 322.99,
                                    "isBulk": false,
                                    "planId": 786,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 18:31:46",
                                    "plan_id": 786,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 17:47:28",
                                    "parentId": "198",
                                    "planCode": "allingold",
                                    "planName": "All-in Gold",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 47.56,
                                    "coverage1": "Single",
                                    "packageId": 1,
                                    "customerId": 2002,
                                    "grandTotal": 322.99,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-05-30",
                                    "taxDetails": {
                                        "tax": 47.56,
                                        "price": 550.86,
                                        "total": 598.42,
                                        "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                    },
                                    "taxForPlan": 47.56,
                                    "totalPrice": 275.43,
                                    "createdDate": "2024-05-30 18:31:46",
                                    "customer_id": 2002,
                                    "enrolledDate": "2024-06-01",
                                    "taxDetailsDB": {
                                        "gst": "0.00",
                                        "hst": "0.00",
                                        "pst": "22.03",
                                        "tax": "22.03",
                                        "price": "275.43",
                                        "total": "297.46",
                                        "taxName": "PST on Health Insurance",
                                        "taxPrice": "22.03",
                                        "gstTaxRate": "0.00",
                                        "hstTaxRate": "0.00",
                                        "pstTaxRate": "8.00",
                                        "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                    },
                                    "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6357071",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": false,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": "6357070",
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": 6357070,
                                    "aitestproExecutionId": 10600,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4196,
                                            "price": 275.43,
                                            "taxSku": null,
                                            "product": {
                                                "id": 7,
                                                "code": "single",
                                                "data": "{\"additional_instructions\": []}",
                                                "logo": null,
                                                "name": "Single",
                                                "color": null,
                                                "price": 7.25,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126196",
                                                "backgroundColor": "#212A3E",
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 7,
                                            "product_id": 7,
                                            "planCoverage": "SINGLE",
                                            "customerPlanId": 5884,
                                            "customer_plan_id": 5884
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "address": {
                            "id": 4472,
                            "apt": "",
                            "city": "Aurora",
                            "line1": "22 Sandusky Cr.",
                            "line2": "",
                            "state": "Ontario",
                            "country": "Canada",
                            "stateId": 12,
                            "countryId": 1,
                            "fusebillId": null,
                            "postalCode": "L4G3N4",
                            "addressType": "HOME_ADDRESS",
                            "contactType": "CUSTOMER",
                            "primaryEmail": "shannonmpdharris@gmail.com",
                            "primaryPhone": "+1 (416) 723-4314",
                            "secondaryEmail": null,
                            "secondaryPhone": null
                        },
                        "lastName": "Harris",
                        "firstName": "Shannon",
                        "customerId": 2002,
                        "staxbillId": "13196440",
                        "accountType": "child",
                        "companyName": "AveryLaw",
                        "isCorporate": true,
                        "paymentType": "NONE",
                        "employerName": "",
                        "pastInvoices": [],
                        "invoiceAmount": 297.46,
                        "invoiceAmountEP": 0,
                        "workingProvince": "Ontario",
                        "workingProvinceId": 12
                    },
                    {
                        "id": 2124,
                        "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                        "email": "agica143@gmail.com",
                        "plans": {
                            "taxes": [
                                {
                                    "id": 6049,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 22.03,
                                    "scope": null,
                                    "total": 22.03,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-06-18 11:51:55",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 18:28:09",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2124,
                                    "grandTotal": 22.03,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-06-18",
                                    "taxForPlan": 0,
                                    "totalPrice": 22.03,
                                    "createdDate": "2024-06-18 11:51:55",
                                    "customer_id": 2124,
                                    "enrolledDate": "2024-07-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-07-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6378369",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 1,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4342,
                                            "price": 22.03,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 6049,
                                            "customer_plan_id": 6049
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ],
                            "subscriptions": [
                                {
                                    "id": 6050,
                                    "gst": 0,
                                    "hst": 0,
                                    "pst": 22.03,
                                    "qst": 0,
                                    "tax": 47.56,
                                    "misc": null,
                                    "name": "All-in Gold",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 275.43,
                                    "scope": null,
                                    "total": 322.99,
                                    "isBulk": false,
                                    "planId": 786,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-06-18 11:51:56",
                                    "plan_id": 786,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 17:47:31",
                                    "parentId": "198",
                                    "planCode": "allingold",
                                    "planName": "All-in Gold",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 47.56,
                                    "coverage1": "Single",
                                    "packageId": 1,
                                    "customerId": 2124,
                                    "grandTotal": 322.99,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-06-18",
                                    "taxDetails": {
                                        "tax": 47.56,
                                        "price": 550.86,
                                        "total": 598.42,
                                        "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                    },
                                    "taxForPlan": 47.56,
                                    "totalPrice": 275.43,
                                    "createdDate": "2024-06-18 11:51:56",
                                    "customer_id": 2124,
                                    "enrolledDate": "2024-07-01",
                                    "taxDetailsDB": {
                                        "gst": "0.00",
                                        "hst": "0.00",
                                        "pst": "22.03",
                                        "tax": "22.03",
                                        "price": "275.43",
                                        "total": "297.46",
                                        "taxName": "PST on Health Insurance",
                                        "taxPrice": "22.03",
                                        "gstTaxRate": "0.00",
                                        "hstTaxRate": "0.00",
                                        "pstTaxRate": "8.00",
                                        "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                    },
                                    "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                    "activationDate": "2024-07-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6378370",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": false,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": "6378369",
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": 6378369,
                                    "aitestproExecutionId": 10904,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4343,
                                            "price": 275.43,
                                            "taxSku": null,
                                            "product": {
                                                "id": 7,
                                                "code": "single",
                                                "data": "{\"additional_instructions\": []}",
                                                "logo": null,
                                                "name": "Single",
                                                "color": null,
                                                "price": 7.25,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126196",
                                                "backgroundColor": "#212A3E",
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 7,
                                            "product_id": 7,
                                            "planCoverage": "SINGLE",
                                            "customerPlanId": 6050,
                                            "customer_plan_id": 6050
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "address": {
                            "id": 4790,
                            "apt": "510",
                            "city": "Toronto",
                            "line1": "751 Woodbine Avenue ",
                            "line2": "",
                            "state": "Ontario",
                            "country": "Canada",
                            "stateId": 12,
                            "countryId": 1,
                            "fusebillId": null,
                            "postalCode": "M4E 3V5",
                            "addressType": "HOME_ADDRESS",
                            "contactType": "CUSTOMER",
                            "primaryEmail": "agica143@gmail.com",
                            "primaryPhone": "+1 (647) 803-7573",
                            "secondaryEmail": null,
                            "secondaryPhone": null
                        },
                        "lastName": "Illes",
                        "firstName": "Agnes",
                        "customerId": 2124,
                        "staxbillId": "13248991",
                        "accountType": "child",
                        "companyName": "AveryLaw",
                        "isCorporate": true,
                        "paymentType": "NONE",
                        "employerName": "",
                        "pastInvoices": [],
                        "invoiceAmount": 297.46,
                        "invoiceAmountEP": 0,
                        "workingProvince": "Ontario",
                        "workingProvinceId": 12
                    },
                    {
                        "id": 2132,
                        "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                        "email": "alexandra.cullum@uoit.net",
                        "plans": {
                            "taxes": [
                                {
                                    "id": 6061,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 22.03,
                                    "scope": null,
                                    "total": 22.03,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-06-20 15:39:18",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 18:28:09",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2132,
                                    "grandTotal": 22.03,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-06-20",
                                    "taxForPlan": 0,
                                    "totalPrice": 22.03,
                                    "createdDate": "2024-06-20 15:39:18",
                                    "customer_id": 2132,
                                    "enrolledDate": "2024-07-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-07-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6381134",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 1,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4357,
                                            "price": 22.03,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 6061,
                                            "customer_plan_id": 6061
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ],
                            "subscriptions": [
                                {
                                    "id": 6062,
                                    "gst": 0,
                                    "hst": 0,
                                    "pst": 22.03,
                                    "qst": 0,
                                    "tax": 47.56,
                                    "misc": null,
                                    "name": "All-in Gold",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 275.43,
                                    "scope": null,
                                    "total": 322.99,
                                    "isBulk": false,
                                    "planId": 786,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-06-20 15:39:19",
                                    "plan_id": 786,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 17:47:31",
                                    "parentId": "198",
                                    "planCode": "allingold",
                                    "planName": "All-in Gold",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 47.56,
                                    "coverage1": "Single",
                                    "packageId": 1,
                                    "customerId": 2132,
                                    "grandTotal": 322.99,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-06-20",
                                    "taxDetails": {
                                        "tax": 47.56,
                                        "price": 550.86,
                                        "total": 598.42,
                                        "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                    },
                                    "taxForPlan": 47.56,
                                    "totalPrice": 275.43,
                                    "createdDate": "2024-06-20 15:39:19",
                                    "customer_id": 2132,
                                    "enrolledDate": "2024-07-01",
                                    "taxDetailsDB": {
                                        "gst": "0.00",
                                        "hst": "0.00",
                                        "pst": "22.03",
                                        "tax": "22.03",
                                        "price": "275.43",
                                        "total": "297.46",
                                        "taxName": "PST on Health Insurance",
                                        "taxPrice": "22.03",
                                        "gstTaxRate": "0.00",
                                        "hstTaxRate": "0.00",
                                        "pstTaxRate": "8.00",
                                        "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                    },
                                    "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                    "activationDate": "2024-07-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6381135",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": false,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": "6381134",
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": 6381134,
                                    "aitestproExecutionId": 11006,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4358,
                                            "price": 275.43,
                                            "taxSku": null,
                                            "product": {
                                                "id": 7,
                                                "code": "single",
                                                "data": "{\"additional_instructions\": []}",
                                                "logo": null,
                                                "name": "Single",
                                                "color": null,
                                                "price": 7.25,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126196",
                                                "backgroundColor": "#212A3E",
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 7,
                                            "product_id": 7,
                                            "planCoverage": "SINGLE",
                                            "customerPlanId": 6062,
                                            "customer_plan_id": 6062
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "address": {
                            "id": 4814,
                            "apt": "",
                            "city": "Port Perry",
                            "line1": "19 Winchurch Dr.",
                            "line2": "",
                            "state": "Ontario",
                            "country": "Canada",
                            "stateId": 12,
                            "countryId": 1,
                            "fusebillId": null,
                            "postalCode": "L9L 1T6",
                            "addressType": "HOME_ADDRESS",
                            "contactType": "CUSTOMER",
                            "primaryEmail": "alexandra.cullum@uoit.net",
                            "primaryPhone": "+1 (905) 706-3692",
                            "secondaryEmail": null,
                            "secondaryPhone": null
                        },
                        "lastName": "Cullum",
                        "firstName": "Alexandra",
                        "customerId": 2132,
                        "staxbillId": "13252945",
                        "accountType": "child",
                        "companyName": "AveryLaw",
                        "isCorporate": true,
                        "paymentType": "NONE",
                        "employerName": "",
                        "pastInvoices": [],
                        "invoiceAmount": 297.46,
                        "invoiceAmountEP": 0,
                        "workingProvince": "Ontario",
                        "workingProvinceId": 12
                    }
                ],
                "employerName": "",
                "invoiceDate2": "2025-05-01",
                "pastInvoices": [
                    {
                        "id": 4486,
                        "status": "PAID",
                        "created": "2025-04-04 13:13:19",
                        "dueDate": "2025-04-01",
                        "modified": "2025-04-30 09:25:02",
                        "paymentId": null,
                        "reference": null,
                        "amountPaid": 1654.08,
                        "customerId": 198,
                        "customer_id": 198,
                        "invoiceDate": "2025-04-01",
                        "paymentDate": null,
                        "paymentInfo": null,
                        "paymentType": "CREDIT CARD",
                        "invoiceAmount": 1654.08,
                        "invoiceNumber": "25-04-9407",
                        "invoiceObject": {
                            "id": 198,
                            "logo": "https://api-admin.groupbenefitz.net/api/ap/app/resources/images/gb_logo_long.png",
                            "note": "",
                            "email": "avery@averylaw.ca",
                            "plans": {
                                "taxes": [],
                                "subscriptions": []
                            },
                            "taxes": {
                                "PST on Health Insurance ON": 122.51
                            },
                            "total": 1654.08,
                            "credit": 0,
                            "status": "Active",
                            "address": {
                                "id": 492,
                                "apt": null,
                                "city": "Oshawa",
                                "line1": "1018 Highbrooke Ct",
                                "line2": "",
                                "state": "Ontario",
                                "country": "Canada",
                                "stateId": 12,
                                "countryId": 1,
                                "fusebillId": "8860011",
                                "postalCode": "L1K 2K6",
                                "addressType": "BILLING_ADDRESS",
                                "contactType": "CUSTOMER",
                                "primaryEmail": "avery@averylaw.ca",
                                "primaryPhone": "+1 (416) 895-4964",
                                "secondaryEmail": null,
                                "secondaryPhone": null
                            },
                            "arrears": 0,
                            "baMails": [
                                "avery@averylaw.ca"
                            ],
                            "ciMails": [],
                            "version": "gb7.0.0",
                            "fileName": "Invoice_11663678_2025-04-01_25-04-9407_POST",
                            "filePath": "/var/www/vhosts/api-common.groupbenefitz.net/public/server/MemberInvoices/",
                            "fontSize": "8",
                            "lastName": "Avery",
                            "logoPath": "/var/www/vhosts/api-common.groupbenefitz.net/public/resources/images/gb_logo_long.png",
                            "subtotal": 1531.5700000000002,
                            "firstName": "Christopher",
                            "invoiceNo": "25-04-9407",
                            "customerId": 198,
                            "staxbillId": "11663678",
                            "accountType": "parent",
                            "companyName": "Avery Law",
                            "environment": "production",
                            "generatePDF": true,
                            "invoiceDate": "2025-04",
                            "isCorporate": true,
                            "paymentType": "CREDIT CARD",
                            "employeeList": [
                                {
                                    "id": 2000,
                                    "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                    "email": "avery@averylaw.ca",
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 5879,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 56.42,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 56.42,
                                                "scope": null,
                                                "total": 56.42,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-05-30 10:44:17",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-21 12:52:52",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 56.42,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2000,
                                                "grandTotal": 56.42,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2023-01-23",
                                                "taxForPlan": 0,
                                                "totalPrice": 56.42,
                                                "createdDate": "2024-05-30 10:44:17",
                                                "customer_id": 2000,
                                                "enrolledDate": "2023-03-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6356148",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (<60)",
                                                    "Protect 200",
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4191,
                                                        "price": 56.42,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 5879,
                                                        "customer_plan_id": 5879
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ],
                                        "subscriptions": [
                                            {
                                                "id": 5882,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "All-in Gold",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 275.43,
                                                "scope": null,
                                                "total": 275.43,
                                                "isBulk": false,
                                                "planId": 786,
                                                "status": "Active",
                                                "created": "2024-05-30 10:44:17",
                                                "plan_id": 786,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-21 12:52:52",
                                                "parentId": "198",
                                                "planCode": "allingold",
                                                "planName": "All-in Gold",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "Single",
                                                "packageId": 1,
                                                "customerId": 2000,
                                                "grandTotal": 275.43,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2023-01-23",
                                                "taxDetails": {
                                                    "tax": 0,
                                                    "price": 0,
                                                    "total": 0,
                                                    "taxDescriptionLine": ""
                                                },
                                                "taxForPlan": 0,
                                                "totalPrice": 275.43,
                                                "createdDate": "2024-05-30 10:44:17",
                                                "customer_id": 2000,
                                                "enrolledDate": "2023-03-01",
                                                "taxDetailsDB": {
                                                    "gst": "0.00",
                                                    "hst": "0.00",
                                                    "pst": "22.03",
                                                    "tax": "22.03",
                                                    "price": "275.43",
                                                    "total": "297.46",
                                                    "taxName": "PST on Health Insurance",
                                                    "taxPrice": "22.03",
                                                    "gstTaxRate": "0.00",
                                                    "hstTaxRate": "0.00",
                                                    "pstTaxRate": "8.00",
                                                    "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                },
                                                "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6356146",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (<60)",
                                                    "Protect 200",
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": false,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": "6356148",
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": 6356148,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4194,
                                                        "price": 275.43,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 7,
                                                            "code": "single",
                                                            "data": "{\"additional_instructions\": []}",
                                                            "logo": null,
                                                            "name": "Single",
                                                            "color": null,
                                                            "price": 7.25,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126196",
                                                            "backgroundColor": "#212A3E",
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 7,
                                                        "product_id": 7,
                                                        "planCoverage": "SINGLE",
                                                        "customerPlanId": 5882,
                                                        "customer_plan_id": 5882
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            },
                                            {
                                                "id": 5881,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 4.8,
                                                "qst": null,
                                                "tax": 4.8,
                                                "misc": null,
                                                "name": "GroupBenefitz Protect",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 60,
                                                "scope": null,
                                                "total": 64.8,
                                                "isBulk": false,
                                                "planId": 776,
                                                "status": "Active",
                                                "created": "2024-05-30 10:44:17",
                                                "plan_id": 776,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-21 12:52:52",
                                                "parentId": "198",
                                                "planCode": "groupbenefitzprotectsinglesku",
                                                "planName": "GroupBenefitz Protect",
                                                "quantity": 1,
                                                "taxPrice": 4.8,
                                                "totalTax": 4.8,
                                                "coverage1": "-",
                                                "packageId": 4,
                                                "customerId": 2000,
                                                "grandTotal": 64.8,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2023-01-23",
                                                "taxDetails": {
                                                    "tax": 4.8,
                                                    "price": 60,
                                                    "total": 64.8,
                                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $4.80 "
                                                },
                                                "taxForPlan": 4.8,
                                                "totalPrice": 60,
                                                "createdDate": "2024-05-30 10:44:17",
                                                "customer_id": 2000,
                                                "enrolledDate": "2023-03-01",
                                                "taxDetailsDB": {
                                                    "gst": "0.00",
                                                    "hst": "0.00",
                                                    "pst": "4.80",
                                                    "tax": "4.80",
                                                    "price": "60.00",
                                                    "total": "64.80",
                                                    "taxName": "PST on Health Insurance",
                                                    "taxPrice": "4.80",
                                                    "gstTaxRate": "0.00",
                                                    "hstTaxRate": "0.00",
                                                    "pstTaxRate": "8.00",
                                                    "taxDescriptionLine": "PST on Health Insurance 8% $4.80"
                                                },
                                                "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6356147",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (<60)",
                                                    "Protect 200",
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": false,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": "6356148",
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": 6356148,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4193,
                                                        "price": 60,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 17,
                                                            "code": "protect200",
                                                            "data": "{\"additional_instructions\": []}",
                                                            "logo": null,
                                                            "name": "Protect 200",
                                                            "color": null,
                                                            "price": 60,
                                                            "glCode": "53210",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "127797",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 17,
                                                        "product_id": 17,
                                                        "planCoverage": null,
                                                        "customerPlanId": 5881,
                                                        "customer_plan_id": 5881
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            },
                                            {
                                                "id": 5880,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 29.59,
                                                "qst": null,
                                                "tax": 29.59,
                                                "misc": null,
                                                "name": "Complete Executive Care (<60)",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 369.85,
                                                "scope": null,
                                                "total": 399.44,
                                                "isBulk": false,
                                                "planId": 772,
                                                "status": "Active",
                                                "created": "2024-05-30 10:44:17",
                                                "plan_id": 772,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-21 12:52:52",
                                                "parentId": "198",
                                                "planCode": "completeexecutivecare60",
                                                "planName": "Complete Executive Care (<60)",
                                                "quantity": 1,
                                                "taxPrice": 29.59,
                                                "totalTax": 29.59,
                                                "coverage1": "Single",
                                                "packageId": 5,
                                                "customerId": 2000,
                                                "grandTotal": 399.44,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2023-01-23",
                                                "taxDetails": {
                                                    "tax": 29.59,
                                                    "price": 369.85,
                                                    "total": 399.44,
                                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $29.59 "
                                                },
                                                "taxForPlan": 29.59,
                                                "totalPrice": 369.85,
                                                "createdDate": "2024-05-30 10:44:17",
                                                "customer_id": 2000,
                                                "enrolledDate": "2023-03-01",
                                                "taxDetailsDB": {
                                                    "gst": "0.00",
                                                    "hst": "0.00",
                                                    "pst": "29.59",
                                                    "tax": "29.59",
                                                    "price": "369.85",
                                                    "total": "399.44",
                                                    "taxName": "PST on Health Insurance",
                                                    "taxPrice": "29.59",
                                                    "gstTaxRate": "0.00",
                                                    "hstTaxRate": "0.00",
                                                    "pstTaxRate": "8.00",
                                                    "taxDescriptionLine": "PST on Health Insurance 8% $29.59"
                                                },
                                                "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6356145",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (<60)",
                                                    "Protect 200",
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": false,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": "6356148",
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": 6356148,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4192,
                                                        "price": 369.85,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 7,
                                                            "code": "single",
                                                            "data": "{\"additional_instructions\": []}",
                                                            "logo": null,
                                                            "name": "Single",
                                                            "color": null,
                                                            "price": 7.25,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126196",
                                                            "backgroundColor": "#212A3E",
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 7,
                                                        "product_id": 7,
                                                        "planCoverage": null,
                                                        "customerPlanId": 5880,
                                                        "customer_plan_id": 5880
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "address": {
                                        "id": 6703,
                                        "apt": "",
                                        "city": "Oshawa",
                                        "line1": "1018 Highbrooke Ct",
                                        "line2": "",
                                        "state": "Ontario",
                                        "country": "Canada",
                                        "stateId": 12,
                                        "countryId": 1,
                                        "fusebillId": "1",
                                        "postalCode": "L1K 2K6",
                                        "addressType": "HOME_ADDRESS",
                                        "contactType": "CUSTOMER",
                                        "primaryEmail": "avery@averylaw.ca",
                                        "primaryPhone": "+1 (416) 895-4964",
                                        "secondaryEmail": "",
                                        "secondaryPhone": ""
                                    },
                                    "lastName": "Avery",
                                    "firstName": "Christopher",
                                    "customerId": 2000,
                                    "staxbillId": "13195516",
                                    "accountType": "child",
                                    "companyName": "AveryLaw",
                                    "isCorporate": true,
                                    "paymentType": "NONE",
                                    "employerName": "",
                                    "pastInvoices": [],
                                    "invoiceAmount": 761.7,
                                    "invoiceAmountEP": 0,
                                    "workingProvince": "Ontario",
                                    "workingProvinceId": 12
                                },
                                {
                                    "id": 2002,
                                    "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                    "email": "shannonmpdharris@gmail.com",
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 5883,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 22.03,
                                                "scope": null,
                                                "total": 22.03,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-05-30 18:31:45",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 18:28:09",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2002,
                                                "grandTotal": 22.03,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-05-30",
                                                "taxForPlan": 0,
                                                "totalPrice": 22.03,
                                                "createdDate": "2024-05-30 18:31:45",
                                                "customer_id": 2002,
                                                "enrolledDate": "2024-06-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6357070",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 1,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4195,
                                                        "price": 22.03,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 5883,
                                                        "customer_plan_id": 5883
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ],
                                        "subscriptions": [
                                            {
                                                "id": 5884,
                                                "gst": 0,
                                                "hst": 0,
                                                "pst": 22.03,
                                                "qst": 0,
                                                "tax": 47.56,
                                                "misc": null,
                                                "name": "All-in Gold",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 275.43,
                                                "scope": null,
                                                "total": 322.99,
                                                "isBulk": false,
                                                "planId": 786,
                                                "status": "Active",
                                                "created": "2024-05-30 18:31:46",
                                                "plan_id": 786,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 17:47:28",
                                                "parentId": "198",
                                                "planCode": "allingold",
                                                "planName": "All-in Gold",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 47.56,
                                                "coverage1": "Single",
                                                "packageId": 1,
                                                "customerId": 2002,
                                                "grandTotal": 322.99,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-05-30",
                                                "taxDetails": {
                                                    "tax": 47.56,
                                                    "price": 550.86,
                                                    "total": 598.42,
                                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                                },
                                                "taxForPlan": 47.56,
                                                "totalPrice": 275.43,
                                                "createdDate": "2024-05-30 18:31:46",
                                                "customer_id": 2002,
                                                "enrolledDate": "2024-06-01",
                                                "taxDetailsDB": {
                                                    "gst": "0.00",
                                                    "hst": "0.00",
                                                    "pst": "22.03",
                                                    "tax": "22.03",
                                                    "price": "275.43",
                                                    "total": "297.46",
                                                    "taxName": "PST on Health Insurance",
                                                    "taxPrice": "22.03",
                                                    "gstTaxRate": "0.00",
                                                    "hstTaxRate": "0.00",
                                                    "pstTaxRate": "8.00",
                                                    "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                },
                                                "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6357071",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": false,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": "6357070",
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": 6357070,
                                                "aitestproExecutionId": 10600,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4196,
                                                        "price": 275.43,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 7,
                                                            "code": "single",
                                                            "data": "{\"additional_instructions\": []}",
                                                            "logo": null,
                                                            "name": "Single",
                                                            "color": null,
                                                            "price": 7.25,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126196",
                                                            "backgroundColor": "#212A3E",
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 7,
                                                        "product_id": 7,
                                                        "planCoverage": "SINGLE",
                                                        "customerPlanId": 5884,
                                                        "customer_plan_id": 5884
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "address": {
                                        "id": 4472,
                                        "apt": "",
                                        "city": "Aurora",
                                        "line1": "22 Sandusky Cr.",
                                        "line2": "",
                                        "state": "Ontario",
                                        "country": "Canada",
                                        "stateId": 12,
                                        "countryId": 1,
                                        "fusebillId": null,
                                        "postalCode": "L4G3N4",
                                        "addressType": "HOME_ADDRESS",
                                        "contactType": "CUSTOMER",
                                        "primaryEmail": "shannonmpdharris@gmail.com",
                                        "primaryPhone": "+1 (416) 723-4314",
                                        "secondaryEmail": null,
                                        "secondaryPhone": null
                                    },
                                    "lastName": "Harris",
                                    "firstName": "Shannon",
                                    "customerId": 2002,
                                    "staxbillId": "13196440",
                                    "accountType": "child",
                                    "companyName": "AveryLaw",
                                    "isCorporate": true,
                                    "paymentType": "NONE",
                                    "employerName": "",
                                    "pastInvoices": [],
                                    "invoiceAmount": 297.46,
                                    "invoiceAmountEP": 0,
                                    "workingProvince": "Ontario",
                                    "workingProvinceId": 12
                                },
                                {
                                    "id": 2124,
                                    "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                    "email": "agica143@gmail.com",
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 6049,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 22.03,
                                                "scope": null,
                                                "total": 22.03,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-06-18 11:51:55",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 18:28:09",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2124,
                                                "grandTotal": 22.03,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-06-18",
                                                "taxForPlan": 0,
                                                "totalPrice": 22.03,
                                                "createdDate": "2024-06-18 11:51:55",
                                                "customer_id": 2124,
                                                "enrolledDate": "2024-07-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-07-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6378369",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 1,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4342,
                                                        "price": 22.03,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 6049,
                                                        "customer_plan_id": 6049
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ],
                                        "subscriptions": [
                                            {
                                                "id": 6050,
                                                "gst": 0,
                                                "hst": 0,
                                                "pst": 22.03,
                                                "qst": 0,
                                                "tax": 47.56,
                                                "misc": null,
                                                "name": "All-in Gold",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 275.43,
                                                "scope": null,
                                                "total": 322.99,
                                                "isBulk": false,
                                                "planId": 786,
                                                "status": "Active",
                                                "created": "2024-06-18 11:51:56",
                                                "plan_id": 786,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 17:47:31",
                                                "parentId": "198",
                                                "planCode": "allingold",
                                                "planName": "All-in Gold",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 47.56,
                                                "coverage1": "Single",
                                                "packageId": 1,
                                                "customerId": 2124,
                                                "grandTotal": 322.99,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-06-18",
                                                "taxDetails": {
                                                    "tax": 47.56,
                                                    "price": 550.86,
                                                    "total": 598.42,
                                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                                },
                                                "taxForPlan": 47.56,
                                                "totalPrice": 275.43,
                                                "createdDate": "2024-06-18 11:51:56",
                                                "customer_id": 2124,
                                                "enrolledDate": "2024-07-01",
                                                "taxDetailsDB": {
                                                    "gst": "0.00",
                                                    "hst": "0.00",
                                                    "pst": "22.03",
                                                    "tax": "22.03",
                                                    "price": "275.43",
                                                    "total": "297.46",
                                                    "taxName": "PST on Health Insurance",
                                                    "taxPrice": "22.03",
                                                    "gstTaxRate": "0.00",
                                                    "hstTaxRate": "0.00",
                                                    "pstTaxRate": "8.00",
                                                    "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                },
                                                "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                                "activationDate": "2024-07-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6378370",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": false,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": "6378369",
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": 6378369,
                                                "aitestproExecutionId": 10904,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4343,
                                                        "price": 275.43,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 7,
                                                            "code": "single",
                                                            "data": "{\"additional_instructions\": []}",
                                                            "logo": null,
                                                            "name": "Single",
                                                            "color": null,
                                                            "price": 7.25,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126196",
                                                            "backgroundColor": "#212A3E",
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 7,
                                                        "product_id": 7,
                                                        "planCoverage": "SINGLE",
                                                        "customerPlanId": 6050,
                                                        "customer_plan_id": 6050
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "address": {
                                        "id": 4790,
                                        "apt": "510",
                                        "city": "Toronto",
                                        "line1": "751 Woodbine Avenue ",
                                        "line2": "",
                                        "state": "Ontario",
                                        "country": "Canada",
                                        "stateId": 12,
                                        "countryId": 1,
                                        "fusebillId": null,
                                        "postalCode": "M4E 3V5",
                                        "addressType": "HOME_ADDRESS",
                                        "contactType": "CUSTOMER",
                                        "primaryEmail": "agica143@gmail.com",
                                        "primaryPhone": "+1 (647) 803-7573",
                                        "secondaryEmail": null,
                                        "secondaryPhone": null
                                    },
                                    "lastName": "Illes",
                                    "firstName": "Agnes",
                                    "customerId": 2124,
                                    "staxbillId": "13248991",
                                    "accountType": "child",
                                    "companyName": "AveryLaw",
                                    "isCorporate": true,
                                    "paymentType": "NONE",
                                    "employerName": "",
                                    "pastInvoices": [],
                                    "invoiceAmount": 297.46,
                                    "invoiceAmountEP": 0,
                                    "workingProvince": "Ontario",
                                    "workingProvinceId": 12
                                },
                                {
                                    "id": 2132,
                                    "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                    "email": "alexandra.cullum@uoit.net",
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 6061,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 22.03,
                                                "scope": null,
                                                "total": 22.03,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-06-20 15:39:18",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 18:28:09",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2132,
                                                "grandTotal": 22.03,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-06-20",
                                                "taxForPlan": 0,
                                                "totalPrice": 22.03,
                                                "createdDate": "2024-06-20 15:39:18",
                                                "customer_id": 2132,
                                                "enrolledDate": "2024-07-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-07-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6381134",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 1,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4357,
                                                        "price": 22.03,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 6061,
                                                        "customer_plan_id": 6061
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ],
                                        "subscriptions": [
                                            {
                                                "id": 6062,
                                                "gst": 0,
                                                "hst": 0,
                                                "pst": 22.03,
                                                "qst": 0,
                                                "tax": 47.56,
                                                "misc": null,
                                                "name": "All-in Gold",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 275.43,
                                                "scope": null,
                                                "total": 322.99,
                                                "isBulk": false,
                                                "planId": 786,
                                                "status": "Active",
                                                "created": "2024-06-20 15:39:19",
                                                "plan_id": 786,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 17:47:31",
                                                "parentId": "198",
                                                "planCode": "allingold",
                                                "planName": "All-in Gold",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 47.56,
                                                "coverage1": "Single",
                                                "packageId": 1,
                                                "customerId": 2132,
                                                "grandTotal": 322.99,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-06-20",
                                                "taxDetails": {
                                                    "tax": 47.56,
                                                    "price": 550.86,
                                                    "total": 598.42,
                                                    "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                                },
                                                "taxForPlan": 47.56,
                                                "totalPrice": 275.43,
                                                "createdDate": "2024-06-20 15:39:19",
                                                "customer_id": 2132,
                                                "enrolledDate": "2024-07-01",
                                                "taxDetailsDB": {
                                                    "gst": "0.00",
                                                    "hst": "0.00",
                                                    "pst": "22.03",
                                                    "tax": "22.03",
                                                    "price": "275.43",
                                                    "total": "297.46",
                                                    "taxName": "PST on Health Insurance",
                                                    "taxPrice": "22.03",
                                                    "gstTaxRate": "0.00",
                                                    "hstTaxRate": "0.00",
                                                    "pstTaxRate": "8.00",
                                                    "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                },
                                                "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                                "activationDate": "2024-07-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6381135",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": false,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": "6381134",
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": 6381134,
                                                "aitestproExecutionId": 11006,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4358,
                                                        "price": 275.43,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 7,
                                                            "code": "single",
                                                            "data": "{\"additional_instructions\": []}",
                                                            "logo": null,
                                                            "name": "Single",
                                                            "color": null,
                                                            "price": 7.25,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126196",
                                                            "backgroundColor": "#212A3E",
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 7,
                                                        "product_id": 7,
                                                        "planCoverage": "SINGLE",
                                                        "customerPlanId": 6062,
                                                        "customer_plan_id": 6062
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "address": {
                                        "id": 4814,
                                        "apt": "",
                                        "city": "Port Perry",
                                        "line1": "19 Winchurch Dr.",
                                        "line2": "",
                                        "state": "Ontario",
                                        "country": "Canada",
                                        "stateId": 12,
                                        "countryId": 1,
                                        "fusebillId": null,
                                        "postalCode": "L9L 1T6",
                                        "addressType": "HOME_ADDRESS",
                                        "contactType": "CUSTOMER",
                                        "primaryEmail": "alexandra.cullum@uoit.net",
                                        "primaryPhone": "+1 (905) 706-3692",
                                        "secondaryEmail": null,
                                        "secondaryPhone": null
                                    },
                                    "lastName": "Cullum",
                                    "firstName": "Alexandra",
                                    "customerId": 2132,
                                    "staxbillId": "13252945",
                                    "accountType": "child",
                                    "companyName": "AveryLaw",
                                    "isCorporate": true,
                                    "paymentType": "NONE",
                                    "employerName": "",
                                    "pastInvoices": [],
                                    "invoiceAmount": 297.46,
                                    "invoiceAmountEP": 0,
                                    "workingProvince": "Ontario",
                                    "workingProvinceId": 12
                                }
                            ],
                            "employerName": "",
                            "invoiceDate2": "2025-04-01",
                            "pastInvoices": [
                                {
                                    "id": 4091,
                                    "status": "PAID",
                                    "created": "2025-03-07 05:49:12",
                                    "dueDate": "2025-03-01",
                                    "modified": "2025-04-01 09:27:21",
                                    "paymentId": null,
                                    "reference": null,
                                    "amountPaid": 1654.08,
                                    "customerId": 198,
                                    "customer_id": 198,
                                    "invoiceDate": "2025-03-01",
                                    "paymentDate": null,
                                    "paymentInfo": null,
                                    "paymentType": "CREDIT CARD",
                                    "invoiceAmount": 1654.08,
                                    "invoiceNumber": "25-03-3790",
                                    "invoiceObject": {
                                        "id": 198,
                                        "logo": "https://api-admin.groupbenefitz.net/api/ap/app/resources/images/gb_logo_long.png",
                                        "note": "",
                                        "email": "avery@averylaw.ca",
                                        "plans": {
                                            "taxes": [],
                                            "subscriptions": []
                                        },
                                        "taxes": {
                                            "PST on Health Insurance ON": 122.51
                                        },
                                        "total": 1654.08,
                                        "credit": 0,
                                        "status": "Active",
                                        "address": {
                                            "id": 492,
                                            "apt": null,
                                            "city": "Oshawa",
                                            "line1": "1018 Highbrooke Ct",
                                            "line2": "",
                                            "state": "Ontario",
                                            "country": "Canada",
                                            "stateId": 12,
                                            "countryId": 1,
                                            "fusebillId": "8860011",
                                            "postalCode": "L1K 2K6",
                                            "addressType": "BILLING_ADDRESS",
                                            "contactType": "CUSTOMER",
                                            "primaryEmail": "avery@averylaw.ca",
                                            "primaryPhone": "+1 (416) 895-4964",
                                            "secondaryEmail": null,
                                            "secondaryPhone": null
                                        },
                                        "arrears": 0,
                                        "baMails": [
                                            "avery@averylaw.ca"
                                        ],
                                        "ciMails": [],
                                        "version": "gb7.0.0",
                                        "fileName": "Invoice_11663678_2025-03-01_25-03-3790_POST",
                                        "filePath": "/var/www/vhosts/api-common.groupbenefitz.net/public/server/MemberInvoices/",
                                        "fontSize": "8",
                                        "lastName": "Avery",
                                        "logoPath": "/var/www/vhosts/api-common.groupbenefitz.net/public/resources/images/gb_logo_long.png",
                                        "subtotal": 1531.5700000000002,
                                        "firstName": "Christopher",
                                        "invoiceNo": "25-03-3790",
                                        "customerId": 198,
                                        "staxbillId": "11663678",
                                        "accountType": "parent",
                                        "companyName": "Avery Law",
                                        "environment": "production",
                                        "generatePDF": true,
                                        "invoiceDate": "2025-03",
                                        "isCorporate": true,
                                        "paymentType": "CREDIT CARD",
                                        "employeeList": [
                                            {
                                                "id": 2000,
                                                "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                                "email": "avery@averylaw.ca",
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 5879,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 56.42,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 56.42,
                                                            "scope": null,
                                                            "total": 56.42,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-05-30 10:44:17",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-21 12:52:52",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 56.42,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2000,
                                                            "grandTotal": 56.42,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2023-01-23",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 56.42,
                                                            "createdDate": "2024-05-30 10:44:17",
                                                            "customer_id": 2000,
                                                            "enrolledDate": "2023-03-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6356148",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "Complete Executive Care (<60)",
                                                                "Protect 200",
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": null,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4191,
                                                                    "price": 56.42,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 5879,
                                                                    "customer_plan_id": 5879
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ],
                                                    "subscriptions": [
                                                        {
                                                            "id": 5882,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "All-in Gold",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 275.43,
                                                            "scope": null,
                                                            "total": 275.43,
                                                            "isBulk": false,
                                                            "planId": 786,
                                                            "status": "Active",
                                                            "created": "2024-05-30 10:44:17",
                                                            "plan_id": 786,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-21 12:52:52",
                                                            "parentId": "198",
                                                            "planCode": "allingold",
                                                            "planName": "All-in Gold",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "Single",
                                                            "packageId": 1,
                                                            "customerId": 2000,
                                                            "grandTotal": 275.43,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2023-01-23",
                                                            "taxDetails": {
                                                                "tax": 0,
                                                                "price": 0,
                                                                "total": 0,
                                                                "taxDescriptionLine": ""
                                                            },
                                                            "taxForPlan": 0,
                                                            "totalPrice": 275.43,
                                                            "createdDate": "2024-05-30 10:44:17",
                                                            "customer_id": 2000,
                                                            "enrolledDate": "2023-03-01",
                                                            "taxDetailsDB": {
                                                                "gst": "0.00",
                                                                "hst": "0.00",
                                                                "pst": "22.03",
                                                                "tax": "22.03",
                                                                "price": "275.43",
                                                                "total": "297.46",
                                                                "taxName": "PST on Health Insurance",
                                                                "taxPrice": "22.03",
                                                                "gstTaxRate": "0.00",
                                                                "hstTaxRate": "0.00",
                                                                "pstTaxRate": "8.00",
                                                                "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                            },
                                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6356146",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "Complete Executive Care (<60)",
                                                                "Protect 200",
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": false,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": "6356148",
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": 6356148,
                                                            "aitestproExecutionId": null,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4194,
                                                                    "price": 275.43,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 7,
                                                                        "code": "single",
                                                                        "data": "{\"additional_instructions\": []}",
                                                                        "logo": null,
                                                                        "name": "Single",
                                                                        "color": null,
                                                                        "price": 7.25,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126196",
                                                                        "backgroundColor": "#212A3E",
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 7,
                                                                    "product_id": 7,
                                                                    "planCoverage": "SINGLE",
                                                                    "customerPlanId": 5882,
                                                                    "customer_plan_id": 5882
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        },
                                                        {
                                                            "id": 5881,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 4.8,
                                                            "qst": null,
                                                            "tax": 4.8,
                                                            "misc": null,
                                                            "name": "GroupBenefitz Protect",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 60,
                                                            "scope": null,
                                                            "total": 64.8,
                                                            "isBulk": false,
                                                            "planId": 776,
                                                            "status": "Active",
                                                            "created": "2024-05-30 10:44:17",
                                                            "plan_id": 776,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-21 12:52:52",
                                                            "parentId": "198",
                                                            "planCode": "groupbenefitzprotectsinglesku",
                                                            "planName": "GroupBenefitz Protect",
                                                            "quantity": 1,
                                                            "taxPrice": 4.8,
                                                            "totalTax": 4.8,
                                                            "coverage1": "-",
                                                            "packageId": 4,
                                                            "customerId": 2000,
                                                            "grandTotal": 64.8,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2023-01-23",
                                                            "taxDetails": {
                                                                "tax": 4.8,
                                                                "price": 60,
                                                                "total": 64.8,
                                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $4.80 "
                                                            },
                                                            "taxForPlan": 4.8,
                                                            "totalPrice": 60,
                                                            "createdDate": "2024-05-30 10:44:17",
                                                            "customer_id": 2000,
                                                            "enrolledDate": "2023-03-01",
                                                            "taxDetailsDB": {
                                                                "gst": "0.00",
                                                                "hst": "0.00",
                                                                "pst": "4.80",
                                                                "tax": "4.80",
                                                                "price": "60.00",
                                                                "total": "64.80",
                                                                "taxName": "PST on Health Insurance",
                                                                "taxPrice": "4.80",
                                                                "gstTaxRate": "0.00",
                                                                "hstTaxRate": "0.00",
                                                                "pstTaxRate": "8.00",
                                                                "taxDescriptionLine": "PST on Health Insurance 8% $4.80"
                                                            },
                                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6356147",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "Complete Executive Care (<60)",
                                                                "Protect 200",
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": false,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": "6356148",
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": 6356148,
                                                            "aitestproExecutionId": null,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4193,
                                                                    "price": 60,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 17,
                                                                        "code": "protect200",
                                                                        "data": "{\"additional_instructions\": []}",
                                                                        "logo": null,
                                                                        "name": "Protect 200",
                                                                        "color": null,
                                                                        "price": 60,
                                                                        "glCode": "53210",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "127797",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 17,
                                                                    "product_id": 17,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 5881,
                                                                    "customer_plan_id": 5881
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        },
                                                        {
                                                            "id": 5880,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 29.59,
                                                            "qst": null,
                                                            "tax": 29.59,
                                                            "misc": null,
                                                            "name": "Complete Executive Care (<60)",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 369.85,
                                                            "scope": null,
                                                            "total": 399.44,
                                                            "isBulk": false,
                                                            "planId": 772,
                                                            "status": "Active",
                                                            "created": "2024-05-30 10:44:17",
                                                            "plan_id": 772,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-21 12:52:52",
                                                            "parentId": "198",
                                                            "planCode": "completeexecutivecare60",
                                                            "planName": "Complete Executive Care (<60)",
                                                            "quantity": 1,
                                                            "taxPrice": 29.59,
                                                            "totalTax": 29.59,
                                                            "coverage1": "Single",
                                                            "packageId": 5,
                                                            "customerId": 2000,
                                                            "grandTotal": 399.44,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2023-01-23",
                                                            "taxDetails": {
                                                                "tax": 29.59,
                                                                "price": 369.85,
                                                                "total": 399.44,
                                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $29.59 "
                                                            },
                                                            "taxForPlan": 29.59,
                                                            "totalPrice": 369.85,
                                                            "createdDate": "2024-05-30 10:44:17",
                                                            "customer_id": 2000,
                                                            "enrolledDate": "2023-03-01",
                                                            "taxDetailsDB": {
                                                                "gst": "0.00",
                                                                "hst": "0.00",
                                                                "pst": "29.59",
                                                                "tax": "29.59",
                                                                "price": "369.85",
                                                                "total": "399.44",
                                                                "taxName": "PST on Health Insurance",
                                                                "taxPrice": "29.59",
                                                                "gstTaxRate": "0.00",
                                                                "hstTaxRate": "0.00",
                                                                "pstTaxRate": "8.00",
                                                                "taxDescriptionLine": "PST on Health Insurance 8% $29.59"
                                                            },
                                                            "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6356145",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "Complete Executive Care (<60)",
                                                                "Protect 200",
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": false,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": "6356148",
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": 6356148,
                                                            "aitestproExecutionId": null,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4192,
                                                                    "price": 369.85,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 7,
                                                                        "code": "single",
                                                                        "data": "{\"additional_instructions\": []}",
                                                                        "logo": null,
                                                                        "name": "Single",
                                                                        "color": null,
                                                                        "price": 7.25,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126196",
                                                                        "backgroundColor": "#212A3E",
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 7,
                                                                    "product_id": 7,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 5880,
                                                                    "customer_plan_id": 5880
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "address": {
                                                    "id": 6703,
                                                    "apt": "",
                                                    "city": "Oshawa",
                                                    "line1": "1018 Highbrooke Ct",
                                                    "line2": "",
                                                    "state": "Ontario",
                                                    "country": "Canada",
                                                    "stateId": 12,
                                                    "countryId": 1,
                                                    "fusebillId": "1",
                                                    "postalCode": "L1K 2K6",
                                                    "addressType": "HOME_ADDRESS",
                                                    "contactType": "CUSTOMER",
                                                    "primaryEmail": "avery@averylaw.ca",
                                                    "primaryPhone": "+1 (416) 895-4964",
                                                    "secondaryEmail": "",
                                                    "secondaryPhone": ""
                                                },
                                                "lastName": "Avery",
                                                "firstName": "Christopher",
                                                "customerId": 2000,
                                                "staxbillId": "13195516",
                                                "accountType": "child",
                                                "companyName": "AveryLaw",
                                                "isCorporate": true,
                                                "paymentType": "NONE",
                                                "employerName": "",
                                                "invoiceAmount": 761.7,
                                                "invoiceAmountEP": 0,
                                                "workingProvince": "Ontario",
                                                "workingProvinceId": 12
                                            },
                                            {
                                                "id": 2002,
                                                "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                                "email": "shannonmpdharris@gmail.com",
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 5883,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 22.03,
                                                            "scope": null,
                                                            "total": 22.03,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-05-30 18:31:45",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 18:28:09",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2002,
                                                            "grandTotal": 22.03,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-05-30",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 22.03,
                                                            "createdDate": "2024-05-30 18:31:45",
                                                            "customer_id": 2002,
                                                            "enrolledDate": "2024-06-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6357070",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": 1,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4195,
                                                                    "price": 22.03,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 5883,
                                                                    "customer_plan_id": 5883
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ],
                                                    "subscriptions": [
                                                        {
                                                            "id": 5884,
                                                            "gst": 0,
                                                            "hst": 0,
                                                            "pst": 22.03,
                                                            "qst": 0,
                                                            "tax": 22.03,
                                                            "misc": null,
                                                            "name": "All-in Gold",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 275.43,
                                                            "scope": null,
                                                            "total": 297.46,
                                                            "isBulk": false,
                                                            "planId": 786,
                                                            "status": "Active",
                                                            "created": "2024-05-30 18:31:46",
                                                            "plan_id": 786,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 17:47:28",
                                                            "parentId": "198",
                                                            "planCode": "allingold",
                                                            "planName": "All-in Gold",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 22.03,
                                                            "coverage1": "Single",
                                                            "packageId": 1,
                                                            "customerId": 2002,
                                                            "grandTotal": 297.46,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-05-30",
                                                            "taxDetails": {
                                                                "tax": 22.03,
                                                                "price": 275.43,
                                                                "total": 297.46,
                                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $22.03 "
                                                            },
                                                            "taxForPlan": 22.03,
                                                            "totalPrice": 275.43,
                                                            "createdDate": "2024-05-30 18:31:46",
                                                            "customer_id": 2002,
                                                            "enrolledDate": "2024-06-01",
                                                            "taxDetailsDB": {
                                                                "gst": "0.00",
                                                                "hst": "0.00",
                                                                "pst": "22.03",
                                                                "tax": "22.03",
                                                                "price": "275.43",
                                                                "total": "297.46",
                                                                "taxName": "PST on Health Insurance",
                                                                "taxPrice": "22.03",
                                                                "gstTaxRate": "0.00",
                                                                "hstTaxRate": "0.00",
                                                                "pstTaxRate": "8.00",
                                                                "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                            },
                                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6357071",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": false,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": "6357070",
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": 6357070,
                                                            "aitestproExecutionId": 10600,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4196,
                                                                    "price": 275.43,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 7,
                                                                        "code": "single",
                                                                        "data": "{\"additional_instructions\": []}",
                                                                        "logo": null,
                                                                        "name": "Single",
                                                                        "color": null,
                                                                        "price": 7.25,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126196",
                                                                        "backgroundColor": "#212A3E",
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 7,
                                                                    "product_id": 7,
                                                                    "planCoverage": "SINGLE",
                                                                    "customerPlanId": 5884,
                                                                    "customer_plan_id": 5884
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "address": {
                                                    "id": 4472,
                                                    "apt": "",
                                                    "city": "Aurora",
                                                    "line1": "22 Sandusky Cr.",
                                                    "line2": "",
                                                    "state": "Ontario",
                                                    "country": "Canada",
                                                    "stateId": 12,
                                                    "countryId": 1,
                                                    "fusebillId": null,
                                                    "postalCode": "L4G3N4",
                                                    "addressType": "HOME_ADDRESS",
                                                    "contactType": "CUSTOMER",
                                                    "primaryEmail": "shannonmpdharris@gmail.com",
                                                    "primaryPhone": "+1 (416) 723-4314",
                                                    "secondaryEmail": null,
                                                    "secondaryPhone": null
                                                },
                                                "lastName": "Harris",
                                                "firstName": "Shannon",
                                                "customerId": 2002,
                                                "staxbillId": "13196440",
                                                "accountType": "child",
                                                "companyName": "AveryLaw",
                                                "isCorporate": true,
                                                "paymentType": "NONE",
                                                "employerName": "",
                                                "invoiceAmount": 297.46,
                                                "invoiceAmountEP": 0,
                                                "workingProvince": "Ontario",
                                                "workingProvinceId": 12
                                            },
                                            {
                                                "id": 2124,
                                                "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                                "email": "agica143@gmail.com",
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 6049,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 22.03,
                                                            "scope": null,
                                                            "total": 22.03,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-06-18 11:51:55",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 18:28:09",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2124,
                                                            "grandTotal": 22.03,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-06-18",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 22.03,
                                                            "createdDate": "2024-06-18 11:51:55",
                                                            "customer_id": 2124,
                                                            "enrolledDate": "2024-07-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-07-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6378369",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": 1,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4342,
                                                                    "price": 22.03,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 6049,
                                                                    "customer_plan_id": 6049
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ],
                                                    "subscriptions": [
                                                        {
                                                            "id": 6050,
                                                            "gst": 0,
                                                            "hst": 0,
                                                            "pst": 22.03,
                                                            "qst": 0,
                                                            "tax": 22.03,
                                                            "misc": null,
                                                            "name": "All-in Gold",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 275.43,
                                                            "scope": null,
                                                            "total": 297.46,
                                                            "isBulk": false,
                                                            "planId": 786,
                                                            "status": "Active",
                                                            "created": "2024-06-18 11:51:56",
                                                            "plan_id": 786,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 17:47:31",
                                                            "parentId": "198",
                                                            "planCode": "allingold",
                                                            "planName": "All-in Gold",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 22.03,
                                                            "coverage1": "Single",
                                                            "packageId": 1,
                                                            "customerId": 2124,
                                                            "grandTotal": 297.46,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-06-18",
                                                            "taxDetails": {
                                                                "tax": 22.03,
                                                                "price": 275.43,
                                                                "total": 297.46,
                                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $22.03 "
                                                            },
                                                            "taxForPlan": 22.03,
                                                            "totalPrice": 275.43,
                                                            "createdDate": "2024-06-18 11:51:56",
                                                            "customer_id": 2124,
                                                            "enrolledDate": "2024-07-01",
                                                            "taxDetailsDB": {
                                                                "gst": "0.00",
                                                                "hst": "0.00",
                                                                "pst": "22.03",
                                                                "tax": "22.03",
                                                                "price": "275.43",
                                                                "total": "297.46",
                                                                "taxName": "PST on Health Insurance",
                                                                "taxPrice": "22.03",
                                                                "gstTaxRate": "0.00",
                                                                "hstTaxRate": "0.00",
                                                                "pstTaxRate": "8.00",
                                                                "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                            },
                                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "activationDate": "2024-07-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6378370",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": false,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": "6378369",
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": 6378369,
                                                            "aitestproExecutionId": 10904,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4343,
                                                                    "price": 275.43,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 7,
                                                                        "code": "single",
                                                                        "data": "{\"additional_instructions\": []}",
                                                                        "logo": null,
                                                                        "name": "Single",
                                                                        "color": null,
                                                                        "price": 7.25,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126196",
                                                                        "backgroundColor": "#212A3E",
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 7,
                                                                    "product_id": 7,
                                                                    "planCoverage": "SINGLE",
                                                                    "customerPlanId": 6050,
                                                                    "customer_plan_id": 6050
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "address": {
                                                    "id": 4790,
                                                    "apt": "510",
                                                    "city": "Toronto",
                                                    "line1": "751 Woodbine Avenue ",
                                                    "line2": "",
                                                    "state": "Ontario",
                                                    "country": "Canada",
                                                    "stateId": 12,
                                                    "countryId": 1,
                                                    "fusebillId": null,
                                                    "postalCode": "M4E 3V5",
                                                    "addressType": "HOME_ADDRESS",
                                                    "contactType": "CUSTOMER",
                                                    "primaryEmail": "agica143@gmail.com",
                                                    "primaryPhone": "+1 (647) 803-7573",
                                                    "secondaryEmail": null,
                                                    "secondaryPhone": null
                                                },
                                                "lastName": "Illes",
                                                "firstName": "Agnes",
                                                "customerId": 2124,
                                                "staxbillId": "13248991",
                                                "accountType": "child",
                                                "companyName": "AveryLaw",
                                                "isCorporate": true,
                                                "paymentType": "NONE",
                                                "employerName": "",
                                                "invoiceAmount": 297.46,
                                                "invoiceAmountEP": 0,
                                                "workingProvince": "Ontario",
                                                "workingProvinceId": 12
                                            },
                                            {
                                                "id": 2132,
                                                "note": "Changing subscription plan state from 12 - to 12Changing subscription plan state from 12 - to 12",
                                                "email": "alexandra.cullum@uoit.net",
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 6061,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 22.03,
                                                            "scope": null,
                                                            "total": 22.03,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-06-20 15:39:18",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 18:28:09",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2132,
                                                            "grandTotal": 22.03,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-06-20",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 22.03,
                                                            "createdDate": "2024-06-20 15:39:18",
                                                            "customer_id": 2132,
                                                            "enrolledDate": "2024-07-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-07-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6381134",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": 1,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4357,
                                                                    "price": 22.03,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 6061,
                                                                    "customer_plan_id": 6061
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ],
                                                    "subscriptions": [
                                                        {
                                                            "id": 6062,
                                                            "gst": 0,
                                                            "hst": 0,
                                                            "pst": 22.03,
                                                            "qst": 0,
                                                            "tax": 22.03,
                                                            "misc": null,
                                                            "name": "All-in Gold",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 275.43,
                                                            "scope": null,
                                                            "total": 297.46,
                                                            "isBulk": false,
                                                            "planId": 786,
                                                            "status": "Active",
                                                            "created": "2024-06-20 15:39:19",
                                                            "plan_id": 786,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 17:47:31",
                                                            "parentId": "198",
                                                            "planCode": "allingold",
                                                            "planName": "All-in Gold",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 22.03,
                                                            "coverage1": "Single",
                                                            "packageId": 1,
                                                            "customerId": 2132,
                                                            "grandTotal": 297.46,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-06-20",
                                                            "taxDetails": {
                                                                "tax": 22.03,
                                                                "price": 275.43,
                                                                "total": 297.46,
                                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $22.03 "
                                                            },
                                                            "taxForPlan": 22.03,
                                                            "totalPrice": 275.43,
                                                            "createdDate": "2024-06-20 15:39:19",
                                                            "customer_id": 2132,
                                                            "enrolledDate": "2024-07-01",
                                                            "taxDetailsDB": {
                                                                "gst": "0.00",
                                                                "hst": "0.00",
                                                                "pst": "22.03",
                                                                "tax": "22.03",
                                                                "price": "275.43",
                                                                "total": "297.46",
                                                                "taxName": "PST on Health Insurance",
                                                                "taxPrice": "22.03",
                                                                "gstTaxRate": "0.00",
                                                                "hstTaxRate": "0.00",
                                                                "pstTaxRate": "8.00",
                                                                "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                            },
                                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                            "activationDate": "2024-07-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6381135",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": false,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": "6381134",
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": 6381134,
                                                            "aitestproExecutionId": 11006,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4358,
                                                                    "price": 275.43,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 7,
                                                                        "code": "single",
                                                                        "data": "{\"additional_instructions\": []}",
                                                                        "logo": null,
                                                                        "name": "Single",
                                                                        "color": null,
                                                                        "price": 7.25,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126196",
                                                                        "backgroundColor": "#212A3E",
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 7,
                                                                    "product_id": 7,
                                                                    "planCoverage": "SINGLE",
                                                                    "customerPlanId": 6062,
                                                                    "customer_plan_id": 6062
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "address": {
                                                    "id": 4814,
                                                    "apt": "",
                                                    "city": "Port Perry",
                                                    "line1": "19 Winchurch Dr.",
                                                    "line2": "",
                                                    "state": "Ontario",
                                                    "country": "Canada",
                                                    "stateId": 12,
                                                    "countryId": 1,
                                                    "fusebillId": null,
                                                    "postalCode": "L9L 1T6",
                                                    "addressType": "HOME_ADDRESS",
                                                    "contactType": "CUSTOMER",
                                                    "primaryEmail": "alexandra.cullum@uoit.net",
                                                    "primaryPhone": "+1 (905) 706-3692",
                                                    "secondaryEmail": null,
                                                    "secondaryPhone": null
                                                },
                                                "lastName": "Cullum",
                                                "firstName": "Alexandra",
                                                "customerId": 2132,
                                                "staxbillId": "13252945",
                                                "accountType": "child",
                                                "companyName": "AveryLaw",
                                                "isCorporate": true,
                                                "paymentType": "NONE",
                                                "employerName": "",
                                                "invoiceAmount": 297.46,
                                                "invoiceAmountEP": 0,
                                                "workingProvince": "Ontario",
                                                "workingProvinceId": 12
                                            }
                                        ],
                                        "employerName": "",
                                        "invoiceDate2": "2025-03-01",
                                        "invoiceAmount": 1654.08,
                                        "invoiceStatus": "POST",
                                        "overall_taxes": {
                                            "Total": 122.51,
                                            "PST on Health Insurance": 122.51
                                        },
                                        "displayVersion": true,
                                        "havingBulkPlan": false,
                                        "havingEmployees": true,
                                        "lastInvoiceDate": "2025-02-01",
                                        "previousInvoice": true,
                                        "tax_information": "{\"individual_taxes\": {\"198\": {\"customerId\": 198, \"staxbillId\": \"11663678\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"taxes\": []}}, \"2124\": {\"customerId\": 2124, \"staxbillId\": \"13248991\", \"firstName\": \"Agnes\", \"lastName\": \"Illes\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2024-06-18\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-18 11:51:55\", \"subscriptionId\": \"6378369\", \"price\": 22.03, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 22.03, \"totalPrice\": 22.03, \"totalTax\": 0, \"grandTotal\": 22.03, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2124, \"id\": 6049, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 1, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-06-18 11:51:55\", \"modified\": \"2025-01-20 18:28:09\", \"misc\": null, \"planObject\": null, \"customer_id\": 2124, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 6049, \"id\": 4342, \"planCoverage\": null, \"price\": 22.03, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6049, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2132\": {\"customerId\": 2132, \"staxbillId\": \"13252945\", \"firstName\": \"Alexandra\", \"lastName\": \"Cullum\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2024-06-20\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-20 15:39:18\", \"subscriptionId\": \"6381134\", \"price\": 22.03, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 22.03, \"totalPrice\": 22.03, \"totalTax\": 0, \"grandTotal\": 22.03, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2132, \"id\": 6061, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 1, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-06-20 15:39:18\", \"modified\": \"2025-01-20 18:28:09\", \"misc\": null, \"planObject\": null, \"customer_id\": 2132, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 6061, \"id\": 4357, \"planCoverage\": null, \"price\": 22.03, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6061, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2000\": {\"customerId\": 2000, \"staxbillId\": \"13195516\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356148\", \"price\": 56.42, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 56.42, \"totalPrice\": 56.42, \"totalTax\": 0, \"grandTotal\": 56.42, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5879, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 56.42, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 56.42, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 5879, \"id\": 4191, \"planCoverage\": null, \"price\": 56.42, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5879, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2002\": {\"customerId\": 2002, \"staxbillId\": \"13196440\", \"firstName\": \"Shannon\", \"lastName\": \"Harris\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2024-05-30\", \"enrolledDate\": \"2024-06-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 18:31:45\", \"subscriptionId\": \"6357070\", \"price\": 22.03, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 22.03, \"totalPrice\": 22.03, \"totalTax\": 0, \"grandTotal\": 22.03, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2002, \"id\": 5883, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 1, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-05-30 18:31:45\", \"modified\": \"2025-01-20 18:28:09\", \"misc\": null, \"planObject\": null, \"customer_id\": 2002, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 5883, \"id\": 4195, \"planCoverage\": null, \"price\": 22.03, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5883, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}}, \"overall_taxes\": {\"Total\": 122.51, \"PST on Health Insurance\": 122.51}}",
                                        "individual_taxes": {
                                            "198": {
                                                "plans": {
                                                    "taxes": []
                                                },
                                                "lastName": "Avery",
                                                "firstName": "Christopher",
                                                "customerId": 198,
                                                "staxbillId": "11663678"
                                            },
                                            "2000": {
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 5879,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 56.42,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 56.42,
                                                            "scope": null,
                                                            "total": 56.42,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-05-30 10:44:17",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-21 12:52:52",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 56.42,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2000,
                                                            "grandTotal": 56.42,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2023-01-23",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 56.42,
                                                            "createdDate": "2024-05-30 10:44:17",
                                                            "customer_id": 2000,
                                                            "enrolledDate": "2023-03-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6356148",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "Complete Executive Care (<60)",
                                                                "Protect 200",
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": null,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4191,
                                                                    "price": 56.42,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 5879,
                                                                    "customer_plan_id": 5879
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "lastName": "Avery",
                                                "firstName": "Christopher",
                                                "customerId": 2000,
                                                "staxbillId": "13195516"
                                            },
                                            "2002": {
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 5883,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 22.03,
                                                            "scope": null,
                                                            "total": 22.03,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-05-30 18:31:45",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 18:28:09",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2002,
                                                            "grandTotal": 22.03,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-05-30",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 22.03,
                                                            "createdDate": "2024-05-30 18:31:45",
                                                            "customer_id": 2002,
                                                            "enrolledDate": "2024-06-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6357070",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": 1,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4195,
                                                                    "price": 22.03,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 5883,
                                                                    "customer_plan_id": 5883
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "lastName": "Harris",
                                                "firstName": "Shannon",
                                                "customerId": 2002,
                                                "staxbillId": "13196440"
                                            },
                                            "2124": {
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 6049,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 22.03,
                                                            "scope": null,
                                                            "total": 22.03,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-06-18 11:51:55",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 18:28:09",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2124,
                                                            "grandTotal": 22.03,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-06-18",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 22.03,
                                                            "createdDate": "2024-06-18 11:51:55",
                                                            "customer_id": 2124,
                                                            "enrolledDate": "2024-07-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-07-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6378369",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": 1,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4342,
                                                                    "price": 22.03,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 6049,
                                                                    "customer_plan_id": 6049
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "lastName": "Illes",
                                                "firstName": "Agnes",
                                                "customerId": 2124,
                                                "staxbillId": "13248991"
                                            },
                                            "2132": {
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 6061,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 22.03,
                                                            "scope": null,
                                                            "total": 22.03,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-06-20 15:39:18",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 18:28:09",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2132,
                                                            "grandTotal": 22.03,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-06-20",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 22.03,
                                                            "createdDate": "2024-06-20 15:39:18",
                                                            "customer_id": 2132,
                                                            "enrolledDate": "2024-07-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-07-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6381134",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": 1,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4357,
                                                                    "price": 22.03,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 6061,
                                                                    "customer_plan_id": 6061
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "lastName": "Cullum",
                                                "firstName": "Alexandra",
                                                "customerId": 2132,
                                                "staxbillId": "13252945"
                                            }
                                        },
                                        "plan_information": "{\"198\": {\"customerId\": 198, \"staxbillId\": \"11663678\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"subscriptions\": []}}, \"2124\": {\"customerId\": 2124, \"staxbillId\": \"13248991\", \"firstName\": \"Agnes\", \"lastName\": \"Illes\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 275.43, \"tax\": 22.03, \"total\": 297.46, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $22.03 \"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 22.03, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2024-06-18\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-18 11:51:56\", \"subscriptionId\": \"6378370\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 22.03, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"total\": 297.46, \"totalPrice\": 275.43, \"totalTax\": 22.03, \"grandTotal\": 297.46, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2124, \"id\": 6050, \"planId\": 786, \"status\": \"Active\", \"hst\": 0, \"gst\": 0, \"pst\": 22.03, \"qst\": 0, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 10904, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6378369\", \"isBulk\": false, \"created\": \"2024-06-18 11:51:56\", \"modified\": \"2025-01-20 17:47:31\", \"misc\": null, \"planObject\": null, \"customer_id\": 2124, \"plan_id\": 786, \"tax_subscription_id\": 6378369, \"customerPlanProducts\": [{\"customerPlanId\": 6050, \"id\": 4343, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6050, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}]}}, \"2132\": {\"customerId\": 2132, \"staxbillId\": \"13252945\", \"firstName\": \"Alexandra\", \"lastName\": \"Cullum\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 275.43, \"tax\": 22.03, \"total\": 297.46, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $22.03 \"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 22.03, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2024-06-20\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-20 15:39:19\", \"subscriptionId\": \"6381135\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 22.03, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"total\": 297.46, \"totalPrice\": 275.43, \"totalTax\": 22.03, \"grandTotal\": 297.46, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2132, \"id\": 6062, \"planId\": 786, \"status\": \"Active\", \"hst\": 0, \"gst\": 0, \"pst\": 22.03, \"qst\": 0, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 11006, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6381134\", \"isBulk\": false, \"created\": \"2024-06-20 15:39:19\", \"modified\": \"2025-01-20 17:47:31\", \"misc\": null, \"planObject\": null, \"customer_id\": 2132, \"plan_id\": 786, \"tax_subscription_id\": 6381134, \"customerPlanProducts\": [{\"customerPlanId\": 6062, \"id\": 4358, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6062, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}]}}, \"2000\": {\"customerId\": 2000, \"staxbillId\": \"13195516\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 0, \"tax\": 0, \"total\": 0, \"taxDescriptionLine\": \"\"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356146\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"total\": 275.43, \"totalPrice\": 275.43, \"totalTax\": 0, \"grandTotal\": 275.43, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5882, \"planId\": 786, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6356148\", \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 786, \"tax_subscription_id\": 6356148, \"customerPlanProducts\": [{\"customerPlanId\": 5882, \"id\": 4194, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5882, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}, {\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 60, \"tax\": 4.8, \"total\": 64.8, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $4.80 \"}, \"taxDetailsDB\": {\"pst\": \"4.80\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"4.80\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $4.80\", \"tax\": \"4.80\", \"price\": \"60.00\", \"total\": \"64.80\"}, \"taxForPlan\": 4.8, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356147\", \"price\": 60, \"quantity\": 1, \"count\": 1, \"tax\": 4.8, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"total\": 64.8, \"totalPrice\": 60, \"totalTax\": 4.8, \"grandTotal\": 64.8, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5881, \"planId\": 776, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 4.8, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 4.8, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6356148\", \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 776, \"tax_subscription_id\": 6356148, \"customerPlanProducts\": [{\"customerPlanId\": 5881, \"id\": 4193, \"planCoverage\": null, \"price\": 60, \"productId\": 17, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5881, \"product_id\": 17, \"product\": {\"backgroundColor\": null, \"code\": \"protect200\", \"color\": null, \"fusebillId\": \"127797\", \"glCode\": \"53210\", \"id\": 17, \"name\": \"Protect 200\", \"price\": 60, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"GroupBenefitz Protect\", \"name\": \"GroupBenefitz Protect\", \"planCode\": \"groupbenefitzprotectsinglesku\", \"packageId\": 4}, {\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 369.85, \"tax\": 29.59, \"total\": 399.44, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $29.59 \"}, \"taxDetailsDB\": {\"pst\": \"29.59\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"29.59\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $29.59\", \"tax\": \"29.59\", \"price\": \"369.85\", \"total\": \"399.44\"}, \"taxForPlan\": 29.59, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356145\", \"price\": 369.85, \"quantity\": 1, \"count\": 1, \"tax\": 29.59, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | \", \"total\": 399.44, \"totalPrice\": 369.85, \"totalTax\": 29.59, \"grandTotal\": 399.44, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5880, \"planId\": 772, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 29.59, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 29.59, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6356148\", \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 772, \"tax_subscription_id\": 6356148, \"customerPlanProducts\": [{\"customerPlanId\": 5880, \"id\": 4192, \"planCoverage\": null, \"price\": 369.85, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5880, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"Complete Executive Care (<60)\", \"name\": \"Complete Executive Care (<60)\", \"planCode\": \"completeexecutivecare60\", \"packageId\": 5}]}}, \"2002\": {\"customerId\": 2002, \"staxbillId\": \"13196440\", \"firstName\": \"Shannon\", \"lastName\": \"Harris\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 275.43, \"tax\": 22.03, \"total\": 297.46, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $22.03 \"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 22.03, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2024-05-30\", \"enrolledDate\": \"2024-06-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 18:31:46\", \"subscriptionId\": \"6357071\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 22.03, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"total\": 297.46, \"totalPrice\": 275.43, \"totalTax\": 22.03, \"grandTotal\": 297.46, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2002, \"id\": 5884, \"planId\": 786, \"status\": \"Active\", \"hst\": 0, \"gst\": 0, \"pst\": 22.03, \"qst\": 0, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 10600, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6357070\", \"isBulk\": false, \"created\": \"2024-05-30 18:31:46\", \"modified\": \"2025-01-20 17:47:28\", \"misc\": null, \"planObject\": null, \"customer_id\": 2002, \"plan_id\": 786, \"tax_subscription_id\": 6357070, \"customerPlanProducts\": [{\"customerPlanId\": 5884, \"id\": 4196, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5884, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}]}}}",
                                        "lastInvoiceAmount": 1654.08,
                                        "invoicePaymentDate": "2025-03-01",
                                        "lastInvoicePayment": 1654.08,
                                        "contact_information": "{\"stateId\": 12, \"workingProvinceId\": 12, \"state\": \"Ontario\", \"workingProvince\": \"Ontario\"}",
                                        "handleInvoiceHistory": true
                                    },
                                    "paymentStatus": null,
                                    "invoiceHistory": null,
                                    "taxInformation": {
                                        "overall_taxes": {
                                            "Total": 122.51,
                                            "PST on Health Insurance": 122.51
                                        },
                                        "individual_taxes": {
                                            "198": {
                                                "plans": {
                                                    "taxes": []
                                                },
                                                "lastName": "Avery",
                                                "firstName": "Christopher",
                                                "customerId": 198,
                                                "staxbillId": "11663678"
                                            },
                                            "2000": {
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 5879,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 56.42,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 56.42,
                                                            "scope": null,
                                                            "total": 56.42,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-05-30 10:44:17",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-21 12:52:52",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 56.42,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2000,
                                                            "grandTotal": 56.42,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2023-01-23",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 56.42,
                                                            "createdDate": "2024-05-30 10:44:17",
                                                            "customer_id": 2000,
                                                            "enrolledDate": "2023-03-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6356148",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "Complete Executive Care (<60)",
                                                                "Protect 200",
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": null,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4191,
                                                                    "price": 56.42,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 5879,
                                                                    "customer_plan_id": 5879
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "lastName": "Avery",
                                                "firstName": "Christopher",
                                                "customerId": 2000,
                                                "staxbillId": "13195516"
                                            },
                                            "2002": {
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 5883,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 22.03,
                                                            "scope": null,
                                                            "total": 22.03,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-05-30 18:31:45",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 18:28:09",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2002,
                                                            "grandTotal": 22.03,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-05-30",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 22.03,
                                                            "createdDate": "2024-05-30 18:31:45",
                                                            "customer_id": 2002,
                                                            "enrolledDate": "2024-06-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-06-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6357070",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": 1,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4195,
                                                                    "price": 22.03,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 5883,
                                                                    "customer_plan_id": 5883
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "lastName": "Harris",
                                                "firstName": "Shannon",
                                                "customerId": 2002,
                                                "staxbillId": "13196440"
                                            },
                                            "2124": {
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 6049,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 22.03,
                                                            "scope": null,
                                                            "total": 22.03,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-06-18 11:51:55",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 18:28:09",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2124,
                                                            "grandTotal": 22.03,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-06-18",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 22.03,
                                                            "createdDate": "2024-06-18 11:51:55",
                                                            "customer_id": 2124,
                                                            "enrolledDate": "2024-07-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-07-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6378369",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": 1,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4342,
                                                                    "price": 22.03,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 6049,
                                                                    "customer_plan_id": 6049
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "lastName": "Illes",
                                                "firstName": "Agnes",
                                                "customerId": 2124,
                                                "staxbillId": "13248991"
                                            },
                                            "2132": {
                                                "plans": {
                                                    "taxes": [
                                                        {
                                                            "id": 6061,
                                                            "gst": null,
                                                            "hst": null,
                                                            "pst": 22.03,
                                                            "qst": null,
                                                            "tax": 0,
                                                            "misc": null,
                                                            "name": "Taxes",
                                                            "type": "100% Company Paid",
                                                            "count": 1,
                                                            "price": 22.03,
                                                            "scope": null,
                                                            "total": 22.03,
                                                            "isBulk": false,
                                                            "planId": 765,
                                                            "status": "Active",
                                                            "created": "2024-06-20 15:39:18",
                                                            "plan_id": 765,
                                                            "stateId": 12,
                                                            "summary": null,
                                                            "taxCode": null,
                                                            "taxName": "PST on Health Insurance",
                                                            "version": null,
                                                            "coverage": "SINGLE",
                                                            "modified": "2025-01-20 18:28:09",
                                                            "parentId": "198",
                                                            "planCode": "taxes1",
                                                            "planName": "Taxes",
                                                            "quantity": 1,
                                                            "taxPrice": 22.03,
                                                            "totalTax": 0,
                                                            "coverage1": "-",
                                                            "packageId": null,
                                                            "customerId": 2132,
                                                            "grandTotal": 22.03,
                                                            "gstTaxRate": null,
                                                            "hstTaxRate": null,
                                                            "planObject": null,
                                                            "pstTaxRate": 8,
                                                            "qstTaxRate": null,
                                                            "signupDate": "2024-06-20",
                                                            "taxForPlan": 0,
                                                            "totalPrice": 22.03,
                                                            "createdDate": "2024-06-20 15:39:18",
                                                            "customer_id": 2132,
                                                            "enrolledDate": "2024-07-01",
                                                            "taxStatement": "",
                                                            "bulkPlanLevel": null,
                                                            "paidByCompany": 1,
                                                            "taxStatement1": "",
                                                            "activationDate": "2024-07-01 04:00:00",
                                                            "paidByEmployee": null,
                                                            "subscriptionId": "6381134",
                                                            "workingStateId": 12,
                                                            "bundledProducts": [
                                                                "All-in Gold"
                                                            ],
                                                            "lastBillingDate": null,
                                                            "nextBillingDate": null,
                                                            "terminationDate": null,
                                                            "cancellationDate": null,
                                                            "coveredByCompany": null,
                                                            "nextBillingPrice": null,
                                                            "restrictedAccess": null,
                                                            "isSubscriptionTax": true,
                                                            "reinstatementDate": null,
                                                            "taxSubscriptionId": null,
                                                            "terminationReason": null,
                                                            "reinstatementReason": null,
                                                            "tax_subscription_id": null,
                                                            "aitestproExecutionId": 1,
                                                            "customerPlanProducts": [
                                                                {
                                                                    "id": 4357,
                                                                    "price": 22.03,
                                                                    "taxSku": null,
                                                                    "product": {
                                                                        "id": 2,
                                                                        "code": "pstonhealthinsurance",
                                                                        "data": null,
                                                                        "logo": null,
                                                                        "name": "PST on Health Insurance",
                                                                        "color": null,
                                                                        "price": 0,
                                                                        "glCode": "53211",
                                                                        "display": "TITLE",
                                                                        "published": true,
                                                                        "fusebillId": "126201",
                                                                        "backgroundColor": null,
                                                                        "includedProducts": null
                                                                    },
                                                                    "taxCode": null,
                                                                    "taxName": null,
                                                                    "version": null,
                                                                    "productId": 2,
                                                                    "product_id": 2,
                                                                    "planCoverage": null,
                                                                    "customerPlanId": 6061,
                                                                    "customer_plan_id": 6061
                                                                }
                                                            ],
                                                            "backdatedActivationDate": null,
                                                            "backdatedCancellationDate": null
                                                        }
                                                    ]
                                                },
                                                "lastName": "Cullum",
                                                "firstName": "Alexandra",
                                                "customerId": 2132,
                                                "staxbillId": "13252945"
                                            }
                                        }
                                    },
                                    "planInformation": {
                                        "198": {
                                            "plans": {
                                                "subscriptions": []
                                            },
                                            "lastName": "Avery",
                                            "firstName": "Christopher",
                                            "customerId": 198,
                                            "staxbillId": "11663678"
                                        },
                                        "2000": {
                                            "plans": {
                                                "subscriptions": [
                                                    {
                                                        "id": 5882,
                                                        "gst": null,
                                                        "hst": null,
                                                        "pst": 22.03,
                                                        "qst": null,
                                                        "tax": 0,
                                                        "misc": null,
                                                        "name": "All-in Gold",
                                                        "type": "100% Company Paid",
                                                        "count": 1,
                                                        "price": 275.43,
                                                        "scope": null,
                                                        "total": 275.43,
                                                        "isBulk": false,
                                                        "planId": 786,
                                                        "status": "Active",
                                                        "created": "2024-05-30 10:44:17",
                                                        "plan_id": 786,
                                                        "stateId": 12,
                                                        "summary": null,
                                                        "taxCode": null,
                                                        "taxName": "PST on Health Insurance",
                                                        "version": null,
                                                        "coverage": "SINGLE",
                                                        "modified": "2025-01-21 12:52:52",
                                                        "parentId": "198",
                                                        "planCode": "allingold",
                                                        "planName": "All-in Gold",
                                                        "quantity": 1,
                                                        "taxPrice": 22.03,
                                                        "totalTax": 0,
                                                        "coverage1": "Single",
                                                        "packageId": 1,
                                                        "customerId": 2000,
                                                        "grandTotal": 275.43,
                                                        "gstTaxRate": null,
                                                        "hstTaxRate": null,
                                                        "planObject": null,
                                                        "pstTaxRate": 8,
                                                        "qstTaxRate": null,
                                                        "signupDate": "2023-01-23",
                                                        "taxDetails": {
                                                            "tax": 0,
                                                            "price": 0,
                                                            "total": 0,
                                                            "taxDescriptionLine": ""
                                                        },
                                                        "taxForPlan": 0,
                                                        "totalPrice": 275.43,
                                                        "createdDate": "2024-05-30 10:44:17",
                                                        "customer_id": 2000,
                                                        "enrolledDate": "2023-03-01",
                                                        "taxDetailsDB": {
                                                            "gst": "0.00",
                                                            "hst": "0.00",
                                                            "pst": "22.03",
                                                            "tax": "22.03",
                                                            "price": "275.43",
                                                            "total": "297.46",
                                                            "taxName": "PST on Health Insurance",
                                                            "taxPrice": "22.03",
                                                            "gstTaxRate": "0.00",
                                                            "hstTaxRate": "0.00",
                                                            "pstTaxRate": "8.00",
                                                            "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                        },
                                                        "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "bulkPlanLevel": null,
                                                        "paidByCompany": 1,
                                                        "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "activationDate": "2024-06-01 04:00:00",
                                                        "paidByEmployee": null,
                                                        "subscriptionId": "6356146",
                                                        "workingStateId": 12,
                                                        "bundledProducts": [
                                                            "Complete Executive Care (<60)",
                                                            "Protect 200",
                                                            "All-in Gold"
                                                        ],
                                                        "lastBillingDate": null,
                                                        "nextBillingDate": null,
                                                        "terminationDate": null,
                                                        "cancellationDate": null,
                                                        "coveredByCompany": null,
                                                        "nextBillingPrice": null,
                                                        "restrictedAccess": null,
                                                        "isSubscriptionTax": false,
                                                        "reinstatementDate": null,
                                                        "taxSubscriptionId": "6356148",
                                                        "terminationReason": null,
                                                        "reinstatementReason": null,
                                                        "tax_subscription_id": 6356148,
                                                        "aitestproExecutionId": null,
                                                        "customerPlanProducts": [
                                                            {
                                                                "id": 4194,
                                                                "price": 275.43,
                                                                "taxSku": null,
                                                                "product": {
                                                                    "id": 7,
                                                                    "code": "single",
                                                                    "data": "{\"additional_instructions\": []}",
                                                                    "logo": null,
                                                                    "name": "Single",
                                                                    "color": null,
                                                                    "price": 7.25,
                                                                    "glCode": "53211",
                                                                    "display": "TITLE",
                                                                    "published": true,
                                                                    "fusebillId": "126196",
                                                                    "backgroundColor": "#212A3E",
                                                                    "includedProducts": null
                                                                },
                                                                "taxCode": null,
                                                                "taxName": null,
                                                                "version": null,
                                                                "productId": 7,
                                                                "product_id": 7,
                                                                "planCoverage": "SINGLE",
                                                                "customerPlanId": 5882,
                                                                "customer_plan_id": 5882
                                                            }
                                                        ],
                                                        "backdatedActivationDate": null,
                                                        "backdatedCancellationDate": null
                                                    },
                                                    {
                                                        "id": 5881,
                                                        "gst": null,
                                                        "hst": null,
                                                        "pst": 4.8,
                                                        "qst": null,
                                                        "tax": 4.8,
                                                        "misc": null,
                                                        "name": "GroupBenefitz Protect",
                                                        "type": "100% Company Paid",
                                                        "count": 1,
                                                        "price": 60,
                                                        "scope": null,
                                                        "total": 64.8,
                                                        "isBulk": false,
                                                        "planId": 776,
                                                        "status": "Active",
                                                        "created": "2024-05-30 10:44:17",
                                                        "plan_id": 776,
                                                        "stateId": 12,
                                                        "summary": null,
                                                        "taxCode": null,
                                                        "taxName": "PST on Health Insurance",
                                                        "version": null,
                                                        "coverage": "SINGLE",
                                                        "modified": "2025-01-21 12:52:52",
                                                        "parentId": "198",
                                                        "planCode": "groupbenefitzprotectsinglesku",
                                                        "planName": "GroupBenefitz Protect",
                                                        "quantity": 1,
                                                        "taxPrice": 4.8,
                                                        "totalTax": 4.8,
                                                        "coverage1": "-",
                                                        "packageId": 4,
                                                        "customerId": 2000,
                                                        "grandTotal": 64.8,
                                                        "gstTaxRate": null,
                                                        "hstTaxRate": null,
                                                        "planObject": null,
                                                        "pstTaxRate": 8,
                                                        "qstTaxRate": null,
                                                        "signupDate": "2023-01-23",
                                                        "taxDetails": {
                                                            "tax": 4.8,
                                                            "price": 60,
                                                            "total": 64.8,
                                                            "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $4.80 "
                                                        },
                                                        "taxForPlan": 4.8,
                                                        "totalPrice": 60,
                                                        "createdDate": "2024-05-30 10:44:17",
                                                        "customer_id": 2000,
                                                        "enrolledDate": "2023-03-01",
                                                        "taxDetailsDB": {
                                                            "gst": "0.00",
                                                            "hst": "0.00",
                                                            "pst": "4.80",
                                                            "tax": "4.80",
                                                            "price": "60.00",
                                                            "total": "64.80",
                                                            "taxName": "PST on Health Insurance",
                                                            "taxPrice": "4.80",
                                                            "gstTaxRate": "0.00",
                                                            "hstTaxRate": "0.00",
                                                            "pstTaxRate": "8.00",
                                                            "taxDescriptionLine": "PST on Health Insurance 8% $4.80"
                                                        },
                                                        "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "bulkPlanLevel": null,
                                                        "paidByCompany": 1,
                                                        "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "activationDate": "2024-06-01 04:00:00",
                                                        "paidByEmployee": null,
                                                        "subscriptionId": "6356147",
                                                        "workingStateId": 12,
                                                        "bundledProducts": [
                                                            "Complete Executive Care (<60)",
                                                            "Protect 200",
                                                            "All-in Gold"
                                                        ],
                                                        "lastBillingDate": null,
                                                        "nextBillingDate": null,
                                                        "terminationDate": null,
                                                        "cancellationDate": null,
                                                        "coveredByCompany": null,
                                                        "nextBillingPrice": null,
                                                        "restrictedAccess": null,
                                                        "isSubscriptionTax": false,
                                                        "reinstatementDate": null,
                                                        "taxSubscriptionId": "6356148",
                                                        "terminationReason": null,
                                                        "reinstatementReason": null,
                                                        "tax_subscription_id": 6356148,
                                                        "aitestproExecutionId": null,
                                                        "customerPlanProducts": [
                                                            {
                                                                "id": 4193,
                                                                "price": 60,
                                                                "taxSku": null,
                                                                "product": {
                                                                    "id": 17,
                                                                    "code": "protect200",
                                                                    "data": "{\"additional_instructions\": []}",
                                                                    "logo": null,
                                                                    "name": "Protect 200",
                                                                    "color": null,
                                                                    "price": 60,
                                                                    "glCode": "53210",
                                                                    "display": "TITLE",
                                                                    "published": true,
                                                                    "fusebillId": "127797",
                                                                    "backgroundColor": null,
                                                                    "includedProducts": null
                                                                },
                                                                "taxCode": null,
                                                                "taxName": null,
                                                                "version": null,
                                                                "productId": 17,
                                                                "product_id": 17,
                                                                "planCoverage": null,
                                                                "customerPlanId": 5881,
                                                                "customer_plan_id": 5881
                                                            }
                                                        ],
                                                        "backdatedActivationDate": null,
                                                        "backdatedCancellationDate": null
                                                    },
                                                    {
                                                        "id": 5880,
                                                        "gst": null,
                                                        "hst": null,
                                                        "pst": 29.59,
                                                        "qst": null,
                                                        "tax": 29.59,
                                                        "misc": null,
                                                        "name": "Complete Executive Care (<60)",
                                                        "type": "100% Company Paid",
                                                        "count": 1,
                                                        "price": 369.85,
                                                        "scope": null,
                                                        "total": 399.44,
                                                        "isBulk": false,
                                                        "planId": 772,
                                                        "status": "Active",
                                                        "created": "2024-05-30 10:44:17",
                                                        "plan_id": 772,
                                                        "stateId": 12,
                                                        "summary": null,
                                                        "taxCode": null,
                                                        "taxName": "PST on Health Insurance",
                                                        "version": null,
                                                        "coverage": "SINGLE",
                                                        "modified": "2025-01-21 12:52:52",
                                                        "parentId": "198",
                                                        "planCode": "completeexecutivecare60",
                                                        "planName": "Complete Executive Care (<60)",
                                                        "quantity": 1,
                                                        "taxPrice": 29.59,
                                                        "totalTax": 29.59,
                                                        "coverage1": "Single",
                                                        "packageId": 5,
                                                        "customerId": 2000,
                                                        "grandTotal": 399.44,
                                                        "gstTaxRate": null,
                                                        "hstTaxRate": null,
                                                        "planObject": null,
                                                        "pstTaxRate": 8,
                                                        "qstTaxRate": null,
                                                        "signupDate": "2023-01-23",
                                                        "taxDetails": {
                                                            "tax": 29.59,
                                                            "price": 369.85,
                                                            "total": 399.44,
                                                            "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $29.59 "
                                                        },
                                                        "taxForPlan": 29.59,
                                                        "totalPrice": 369.85,
                                                        "createdDate": "2024-05-30 10:44:17",
                                                        "customer_id": 2000,
                                                        "enrolledDate": "2023-03-01",
                                                        "taxDetailsDB": {
                                                            "gst": "0.00",
                                                            "hst": "0.00",
                                                            "pst": "29.59",
                                                            "tax": "29.59",
                                                            "price": "369.85",
                                                            "total": "399.44",
                                                            "taxName": "PST on Health Insurance",
                                                            "taxPrice": "29.59",
                                                            "gstTaxRate": "0.00",
                                                            "hstTaxRate": "0.00",
                                                            "pstTaxRate": "8.00",
                                                            "taxDescriptionLine": "PST on Health Insurance 8% $29.59"
                                                        },
                                                        "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                                        "bulkPlanLevel": null,
                                                        "paidByCompany": 1,
                                                        "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                                        "activationDate": "2024-06-01 04:00:00",
                                                        "paidByEmployee": null,
                                                        "subscriptionId": "6356145",
                                                        "workingStateId": 12,
                                                        "bundledProducts": [
                                                            "Complete Executive Care (<60)",
                                                            "Protect 200",
                                                            "All-in Gold"
                                                        ],
                                                        "lastBillingDate": null,
                                                        "nextBillingDate": null,
                                                        "terminationDate": null,
                                                        "cancellationDate": null,
                                                        "coveredByCompany": null,
                                                        "nextBillingPrice": null,
                                                        "restrictedAccess": null,
                                                        "isSubscriptionTax": false,
                                                        "reinstatementDate": null,
                                                        "taxSubscriptionId": "6356148",
                                                        "terminationReason": null,
                                                        "reinstatementReason": null,
                                                        "tax_subscription_id": 6356148,
                                                        "aitestproExecutionId": null,
                                                        "customerPlanProducts": [
                                                            {
                                                                "id": 4192,
                                                                "price": 369.85,
                                                                "taxSku": null,
                                                                "product": {
                                                                    "id": 7,
                                                                    "code": "single",
                                                                    "data": "{\"additional_instructions\": []}",
                                                                    "logo": null,
                                                                    "name": "Single",
                                                                    "color": null,
                                                                    "price": 7.25,
                                                                    "glCode": "53211",
                                                                    "display": "TITLE",
                                                                    "published": true,
                                                                    "fusebillId": "126196",
                                                                    "backgroundColor": "#212A3E",
                                                                    "includedProducts": null
                                                                },
                                                                "taxCode": null,
                                                                "taxName": null,
                                                                "version": null,
                                                                "productId": 7,
                                                                "product_id": 7,
                                                                "planCoverage": null,
                                                                "customerPlanId": 5880,
                                                                "customer_plan_id": 5880
                                                            }
                                                        ],
                                                        "backdatedActivationDate": null,
                                                        "backdatedCancellationDate": null
                                                    }
                                                ]
                                            },
                                            "lastName": "Avery",
                                            "firstName": "Christopher",
                                            "customerId": 2000,
                                            "staxbillId": "13195516"
                                        },
                                        "2002": {
                                            "plans": {
                                                "subscriptions": [
                                                    {
                                                        "id": 5884,
                                                        "gst": 0,
                                                        "hst": 0,
                                                        "pst": 22.03,
                                                        "qst": 0,
                                                        "tax": 22.03,
                                                        "misc": null,
                                                        "name": "All-in Gold",
                                                        "type": "100% Company Paid",
                                                        "count": 1,
                                                        "price": 275.43,
                                                        "scope": null,
                                                        "total": 297.46,
                                                        "isBulk": false,
                                                        "planId": 786,
                                                        "status": "Active",
                                                        "created": "2024-05-30 18:31:46",
                                                        "plan_id": 786,
                                                        "stateId": 12,
                                                        "summary": null,
                                                        "taxCode": null,
                                                        "taxName": "PST on Health Insurance",
                                                        "version": null,
                                                        "coverage": "SINGLE",
                                                        "modified": "2025-01-20 17:47:28",
                                                        "parentId": "198",
                                                        "planCode": "allingold",
                                                        "planName": "All-in Gold",
                                                        "quantity": 1,
                                                        "taxPrice": 22.03,
                                                        "totalTax": 22.03,
                                                        "coverage1": "Single",
                                                        "packageId": 1,
                                                        "customerId": 2002,
                                                        "grandTotal": 297.46,
                                                        "gstTaxRate": null,
                                                        "hstTaxRate": null,
                                                        "planObject": null,
                                                        "pstTaxRate": 8,
                                                        "qstTaxRate": null,
                                                        "signupDate": "2024-05-30",
                                                        "taxDetails": {
                                                            "tax": 22.03,
                                                            "price": 275.43,
                                                            "total": 297.46,
                                                            "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $22.03 "
                                                        },
                                                        "taxForPlan": 22.03,
                                                        "totalPrice": 275.43,
                                                        "createdDate": "2024-05-30 18:31:46",
                                                        "customer_id": 2002,
                                                        "enrolledDate": "2024-06-01",
                                                        "taxDetailsDB": {
                                                            "gst": "0.00",
                                                            "hst": "0.00",
                                                            "pst": "22.03",
                                                            "tax": "22.03",
                                                            "price": "275.43",
                                                            "total": "297.46",
                                                            "taxName": "PST on Health Insurance",
                                                            "taxPrice": "22.03",
                                                            "gstTaxRate": "0.00",
                                                            "hstTaxRate": "0.00",
                                                            "pstTaxRate": "8.00",
                                                            "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                        },
                                                        "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "bulkPlanLevel": null,
                                                        "paidByCompany": 1,
                                                        "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "activationDate": "2024-06-01 04:00:00",
                                                        "paidByEmployee": null,
                                                        "subscriptionId": "6357071",
                                                        "workingStateId": 12,
                                                        "bundledProducts": [
                                                            "All-in Gold"
                                                        ],
                                                        "lastBillingDate": null,
                                                        "nextBillingDate": null,
                                                        "terminationDate": null,
                                                        "cancellationDate": null,
                                                        "coveredByCompany": null,
                                                        "nextBillingPrice": null,
                                                        "restrictedAccess": null,
                                                        "isSubscriptionTax": false,
                                                        "reinstatementDate": null,
                                                        "taxSubscriptionId": "6357070",
                                                        "terminationReason": null,
                                                        "reinstatementReason": null,
                                                        "tax_subscription_id": 6357070,
                                                        "aitestproExecutionId": 10600,
                                                        "customerPlanProducts": [
                                                            {
                                                                "id": 4196,
                                                                "price": 275.43,
                                                                "taxSku": null,
                                                                "product": {
                                                                    "id": 7,
                                                                    "code": "single",
                                                                    "data": "{\"additional_instructions\": []}",
                                                                    "logo": null,
                                                                    "name": "Single",
                                                                    "color": null,
                                                                    "price": 7.25,
                                                                    "glCode": "53211",
                                                                    "display": "TITLE",
                                                                    "published": true,
                                                                    "fusebillId": "126196",
                                                                    "backgroundColor": "#212A3E",
                                                                    "includedProducts": null
                                                                },
                                                                "taxCode": null,
                                                                "taxName": null,
                                                                "version": null,
                                                                "productId": 7,
                                                                "product_id": 7,
                                                                "planCoverage": "SINGLE",
                                                                "customerPlanId": 5884,
                                                                "customer_plan_id": 5884
                                                            }
                                                        ],
                                                        "backdatedActivationDate": null,
                                                        "backdatedCancellationDate": null
                                                    }
                                                ]
                                            },
                                            "lastName": "Harris",
                                            "firstName": "Shannon",
                                            "customerId": 2002,
                                            "staxbillId": "13196440"
                                        },
                                        "2124": {
                                            "plans": {
                                                "subscriptions": [
                                                    {
                                                        "id": 6050,
                                                        "gst": 0,
                                                        "hst": 0,
                                                        "pst": 22.03,
                                                        "qst": 0,
                                                        "tax": 22.03,
                                                        "misc": null,
                                                        "name": "All-in Gold",
                                                        "type": "100% Company Paid",
                                                        "count": 1,
                                                        "price": 275.43,
                                                        "scope": null,
                                                        "total": 297.46,
                                                        "isBulk": false,
                                                        "planId": 786,
                                                        "status": "Active",
                                                        "created": "2024-06-18 11:51:56",
                                                        "plan_id": 786,
                                                        "stateId": 12,
                                                        "summary": null,
                                                        "taxCode": null,
                                                        "taxName": "PST on Health Insurance",
                                                        "version": null,
                                                        "coverage": "SINGLE",
                                                        "modified": "2025-01-20 17:47:31",
                                                        "parentId": "198",
                                                        "planCode": "allingold",
                                                        "planName": "All-in Gold",
                                                        "quantity": 1,
                                                        "taxPrice": 22.03,
                                                        "totalTax": 22.03,
                                                        "coverage1": "Single",
                                                        "packageId": 1,
                                                        "customerId": 2124,
                                                        "grandTotal": 297.46,
                                                        "gstTaxRate": null,
                                                        "hstTaxRate": null,
                                                        "planObject": null,
                                                        "pstTaxRate": 8,
                                                        "qstTaxRate": null,
                                                        "signupDate": "2024-06-18",
                                                        "taxDetails": {
                                                            "tax": 22.03,
                                                            "price": 275.43,
                                                            "total": 297.46,
                                                            "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $22.03 "
                                                        },
                                                        "taxForPlan": 22.03,
                                                        "totalPrice": 275.43,
                                                        "createdDate": "2024-06-18 11:51:56",
                                                        "customer_id": 2124,
                                                        "enrolledDate": "2024-07-01",
                                                        "taxDetailsDB": {
                                                            "gst": "0.00",
                                                            "hst": "0.00",
                                                            "pst": "22.03",
                                                            "tax": "22.03",
                                                            "price": "275.43",
                                                            "total": "297.46",
                                                            "taxName": "PST on Health Insurance",
                                                            "taxPrice": "22.03",
                                                            "gstTaxRate": "0.00",
                                                            "hstTaxRate": "0.00",
                                                            "pstTaxRate": "8.00",
                                                            "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                        },
                                                        "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "bulkPlanLevel": null,
                                                        "paidByCompany": 1,
                                                        "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "activationDate": "2024-07-01 04:00:00",
                                                        "paidByEmployee": null,
                                                        "subscriptionId": "6378370",
                                                        "workingStateId": 12,
                                                        "bundledProducts": [
                                                            "All-in Gold"
                                                        ],
                                                        "lastBillingDate": null,
                                                        "nextBillingDate": null,
                                                        "terminationDate": null,
                                                        "cancellationDate": null,
                                                        "coveredByCompany": null,
                                                        "nextBillingPrice": null,
                                                        "restrictedAccess": null,
                                                        "isSubscriptionTax": false,
                                                        "reinstatementDate": null,
                                                        "taxSubscriptionId": "6378369",
                                                        "terminationReason": null,
                                                        "reinstatementReason": null,
                                                        "tax_subscription_id": 6378369,
                                                        "aitestproExecutionId": 10904,
                                                        "customerPlanProducts": [
                                                            {
                                                                "id": 4343,
                                                                "price": 275.43,
                                                                "taxSku": null,
                                                                "product": {
                                                                    "id": 7,
                                                                    "code": "single",
                                                                    "data": "{\"additional_instructions\": []}",
                                                                    "logo": null,
                                                                    "name": "Single",
                                                                    "color": null,
                                                                    "price": 7.25,
                                                                    "glCode": "53211",
                                                                    "display": "TITLE",
                                                                    "published": true,
                                                                    "fusebillId": "126196",
                                                                    "backgroundColor": "#212A3E",
                                                                    "includedProducts": null
                                                                },
                                                                "taxCode": null,
                                                                "taxName": null,
                                                                "version": null,
                                                                "productId": 7,
                                                                "product_id": 7,
                                                                "planCoverage": "SINGLE",
                                                                "customerPlanId": 6050,
                                                                "customer_plan_id": 6050
                                                            }
                                                        ],
                                                        "backdatedActivationDate": null,
                                                        "backdatedCancellationDate": null
                                                    }
                                                ]
                                            },
                                            "lastName": "Illes",
                                            "firstName": "Agnes",
                                            "customerId": 2124,
                                            "staxbillId": "13248991"
                                        },
                                        "2132": {
                                            "plans": {
                                                "subscriptions": [
                                                    {
                                                        "id": 6062,
                                                        "gst": 0,
                                                        "hst": 0,
                                                        "pst": 22.03,
                                                        "qst": 0,
                                                        "tax": 22.03,
                                                        "misc": null,
                                                        "name": "All-in Gold",
                                                        "type": "100% Company Paid",
                                                        "count": 1,
                                                        "price": 275.43,
                                                        "scope": null,
                                                        "total": 297.46,
                                                        "isBulk": false,
                                                        "planId": 786,
                                                        "status": "Active",
                                                        "created": "2024-06-20 15:39:19",
                                                        "plan_id": 786,
                                                        "stateId": 12,
                                                        "summary": null,
                                                        "taxCode": null,
                                                        "taxName": "PST on Health Insurance",
                                                        "version": null,
                                                        "coverage": "SINGLE",
                                                        "modified": "2025-01-20 17:47:31",
                                                        "parentId": "198",
                                                        "planCode": "allingold",
                                                        "planName": "All-in Gold",
                                                        "quantity": 1,
                                                        "taxPrice": 22.03,
                                                        "totalTax": 22.03,
                                                        "coverage1": "Single",
                                                        "packageId": 1,
                                                        "customerId": 2132,
                                                        "grandTotal": 297.46,
                                                        "gstTaxRate": null,
                                                        "hstTaxRate": null,
                                                        "planObject": null,
                                                        "pstTaxRate": 8,
                                                        "qstTaxRate": null,
                                                        "signupDate": "2024-06-20",
                                                        "taxDetails": {
                                                            "tax": 22.03,
                                                            "price": 275.43,
                                                            "total": 297.46,
                                                            "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $22.03 "
                                                        },
                                                        "taxForPlan": 22.03,
                                                        "totalPrice": 275.43,
                                                        "createdDate": "2024-06-20 15:39:19",
                                                        "customer_id": 2132,
                                                        "enrolledDate": "2024-07-01",
                                                        "taxDetailsDB": {
                                                            "gst": "0.00",
                                                            "hst": "0.00",
                                                            "pst": "22.03",
                                                            "tax": "22.03",
                                                            "price": "275.43",
                                                            "total": "297.46",
                                                            "taxName": "PST on Health Insurance",
                                                            "taxPrice": "22.03",
                                                            "gstTaxRate": "0.00",
                                                            "hstTaxRate": "0.00",
                                                            "pstTaxRate": "8.00",
                                                            "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                                        },
                                                        "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "bulkPlanLevel": null,
                                                        "paidByCompany": 1,
                                                        "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                                        "activationDate": "2024-07-01 04:00:00",
                                                        "paidByEmployee": null,
                                                        "subscriptionId": "6381135",
                                                        "workingStateId": 12,
                                                        "bundledProducts": [
                                                            "All-in Gold"
                                                        ],
                                                        "lastBillingDate": null,
                                                        "nextBillingDate": null,
                                                        "terminationDate": null,
                                                        "cancellationDate": null,
                                                        "coveredByCompany": null,
                                                        "nextBillingPrice": null,
                                                        "restrictedAccess": null,
                                                        "isSubscriptionTax": false,
                                                        "reinstatementDate": null,
                                                        "taxSubscriptionId": "6381134",
                                                        "terminationReason": null,
                                                        "reinstatementReason": null,
                                                        "tax_subscription_id": 6381134,
                                                        "aitestproExecutionId": 11006,
                                                        "customerPlanProducts": [
                                                            {
                                                                "id": 4358,
                                                                "price": 275.43,
                                                                "taxSku": null,
                                                                "product": {
                                                                    "id": 7,
                                                                    "code": "single",
                                                                    "data": "{\"additional_instructions\": []}",
                                                                    "logo": null,
                                                                    "name": "Single",
                                                                    "color": null,
                                                                    "price": 7.25,
                                                                    "glCode": "53211",
                                                                    "display": "TITLE",
                                                                    "published": true,
                                                                    "fusebillId": "126196",
                                                                    "backgroundColor": "#212A3E",
                                                                    "includedProducts": null
                                                                },
                                                                "taxCode": null,
                                                                "taxName": null,
                                                                "version": null,
                                                                "productId": 7,
                                                                "product_id": 7,
                                                                "planCoverage": "SINGLE",
                                                                "customerPlanId": 6062,
                                                                "customer_plan_id": 6062
                                                            }
                                                        ],
                                                        "backdatedActivationDate": null,
                                                        "backdatedCancellationDate": null
                                                    }
                                                ]
                                            },
                                            "lastName": "Cullum",
                                            "firstName": "Alexandra",
                                            "customerId": 2132,
                                            "staxbillId": "13252945"
                                        }
                                    },
                                    "contactInformation": {
                                        "state": "Ontario",
                                        "stateId": 12,
                                        "workingProvince": "Ontario",
                                        "workingProvinceId": 12
                                    },
                                    "fusebillCustomerId": "11663678",
                                    "paymentFailureCount": null
                                }
                            ],
                            "invoiceAmount": 1654.08,
                            "invoiceStatus": "POST",
                            "overall_taxes": {
                                "Total": 122.51,
                                "PST on Health Insurance": 122.51
                            },
                            "displayVersion": true,
                            "havingBulkPlan": false,
                            "havingEmployees": true,
                            "lastInvoiceDate": "2025-03-01",
                            "previousInvoice": true,
                            "tax_information": "{\"individual_taxes\": {\"198\": {\"customerId\": 198, \"staxbillId\": \"11663678\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"taxes\": []}}, \"2124\": {\"customerId\": 2124, \"staxbillId\": \"13248991\", \"firstName\": \"Agnes\", \"lastName\": \"Illes\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2024-06-18\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-18 11:51:55\", \"subscriptionId\": \"6378369\", \"price\": 22.03, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 22.03, \"totalPrice\": 22.03, \"totalTax\": 0, \"grandTotal\": 22.03, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2124, \"id\": 6049, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 1, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-06-18 11:51:55\", \"modified\": \"2025-01-20 18:28:09\", \"misc\": null, \"planObject\": null, \"customer_id\": 2124, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 6049, \"id\": 4342, \"planCoverage\": null, \"price\": 22.03, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6049, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2132\": {\"customerId\": 2132, \"staxbillId\": \"13252945\", \"firstName\": \"Alexandra\", \"lastName\": \"Cullum\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2024-06-20\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-20 15:39:18\", \"subscriptionId\": \"6381134\", \"price\": 22.03, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 22.03, \"totalPrice\": 22.03, \"totalTax\": 0, \"grandTotal\": 22.03, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2132, \"id\": 6061, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 1, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-06-20 15:39:18\", \"modified\": \"2025-01-20 18:28:09\", \"misc\": null, \"planObject\": null, \"customer_id\": 2132, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 6061, \"id\": 4357, \"planCoverage\": null, \"price\": 22.03, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6061, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2000\": {\"customerId\": 2000, \"staxbillId\": \"13195516\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356148\", \"price\": 56.42, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 56.42, \"totalPrice\": 56.42, \"totalTax\": 0, \"grandTotal\": 56.42, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5879, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 56.42, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 56.42, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 5879, \"id\": 4191, \"planCoverage\": null, \"price\": 56.42, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5879, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2002\": {\"customerId\": 2002, \"staxbillId\": \"13196440\", \"firstName\": \"Shannon\", \"lastName\": \"Harris\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2024-05-30\", \"enrolledDate\": \"2024-06-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 18:31:45\", \"subscriptionId\": \"6357070\", \"price\": 22.03, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 22.03, \"totalPrice\": 22.03, \"totalTax\": 0, \"grandTotal\": 22.03, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2002, \"id\": 5883, \"planId\": 765, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 1, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-05-30 18:31:45\", \"modified\": \"2025-01-20 18:28:09\", \"misc\": null, \"planObject\": null, \"customer_id\": 2002, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 5883, \"id\": 4195, \"planCoverage\": null, \"price\": 22.03, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5883, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}}, \"overall_taxes\": {\"Total\": 122.51, \"PST on Health Insurance\": 122.51}}",
                            "individual_taxes": {
                                "198": {
                                    "plans": {
                                        "taxes": []
                                    },
                                    "lastName": "Avery",
                                    "firstName": "Christopher",
                                    "customerId": 198,
                                    "staxbillId": "11663678"
                                },
                                "2000": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 5879,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 56.42,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 56.42,
                                                "scope": null,
                                                "total": 56.42,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-05-30 10:44:17",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-21 12:52:52",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 56.42,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2000,
                                                "grandTotal": 56.42,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2023-01-23",
                                                "taxForPlan": 0,
                                                "totalPrice": 56.42,
                                                "createdDate": "2024-05-30 10:44:17",
                                                "customer_id": 2000,
                                                "enrolledDate": "2023-03-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6356148",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (<60)",
                                                    "Protect 200",
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4191,
                                                        "price": 56.42,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 5879,
                                                        "customer_plan_id": 5879
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Avery",
                                    "firstName": "Christopher",
                                    "customerId": 2000,
                                    "staxbillId": "13195516"
                                },
                                "2002": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 5883,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 22.03,
                                                "scope": null,
                                                "total": 22.03,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-05-30 18:31:45",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 18:28:09",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2002,
                                                "grandTotal": 22.03,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-05-30",
                                                "taxForPlan": 0,
                                                "totalPrice": 22.03,
                                                "createdDate": "2024-05-30 18:31:45",
                                                "customer_id": 2002,
                                                "enrolledDate": "2024-06-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6357070",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 1,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4195,
                                                        "price": 22.03,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 5883,
                                                        "customer_plan_id": 5883
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Harris",
                                    "firstName": "Shannon",
                                    "customerId": 2002,
                                    "staxbillId": "13196440"
                                },
                                "2124": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 6049,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 22.03,
                                                "scope": null,
                                                "total": 22.03,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-06-18 11:51:55",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 18:28:09",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2124,
                                                "grandTotal": 22.03,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-06-18",
                                                "taxForPlan": 0,
                                                "totalPrice": 22.03,
                                                "createdDate": "2024-06-18 11:51:55",
                                                "customer_id": 2124,
                                                "enrolledDate": "2024-07-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-07-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6378369",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 1,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4342,
                                                        "price": 22.03,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 6049,
                                                        "customer_plan_id": 6049
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Illes",
                                    "firstName": "Agnes",
                                    "customerId": 2124,
                                    "staxbillId": "13248991"
                                },
                                "2132": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 6061,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 22.03,
                                                "scope": null,
                                                "total": 22.03,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-06-20 15:39:18",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 18:28:09",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2132,
                                                "grandTotal": 22.03,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-06-20",
                                                "taxForPlan": 0,
                                                "totalPrice": 22.03,
                                                "createdDate": "2024-06-20 15:39:18",
                                                "customer_id": 2132,
                                                "enrolledDate": "2024-07-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-07-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6381134",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 1,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4357,
                                                        "price": 22.03,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 6061,
                                                        "customer_plan_id": 6061
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Cullum",
                                    "firstName": "Alexandra",
                                    "customerId": 2132,
                                    "staxbillId": "13252945"
                                }
                            },
                            "plan_information": "{\"198\": {\"customerId\": 198, \"staxbillId\": \"11663678\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"subscriptions\": []}}, \"2124\": {\"customerId\": 2124, \"staxbillId\": \"13248991\", \"firstName\": \"Agnes\", \"lastName\": \"Illes\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 550.86, \"tax\": 47.56, \"total\": 598.42, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 \"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 47.56, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2024-06-18\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-18 11:51:56\", \"subscriptionId\": \"6378370\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 47.56, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"total\": 322.99, \"totalPrice\": 275.43, \"totalTax\": 47.56, \"grandTotal\": 322.99, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2124, \"id\": 6050, \"planId\": 786, \"status\": \"Active\", \"hst\": 0, \"gst\": 0, \"pst\": 22.03, \"qst\": 0, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 10904, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6378369\", \"isBulk\": false, \"created\": \"2024-06-18 11:51:56\", \"modified\": \"2025-01-20 17:47:31\", \"misc\": null, \"planObject\": null, \"customer_id\": 2124, \"plan_id\": 786, \"tax_subscription_id\": 6378369, \"customerPlanProducts\": [{\"customerPlanId\": 6050, \"id\": 4343, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6050, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}]}}, \"2132\": {\"customerId\": 2132, \"staxbillId\": \"13252945\", \"firstName\": \"Alexandra\", \"lastName\": \"Cullum\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 550.86, \"tax\": 47.56, \"total\": 598.42, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 \"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 47.56, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2024-06-20\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-20 15:39:19\", \"subscriptionId\": \"6381135\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 47.56, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"total\": 322.99, \"totalPrice\": 275.43, \"totalTax\": 47.56, \"grandTotal\": 322.99, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2132, \"id\": 6062, \"planId\": 786, \"status\": \"Active\", \"hst\": 0, \"gst\": 0, \"pst\": 22.03, \"qst\": 0, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 11006, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6381134\", \"isBulk\": false, \"created\": \"2024-06-20 15:39:19\", \"modified\": \"2025-01-20 17:47:31\", \"misc\": null, \"planObject\": null, \"customer_id\": 2132, \"plan_id\": 786, \"tax_subscription_id\": 6381134, \"customerPlanProducts\": [{\"customerPlanId\": 6062, \"id\": 4358, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6062, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}]}}, \"2000\": {\"customerId\": 2000, \"staxbillId\": \"13195516\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 0, \"tax\": 0, \"total\": 0, \"taxDescriptionLine\": \"\"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356146\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"total\": 275.43, \"totalPrice\": 275.43, \"totalTax\": 0, \"grandTotal\": 275.43, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5882, \"planId\": 786, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6356148\", \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 786, \"tax_subscription_id\": 6356148, \"customerPlanProducts\": [{\"customerPlanId\": 5882, \"id\": 4194, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5882, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}, {\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 60, \"tax\": 4.8, \"total\": 64.8, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $4.80 \"}, \"taxDetailsDB\": {\"pst\": \"4.80\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"4.80\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $4.80\", \"tax\": \"4.80\", \"price\": \"60.00\", \"total\": \"64.80\"}, \"taxForPlan\": 4.8, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356147\", \"price\": 60, \"quantity\": 1, \"count\": 1, \"tax\": 4.8, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"total\": 64.8, \"totalPrice\": 60, \"totalTax\": 4.8, \"grandTotal\": 64.8, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5881, \"planId\": 776, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 4.8, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 4.8, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6356148\", \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 776, \"tax_subscription_id\": 6356148, \"customerPlanProducts\": [{\"customerPlanId\": 5881, \"id\": 4193, \"planCoverage\": null, \"price\": 60, \"productId\": 17, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5881, \"product_id\": 17, \"product\": {\"backgroundColor\": null, \"code\": \"protect200\", \"color\": null, \"fusebillId\": \"127797\", \"glCode\": \"53210\", \"id\": 17, \"name\": \"Protect 200\", \"price\": 60, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"GroupBenefitz Protect\", \"name\": \"GroupBenefitz Protect\", \"planCode\": \"groupbenefitzprotectsinglesku\", \"packageId\": 4}, {\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 369.85, \"tax\": 29.59, \"total\": 399.44, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $29.59 \"}, \"taxDetailsDB\": {\"pst\": \"29.59\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"29.59\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $29.59\", \"tax\": \"29.59\", \"price\": \"369.85\", \"total\": \"399.44\"}, \"taxForPlan\": 29.59, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356145\", \"price\": 369.85, \"quantity\": 1, \"count\": 1, \"tax\": 29.59, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | \", \"total\": 399.44, \"totalPrice\": 369.85, \"totalTax\": 29.59, \"grandTotal\": 399.44, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5880, \"planId\": 772, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 29.59, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 29.59, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6356148\", \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 772, \"tax_subscription_id\": 6356148, \"customerPlanProducts\": [{\"customerPlanId\": 5880, \"id\": 4192, \"planCoverage\": null, \"price\": 369.85, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5880, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"Complete Executive Care (<60)\", \"name\": \"Complete Executive Care (<60)\", \"planCode\": \"completeexecutivecare60\", \"packageId\": 5}]}}, \"2002\": {\"customerId\": 2002, \"staxbillId\": \"13196440\", \"firstName\": \"Shannon\", \"lastName\": \"Harris\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 550.86, \"tax\": 47.56, \"total\": 598.42, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 \"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 47.56, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2024-05-30\", \"enrolledDate\": \"2024-06-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 18:31:46\", \"subscriptionId\": \"6357071\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 47.56, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"total\": 322.99, \"totalPrice\": 275.43, \"totalTax\": 47.56, \"grandTotal\": 322.99, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2002, \"id\": 5884, \"planId\": 786, \"status\": \"Active\", \"hst\": 0, \"gst\": 0, \"pst\": 22.03, \"qst\": 0, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 10600, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6357070\", \"isBulk\": false, \"created\": \"2024-05-30 18:31:46\", \"modified\": \"2025-01-20 17:47:28\", \"misc\": null, \"planObject\": null, \"customer_id\": 2002, \"plan_id\": 786, \"tax_subscription_id\": 6357070, \"customerPlanProducts\": [{\"customerPlanId\": 5884, \"id\": 4196, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5884, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}]}}}",
                            "lastInvoiceAmount": 1654.08,
                            "invoicePaymentDate": "2025-04-01",
                            "lastInvoicePayment": 1654.08,
                            "contact_information": "{\"stateId\": 12, \"workingProvinceId\": 12, \"state\": \"Ontario\", \"workingProvince\": \"Ontario\"}",
                            "handleInvoiceHistory": true
                        },
                        "paymentStatus": null,
                        "invoiceHistory": null,
                        "taxInformation": {
                            "overall_taxes": {
                                "Total": 122.51,
                                "PST on Health Insurance": 122.51
                            },
                            "individual_taxes": {
                                "198": {
                                    "plans": {
                                        "taxes": []
                                    },
                                    "lastName": "Avery",
                                    "firstName": "Christopher",
                                    "customerId": 198,
                                    "staxbillId": "11663678"
                                },
                                "2000": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 5879,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 56.42,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 56.42,
                                                "scope": null,
                                                "total": 56.42,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-05-30 10:44:17",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-21 12:52:52",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 56.42,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2000,
                                                "grandTotal": 56.42,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2023-01-23",
                                                "taxForPlan": 0,
                                                "totalPrice": 56.42,
                                                "createdDate": "2024-05-30 10:44:17",
                                                "customer_id": 2000,
                                                "enrolledDate": "2023-03-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6356148",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "Complete Executive Care (<60)",
                                                    "Protect 200",
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": null,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4191,
                                                        "price": 56.42,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 5879,
                                                        "customer_plan_id": 5879
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Avery",
                                    "firstName": "Christopher",
                                    "customerId": 2000,
                                    "staxbillId": "13195516"
                                },
                                "2002": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 5883,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 22.03,
                                                "scope": null,
                                                "total": 22.03,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-05-30 18:31:45",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 18:28:09",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2002,
                                                "grandTotal": 22.03,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-05-30",
                                                "taxForPlan": 0,
                                                "totalPrice": 22.03,
                                                "createdDate": "2024-05-30 18:31:45",
                                                "customer_id": 2002,
                                                "enrolledDate": "2024-06-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-06-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6357070",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 1,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4195,
                                                        "price": 22.03,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 5883,
                                                        "customer_plan_id": 5883
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Harris",
                                    "firstName": "Shannon",
                                    "customerId": 2002,
                                    "staxbillId": "13196440"
                                },
                                "2124": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 6049,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 22.03,
                                                "scope": null,
                                                "total": 22.03,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-06-18 11:51:55",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 18:28:09",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2124,
                                                "grandTotal": 22.03,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-06-18",
                                                "taxForPlan": 0,
                                                "totalPrice": 22.03,
                                                "createdDate": "2024-06-18 11:51:55",
                                                "customer_id": 2124,
                                                "enrolledDate": "2024-07-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-07-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6378369",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 1,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4342,
                                                        "price": 22.03,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 6049,
                                                        "customer_plan_id": 6049
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Illes",
                                    "firstName": "Agnes",
                                    "customerId": 2124,
                                    "staxbillId": "13248991"
                                },
                                "2132": {
                                    "plans": {
                                        "taxes": [
                                            {
                                                "id": 6061,
                                                "gst": null,
                                                "hst": null,
                                                "pst": 22.03,
                                                "qst": null,
                                                "tax": 0,
                                                "misc": null,
                                                "name": "Taxes",
                                                "type": "100% Company Paid",
                                                "count": 1,
                                                "price": 22.03,
                                                "scope": null,
                                                "total": 22.03,
                                                "isBulk": false,
                                                "planId": 765,
                                                "status": "Active",
                                                "created": "2024-06-20 15:39:18",
                                                "plan_id": 765,
                                                "stateId": 12,
                                                "summary": null,
                                                "taxCode": null,
                                                "taxName": "PST on Health Insurance",
                                                "version": null,
                                                "coverage": "SINGLE",
                                                "modified": "2025-01-20 18:28:09",
                                                "parentId": "198",
                                                "planCode": "taxes1",
                                                "planName": "Taxes",
                                                "quantity": 1,
                                                "taxPrice": 22.03,
                                                "totalTax": 0,
                                                "coverage1": "-",
                                                "packageId": null,
                                                "customerId": 2132,
                                                "grandTotal": 22.03,
                                                "gstTaxRate": null,
                                                "hstTaxRate": null,
                                                "planObject": null,
                                                "pstTaxRate": 8,
                                                "qstTaxRate": null,
                                                "signupDate": "2024-06-20",
                                                "taxForPlan": 0,
                                                "totalPrice": 22.03,
                                                "createdDate": "2024-06-20 15:39:18",
                                                "customer_id": 2132,
                                                "enrolledDate": "2024-07-01",
                                                "taxStatement": "",
                                                "bulkPlanLevel": null,
                                                "paidByCompany": 1,
                                                "taxStatement1": "",
                                                "activationDate": "2024-07-01 04:00:00",
                                                "paidByEmployee": null,
                                                "subscriptionId": "6381134",
                                                "workingStateId": 12,
                                                "bundledProducts": [
                                                    "All-in Gold"
                                                ],
                                                "lastBillingDate": null,
                                                "nextBillingDate": null,
                                                "terminationDate": null,
                                                "cancellationDate": null,
                                                "coveredByCompany": null,
                                                "nextBillingPrice": null,
                                                "restrictedAccess": null,
                                                "isSubscriptionTax": true,
                                                "reinstatementDate": null,
                                                "taxSubscriptionId": null,
                                                "terminationReason": null,
                                                "reinstatementReason": null,
                                                "tax_subscription_id": null,
                                                "aitestproExecutionId": 1,
                                                "customerPlanProducts": [
                                                    {
                                                        "id": 4357,
                                                        "price": 22.03,
                                                        "taxSku": null,
                                                        "product": {
                                                            "id": 2,
                                                            "code": "pstonhealthinsurance",
                                                            "data": null,
                                                            "logo": null,
                                                            "name": "PST on Health Insurance",
                                                            "color": null,
                                                            "price": 0,
                                                            "glCode": "53211",
                                                            "display": "TITLE",
                                                            "published": true,
                                                            "fusebillId": "126201",
                                                            "backgroundColor": null,
                                                            "includedProducts": null
                                                        },
                                                        "taxCode": null,
                                                        "taxName": null,
                                                        "version": null,
                                                        "productId": 2,
                                                        "product_id": 2,
                                                        "planCoverage": null,
                                                        "customerPlanId": 6061,
                                                        "customer_plan_id": 6061
                                                    }
                                                ],
                                                "backdatedActivationDate": null,
                                                "backdatedCancellationDate": null
                                            }
                                        ]
                                    },
                                    "lastName": "Cullum",
                                    "firstName": "Alexandra",
                                    "customerId": 2132,
                                    "staxbillId": "13252945"
                                }
                            }
                        },
                        "planInformation": {
                            "198": {
                                "plans": {
                                    "subscriptions": []
                                },
                                "lastName": "Avery",
                                "firstName": "Christopher",
                                "customerId": 198,
                                "staxbillId": "11663678"
                            },
                            "2000": {
                                "plans": {
                                    "subscriptions": [
                                        {
                                            "id": 5882,
                                            "gst": null,
                                            "hst": null,
                                            "pst": 22.03,
                                            "qst": null,
                                            "tax": 0,
                                            "misc": null,
                                            "name": "All-in Gold",
                                            "type": "100% Company Paid",
                                            "count": 1,
                                            "price": 275.43,
                                            "scope": null,
                                            "total": 275.43,
                                            "isBulk": false,
                                            "planId": 786,
                                            "status": "Active",
                                            "created": "2024-05-30 10:44:17",
                                            "plan_id": 786,
                                            "stateId": 12,
                                            "summary": null,
                                            "taxCode": null,
                                            "taxName": "PST on Health Insurance",
                                            "version": null,
                                            "coverage": "SINGLE",
                                            "modified": "2025-01-21 12:52:52",
                                            "parentId": "198",
                                            "planCode": "allingold",
                                            "planName": "All-in Gold",
                                            "quantity": 1,
                                            "taxPrice": 22.03,
                                            "totalTax": 0,
                                            "coverage1": "Single",
                                            "packageId": 1,
                                            "customerId": 2000,
                                            "grandTotal": 275.43,
                                            "gstTaxRate": null,
                                            "hstTaxRate": null,
                                            "planObject": null,
                                            "pstTaxRate": 8,
                                            "qstTaxRate": null,
                                            "signupDate": "2023-01-23",
                                            "taxDetails": {
                                                "tax": 0,
                                                "price": 0,
                                                "total": 0,
                                                "taxDescriptionLine": ""
                                            },
                                            "taxForPlan": 0,
                                            "totalPrice": 275.43,
                                            "createdDate": "2024-05-30 10:44:17",
                                            "customer_id": 2000,
                                            "enrolledDate": "2023-03-01",
                                            "taxDetailsDB": {
                                                "gst": "0.00",
                                                "hst": "0.00",
                                                "pst": "22.03",
                                                "tax": "22.03",
                                                "price": "275.43",
                                                "total": "297.46",
                                                "taxName": "PST on Health Insurance",
                                                "taxPrice": "22.03",
                                                "gstTaxRate": "0.00",
                                                "hstTaxRate": "0.00",
                                                "pstTaxRate": "8.00",
                                                "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                            },
                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                            "bulkPlanLevel": null,
                                            "paidByCompany": 1,
                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                            "activationDate": "2024-06-01 04:00:00",
                                            "paidByEmployee": null,
                                            "subscriptionId": "6356146",
                                            "workingStateId": 12,
                                            "bundledProducts": [
                                                "Complete Executive Care (<60)",
                                                "Protect 200",
                                                "All-in Gold"
                                            ],
                                            "lastBillingDate": null,
                                            "nextBillingDate": null,
                                            "terminationDate": null,
                                            "cancellationDate": null,
                                            "coveredByCompany": null,
                                            "nextBillingPrice": null,
                                            "restrictedAccess": null,
                                            "isSubscriptionTax": false,
                                            "reinstatementDate": null,
                                            "taxSubscriptionId": "6356148",
                                            "terminationReason": null,
                                            "reinstatementReason": null,
                                            "tax_subscription_id": 6356148,
                                            "aitestproExecutionId": null,
                                            "customerPlanProducts": [
                                                {
                                                    "id": 4194,
                                                    "price": 275.43,
                                                    "taxSku": null,
                                                    "product": {
                                                        "id": 7,
                                                        "code": "single",
                                                        "data": "{\"additional_instructions\": []}",
                                                        "logo": null,
                                                        "name": "Single",
                                                        "color": null,
                                                        "price": 7.25,
                                                        "glCode": "53211",
                                                        "display": "TITLE",
                                                        "published": true,
                                                        "fusebillId": "126196",
                                                        "backgroundColor": "#212A3E",
                                                        "includedProducts": null
                                                    },
                                                    "taxCode": null,
                                                    "taxName": null,
                                                    "version": null,
                                                    "productId": 7,
                                                    "product_id": 7,
                                                    "planCoverage": "SINGLE",
                                                    "customerPlanId": 5882,
                                                    "customer_plan_id": 5882
                                                }
                                            ],
                                            "backdatedActivationDate": null,
                                            "backdatedCancellationDate": null
                                        },
                                        {
                                            "id": 5881,
                                            "gst": null,
                                            "hst": null,
                                            "pst": 4.8,
                                            "qst": null,
                                            "tax": 4.8,
                                            "misc": null,
                                            "name": "GroupBenefitz Protect",
                                            "type": "100% Company Paid",
                                            "count": 1,
                                            "price": 60,
                                            "scope": null,
                                            "total": 64.8,
                                            "isBulk": false,
                                            "planId": 776,
                                            "status": "Active",
                                            "created": "2024-05-30 10:44:17",
                                            "plan_id": 776,
                                            "stateId": 12,
                                            "summary": null,
                                            "taxCode": null,
                                            "taxName": "PST on Health Insurance",
                                            "version": null,
                                            "coverage": "SINGLE",
                                            "modified": "2025-01-21 12:52:52",
                                            "parentId": "198",
                                            "planCode": "groupbenefitzprotectsinglesku",
                                            "planName": "GroupBenefitz Protect",
                                            "quantity": 1,
                                            "taxPrice": 4.8,
                                            "totalTax": 4.8,
                                            "coverage1": "-",
                                            "packageId": 4,
                                            "customerId": 2000,
                                            "grandTotal": 64.8,
                                            "gstTaxRate": null,
                                            "hstTaxRate": null,
                                            "planObject": null,
                                            "pstTaxRate": 8,
                                            "qstTaxRate": null,
                                            "signupDate": "2023-01-23",
                                            "taxDetails": {
                                                "tax": 4.8,
                                                "price": 60,
                                                "total": 64.8,
                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $4.80 "
                                            },
                                            "taxForPlan": 4.8,
                                            "totalPrice": 60,
                                            "createdDate": "2024-05-30 10:44:17",
                                            "customer_id": 2000,
                                            "enrolledDate": "2023-03-01",
                                            "taxDetailsDB": {
                                                "gst": "0.00",
                                                "hst": "0.00",
                                                "pst": "4.80",
                                                "tax": "4.80",
                                                "price": "60.00",
                                                "total": "64.80",
                                                "taxName": "PST on Health Insurance",
                                                "taxPrice": "4.80",
                                                "gstTaxRate": "0.00",
                                                "hstTaxRate": "0.00",
                                                "pstTaxRate": "8.00",
                                                "taxDescriptionLine": "PST on Health Insurance 8% $4.80"
                                            },
                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                            "bulkPlanLevel": null,
                                            "paidByCompany": 1,
                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | ",
                                            "activationDate": "2024-06-01 04:00:00",
                                            "paidByEmployee": null,
                                            "subscriptionId": "6356147",
                                            "workingStateId": 12,
                                            "bundledProducts": [
                                                "Complete Executive Care (<60)",
                                                "Protect 200",
                                                "All-in Gold"
                                            ],
                                            "lastBillingDate": null,
                                            "nextBillingDate": null,
                                            "terminationDate": null,
                                            "cancellationDate": null,
                                            "coveredByCompany": null,
                                            "nextBillingPrice": null,
                                            "restrictedAccess": null,
                                            "isSubscriptionTax": false,
                                            "reinstatementDate": null,
                                            "taxSubscriptionId": "6356148",
                                            "terminationReason": null,
                                            "reinstatementReason": null,
                                            "tax_subscription_id": 6356148,
                                            "aitestproExecutionId": null,
                                            "customerPlanProducts": [
                                                {
                                                    "id": 4193,
                                                    "price": 60,
                                                    "taxSku": null,
                                                    "product": {
                                                        "id": 17,
                                                        "code": "protect200",
                                                        "data": "{\"additional_instructions\": []}",
                                                        "logo": null,
                                                        "name": "Protect 200",
                                                        "color": null,
                                                        "price": 60,
                                                        "glCode": "53210",
                                                        "display": "TITLE",
                                                        "published": true,
                                                        "fusebillId": "127797",
                                                        "backgroundColor": null,
                                                        "includedProducts": null
                                                    },
                                                    "taxCode": null,
                                                    "taxName": null,
                                                    "version": null,
                                                    "productId": 17,
                                                    "product_id": 17,
                                                    "planCoverage": null,
                                                    "customerPlanId": 5881,
                                                    "customer_plan_id": 5881
                                                }
                                            ],
                                            "backdatedActivationDate": null,
                                            "backdatedCancellationDate": null
                                        },
                                        {
                                            "id": 5880,
                                            "gst": null,
                                            "hst": null,
                                            "pst": 29.59,
                                            "qst": null,
                                            "tax": 29.59,
                                            "misc": null,
                                            "name": "Complete Executive Care (<60)",
                                            "type": "100% Company Paid",
                                            "count": 1,
                                            "price": 369.85,
                                            "scope": null,
                                            "total": 399.44,
                                            "isBulk": false,
                                            "planId": 772,
                                            "status": "Active",
                                            "created": "2024-05-30 10:44:17",
                                            "plan_id": 772,
                                            "stateId": 12,
                                            "summary": null,
                                            "taxCode": null,
                                            "taxName": "PST on Health Insurance",
                                            "version": null,
                                            "coverage": "SINGLE",
                                            "modified": "2025-01-21 12:52:52",
                                            "parentId": "198",
                                            "planCode": "completeexecutivecare60",
                                            "planName": "Complete Executive Care (<60)",
                                            "quantity": 1,
                                            "taxPrice": 29.59,
                                            "totalTax": 29.59,
                                            "coverage1": "Single",
                                            "packageId": 5,
                                            "customerId": 2000,
                                            "grandTotal": 399.44,
                                            "gstTaxRate": null,
                                            "hstTaxRate": null,
                                            "planObject": null,
                                            "pstTaxRate": 8,
                                            "qstTaxRate": null,
                                            "signupDate": "2023-01-23",
                                            "taxDetails": {
                                                "tax": 29.59,
                                                "price": 369.85,
                                                "total": 399.44,
                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $29.59 "
                                            },
                                            "taxForPlan": 29.59,
                                            "totalPrice": 369.85,
                                            "createdDate": "2024-05-30 10:44:17",
                                            "customer_id": 2000,
                                            "enrolledDate": "2023-03-01",
                                            "taxDetailsDB": {
                                                "gst": "0.00",
                                                "hst": "0.00",
                                                "pst": "29.59",
                                                "tax": "29.59",
                                                "price": "369.85",
                                                "total": "399.44",
                                                "taxName": "PST on Health Insurance",
                                                "taxPrice": "29.59",
                                                "gstTaxRate": "0.00",
                                                "hstTaxRate": "0.00",
                                                "pstTaxRate": "8.00",
                                                "taxDescriptionLine": "PST on Health Insurance 8% $29.59"
                                            },
                                            "taxStatement": "8% PST ON HEALTH INSURANCE | ",
                                            "bulkPlanLevel": null,
                                            "paidByCompany": 1,
                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | ",
                                            "activationDate": "2024-06-01 04:00:00",
                                            "paidByEmployee": null,
                                            "subscriptionId": "6356145",
                                            "workingStateId": 12,
                                            "bundledProducts": [
                                                "Complete Executive Care (<60)",
                                                "Protect 200",
                                                "All-in Gold"
                                            ],
                                            "lastBillingDate": null,
                                            "nextBillingDate": null,
                                            "terminationDate": null,
                                            "cancellationDate": null,
                                            "coveredByCompany": null,
                                            "nextBillingPrice": null,
                                            "restrictedAccess": null,
                                            "isSubscriptionTax": false,
                                            "reinstatementDate": null,
                                            "taxSubscriptionId": "6356148",
                                            "terminationReason": null,
                                            "reinstatementReason": null,
                                            "tax_subscription_id": 6356148,
                                            "aitestproExecutionId": null,
                                            "customerPlanProducts": [
                                                {
                                                    "id": 4192,
                                                    "price": 369.85,
                                                    "taxSku": null,
                                                    "product": {
                                                        "id": 7,
                                                        "code": "single",
                                                        "data": "{\"additional_instructions\": []}",
                                                        "logo": null,
                                                        "name": "Single",
                                                        "color": null,
                                                        "price": 7.25,
                                                        "glCode": "53211",
                                                        "display": "TITLE",
                                                        "published": true,
                                                        "fusebillId": "126196",
                                                        "backgroundColor": "#212A3E",
                                                        "includedProducts": null
                                                    },
                                                    "taxCode": null,
                                                    "taxName": null,
                                                    "version": null,
                                                    "productId": 7,
                                                    "product_id": 7,
                                                    "planCoverage": null,
                                                    "customerPlanId": 5880,
                                                    "customer_plan_id": 5880
                                                }
                                            ],
                                            "backdatedActivationDate": null,
                                            "backdatedCancellationDate": null
                                        }
                                    ]
                                },
                                "lastName": "Avery",
                                "firstName": "Christopher",
                                "customerId": 2000,
                                "staxbillId": "13195516"
                            },
                            "2002": {
                                "plans": {
                                    "subscriptions": [
                                        {
                                            "id": 5884,
                                            "gst": 0,
                                            "hst": 0,
                                            "pst": 22.03,
                                            "qst": 0,
                                            "tax": 47.56,
                                            "misc": null,
                                            "name": "All-in Gold",
                                            "type": "100% Company Paid",
                                            "count": 1,
                                            "price": 275.43,
                                            "scope": null,
                                            "total": 322.99,
                                            "isBulk": false,
                                            "planId": 786,
                                            "status": "Active",
                                            "created": "2024-05-30 18:31:46",
                                            "plan_id": 786,
                                            "stateId": 12,
                                            "summary": null,
                                            "taxCode": null,
                                            "taxName": "PST on Health Insurance",
                                            "version": null,
                                            "coverage": "SINGLE",
                                            "modified": "2025-01-20 17:47:28",
                                            "parentId": "198",
                                            "planCode": "allingold",
                                            "planName": "All-in Gold",
                                            "quantity": 1,
                                            "taxPrice": 22.03,
                                            "totalTax": 47.56,
                                            "coverage1": "Single",
                                            "packageId": 1,
                                            "customerId": 2002,
                                            "grandTotal": 322.99,
                                            "gstTaxRate": null,
                                            "hstTaxRate": null,
                                            "planObject": null,
                                            "pstTaxRate": 8,
                                            "qstTaxRate": null,
                                            "signupDate": "2024-05-30",
                                            "taxDetails": {
                                                "tax": 47.56,
                                                "price": 550.86,
                                                "total": 598.42,
                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                            },
                                            "taxForPlan": 47.56,
                                            "totalPrice": 275.43,
                                            "createdDate": "2024-05-30 18:31:46",
                                            "customer_id": 2002,
                                            "enrolledDate": "2024-06-01",
                                            "taxDetailsDB": {
                                                "gst": "0.00",
                                                "hst": "0.00",
                                                "pst": "22.03",
                                                "tax": "22.03",
                                                "price": "275.43",
                                                "total": "297.46",
                                                "taxName": "PST on Health Insurance",
                                                "taxPrice": "22.03",
                                                "gstTaxRate": "0.00",
                                                "hstTaxRate": "0.00",
                                                "pstTaxRate": "8.00",
                                                "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                            },
                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                            "bulkPlanLevel": null,
                                            "paidByCompany": 1,
                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                            "activationDate": "2024-06-01 04:00:00",
                                            "paidByEmployee": null,
                                            "subscriptionId": "6357071",
                                            "workingStateId": 12,
                                            "bundledProducts": [
                                                "All-in Gold"
                                            ],
                                            "lastBillingDate": null,
                                            "nextBillingDate": null,
                                            "terminationDate": null,
                                            "cancellationDate": null,
                                            "coveredByCompany": null,
                                            "nextBillingPrice": null,
                                            "restrictedAccess": null,
                                            "isSubscriptionTax": false,
                                            "reinstatementDate": null,
                                            "taxSubscriptionId": "6357070",
                                            "terminationReason": null,
                                            "reinstatementReason": null,
                                            "tax_subscription_id": 6357070,
                                            "aitestproExecutionId": 10600,
                                            "customerPlanProducts": [
                                                {
                                                    "id": 4196,
                                                    "price": 275.43,
                                                    "taxSku": null,
                                                    "product": {
                                                        "id": 7,
                                                        "code": "single",
                                                        "data": "{\"additional_instructions\": []}",
                                                        "logo": null,
                                                        "name": "Single",
                                                        "color": null,
                                                        "price": 7.25,
                                                        "glCode": "53211",
                                                        "display": "TITLE",
                                                        "published": true,
                                                        "fusebillId": "126196",
                                                        "backgroundColor": "#212A3E",
                                                        "includedProducts": null
                                                    },
                                                    "taxCode": null,
                                                    "taxName": null,
                                                    "version": null,
                                                    "productId": 7,
                                                    "product_id": 7,
                                                    "planCoverage": "SINGLE",
                                                    "customerPlanId": 5884,
                                                    "customer_plan_id": 5884
                                                }
                                            ],
                                            "backdatedActivationDate": null,
                                            "backdatedCancellationDate": null
                                        }
                                    ]
                                },
                                "lastName": "Harris",
                                "firstName": "Shannon",
                                "customerId": 2002,
                                "staxbillId": "13196440"
                            },
                            "2124": {
                                "plans": {
                                    "subscriptions": [
                                        {
                                            "id": 6050,
                                            "gst": 0,
                                            "hst": 0,
                                            "pst": 22.03,
                                            "qst": 0,
                                            "tax": 47.56,
                                            "misc": null,
                                            "name": "All-in Gold",
                                            "type": "100% Company Paid",
                                            "count": 1,
                                            "price": 275.43,
                                            "scope": null,
                                            "total": 322.99,
                                            "isBulk": false,
                                            "planId": 786,
                                            "status": "Active",
                                            "created": "2024-06-18 11:51:56",
                                            "plan_id": 786,
                                            "stateId": 12,
                                            "summary": null,
                                            "taxCode": null,
                                            "taxName": "PST on Health Insurance",
                                            "version": null,
                                            "coverage": "SINGLE",
                                            "modified": "2025-01-20 17:47:31",
                                            "parentId": "198",
                                            "planCode": "allingold",
                                            "planName": "All-in Gold",
                                            "quantity": 1,
                                            "taxPrice": 22.03,
                                            "totalTax": 47.56,
                                            "coverage1": "Single",
                                            "packageId": 1,
                                            "customerId": 2124,
                                            "grandTotal": 322.99,
                                            "gstTaxRate": null,
                                            "hstTaxRate": null,
                                            "planObject": null,
                                            "pstTaxRate": 8,
                                            "qstTaxRate": null,
                                            "signupDate": "2024-06-18",
                                            "taxDetails": {
                                                "tax": 47.56,
                                                "price": 550.86,
                                                "total": 598.42,
                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                            },
                                            "taxForPlan": 47.56,
                                            "totalPrice": 275.43,
                                            "createdDate": "2024-06-18 11:51:56",
                                            "customer_id": 2124,
                                            "enrolledDate": "2024-07-01",
                                            "taxDetailsDB": {
                                                "gst": "0.00",
                                                "hst": "0.00",
                                                "pst": "22.03",
                                                "tax": "22.03",
                                                "price": "275.43",
                                                "total": "297.46",
                                                "taxName": "PST on Health Insurance",
                                                "taxPrice": "22.03",
                                                "gstTaxRate": "0.00",
                                                "hstTaxRate": "0.00",
                                                "pstTaxRate": "8.00",
                                                "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                            },
                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                            "bulkPlanLevel": null,
                                            "paidByCompany": 1,
                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                            "activationDate": "2024-07-01 04:00:00",
                                            "paidByEmployee": null,
                                            "subscriptionId": "6378370",
                                            "workingStateId": 12,
                                            "bundledProducts": [
                                                "All-in Gold"
                                            ],
                                            "lastBillingDate": null,
                                            "nextBillingDate": null,
                                            "terminationDate": null,
                                            "cancellationDate": null,
                                            "coveredByCompany": null,
                                            "nextBillingPrice": null,
                                            "restrictedAccess": null,
                                            "isSubscriptionTax": false,
                                            "reinstatementDate": null,
                                            "taxSubscriptionId": "6378369",
                                            "terminationReason": null,
                                            "reinstatementReason": null,
                                            "tax_subscription_id": 6378369,
                                            "aitestproExecutionId": 10904,
                                            "customerPlanProducts": [
                                                {
                                                    "id": 4343,
                                                    "price": 275.43,
                                                    "taxSku": null,
                                                    "product": {
                                                        "id": 7,
                                                        "code": "single",
                                                        "data": "{\"additional_instructions\": []}",
                                                        "logo": null,
                                                        "name": "Single",
                                                        "color": null,
                                                        "price": 7.25,
                                                        "glCode": "53211",
                                                        "display": "TITLE",
                                                        "published": true,
                                                        "fusebillId": "126196",
                                                        "backgroundColor": "#212A3E",
                                                        "includedProducts": null
                                                    },
                                                    "taxCode": null,
                                                    "taxName": null,
                                                    "version": null,
                                                    "productId": 7,
                                                    "product_id": 7,
                                                    "planCoverage": "SINGLE",
                                                    "customerPlanId": 6050,
                                                    "customer_plan_id": 6050
                                                }
                                            ],
                                            "backdatedActivationDate": null,
                                            "backdatedCancellationDate": null
                                        }
                                    ]
                                },
                                "lastName": "Illes",
                                "firstName": "Agnes",
                                "customerId": 2124,
                                "staxbillId": "13248991"
                            },
                            "2132": {
                                "plans": {
                                    "subscriptions": [
                                        {
                                            "id": 6062,
                                            "gst": 0,
                                            "hst": 0,
                                            "pst": 22.03,
                                            "qst": 0,
                                            "tax": 47.56,
                                            "misc": null,
                                            "name": "All-in Gold",
                                            "type": "100% Company Paid",
                                            "count": 1,
                                            "price": 275.43,
                                            "scope": null,
                                            "total": 322.99,
                                            "isBulk": false,
                                            "planId": 786,
                                            "status": "Active",
                                            "created": "2024-06-20 15:39:19",
                                            "plan_id": 786,
                                            "stateId": 12,
                                            "summary": null,
                                            "taxCode": null,
                                            "taxName": "PST on Health Insurance",
                                            "version": null,
                                            "coverage": "SINGLE",
                                            "modified": "2025-01-20 17:47:31",
                                            "parentId": "198",
                                            "planCode": "allingold",
                                            "planName": "All-in Gold",
                                            "quantity": 1,
                                            "taxPrice": 22.03,
                                            "totalTax": 47.56,
                                            "coverage1": "Single",
                                            "packageId": 1,
                                            "customerId": 2132,
                                            "grandTotal": 322.99,
                                            "gstTaxRate": null,
                                            "hstTaxRate": null,
                                            "planObject": null,
                                            "pstTaxRate": 8,
                                            "qstTaxRate": null,
                                            "signupDate": "2024-06-20",
                                            "taxDetails": {
                                                "tax": 47.56,
                                                "price": 550.86,
                                                "total": 598.42,
                                                "taxDescriptionLine": "PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 "
                                            },
                                            "taxForPlan": 47.56,
                                            "totalPrice": 275.43,
                                            "createdDate": "2024-06-20 15:39:19",
                                            "customer_id": 2132,
                                            "enrolledDate": "2024-07-01",
                                            "taxDetailsDB": {
                                                "gst": "0.00",
                                                "hst": "0.00",
                                                "pst": "22.03",
                                                "tax": "22.03",
                                                "price": "275.43",
                                                "total": "297.46",
                                                "taxName": "PST on Health Insurance",
                                                "taxPrice": "22.03",
                                                "gstTaxRate": "0.00",
                                                "hstTaxRate": "0.00",
                                                "pstTaxRate": "8.00",
                                                "taxDescriptionLine": "PST on Health Insurance 8% $22.03"
                                            },
                                            "taxStatement": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                            "bulkPlanLevel": null,
                                            "paidByCompany": 1,
                                            "taxStatement1": "8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | ",
                                            "activationDate": "2024-07-01 04:00:00",
                                            "paidByEmployee": null,
                                            "subscriptionId": "6381135",
                                            "workingStateId": 12,
                                            "bundledProducts": [
                                                "All-in Gold"
                                            ],
                                            "lastBillingDate": null,
                                            "nextBillingDate": null,
                                            "terminationDate": null,
                                            "cancellationDate": null,
                                            "coveredByCompany": null,
                                            "nextBillingPrice": null,
                                            "restrictedAccess": null,
                                            "isSubscriptionTax": false,
                                            "reinstatementDate": null,
                                            "taxSubscriptionId": "6381134",
                                            "terminationReason": null,
                                            "reinstatementReason": null,
                                            "tax_subscription_id": 6381134,
                                            "aitestproExecutionId": 11006,
                                            "customerPlanProducts": [
                                                {
                                                    "id": 4358,
                                                    "price": 275.43,
                                                    "taxSku": null,
                                                    "product": {
                                                        "id": 7,
                                                        "code": "single",
                                                        "data": "{\"additional_instructions\": []}",
                                                        "logo": null,
                                                        "name": "Single",
                                                        "color": null,
                                                        "price": 7.25,
                                                        "glCode": "53211",
                                                        "display": "TITLE",
                                                        "published": true,
                                                        "fusebillId": "126196",
                                                        "backgroundColor": "#212A3E",
                                                        "includedProducts": null
                                                    },
                                                    "taxCode": null,
                                                    "taxName": null,
                                                    "version": null,
                                                    "productId": 7,
                                                    "product_id": 7,
                                                    "planCoverage": "SINGLE",
                                                    "customerPlanId": 6062,
                                                    "customer_plan_id": 6062
                                                }
                                            ],
                                            "backdatedActivationDate": null,
                                            "backdatedCancellationDate": null
                                        }
                                    ]
                                },
                                "lastName": "Cullum",
                                "firstName": "Alexandra",
                                "customerId": 2132,
                                "staxbillId": "13252945"
                            }
                        },
                        "contactInformation": {
                            "state": "Ontario",
                            "stateId": 12,
                            "workingProvince": "Ontario",
                            "workingProvinceId": 12
                        },
                        "fusebillCustomerId": "11663678",
                        "paymentFailureCount": null
                    }
                ],
                "invoiceAmount": 1654.08,
                "invoiceStatus": "POST",
                "overall_taxes": {
                    "Total": 122.51,
                    "PST on Health Insurance": 122.51
                },
                "displayVersion": true,
                "havingBulkPlan": false,
                "havingEmployees": true,
                "lastInvoiceDate": "2025-04-01",
                "previousInvoice": true,
                "tax_information": "{\"individual_taxes\": {\"198\": {\"customerId\": 198, \"staxbillId\": \"11663678\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"taxes\": []}}, \"2124\": {\"customerId\": 2124, \"staxbillId\": \"13248991\", \"firstName\": \"Agnes\", \"lastName\": \"Illes\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2024-06-18\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-18 11:51:55\", \"subscriptionId\": \"6378369\", \"price\": 22.03, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 22.03, \"totalPrice\": 22.03, \"totalTax\": 0, \"grandTotal\": 22.03, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2124, \"id\": 6049, \"planId\": 765, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 1, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-06-18 11:51:55\", \"modified\": \"2025-01-20 18:28:09\", \"misc\": null, \"planObject\": null, \"customer_id\": 2124, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 6049, \"id\": 4342, \"planCoverage\": null, \"price\": 22.03, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6049, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2132\": {\"customerId\": 2132, \"staxbillId\": \"13252945\", \"firstName\": \"Alexandra\", \"lastName\": \"Cullum\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2024-06-20\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-20 15:39:18\", \"subscriptionId\": \"6381134\", \"price\": 22.03, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 22.03, \"totalPrice\": 22.03, \"totalTax\": 0, \"grandTotal\": 22.03, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2132, \"id\": 6061, \"planId\": 765, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 1, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-06-20 15:39:18\", \"modified\": \"2025-01-20 18:28:09\", \"misc\": null, \"planObject\": null, \"customer_id\": 2132, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 6061, \"id\": 4357, \"planCoverage\": null, \"price\": 22.03, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6061, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2000\": {\"customerId\": 2000, \"staxbillId\": \"13195516\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356148\", \"price\": 56.42, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 56.42, \"totalPrice\": 56.42, \"totalTax\": 0, \"grandTotal\": 56.42, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5879, \"planId\": 765, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 56.42, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 56.42, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 5879, \"id\": 4191, \"planCoverage\": null, \"price\": 56.42, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5879, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}, \"2002\": {\"customerId\": 2002, \"staxbillId\": \"13196440\", \"firstName\": \"Shannon\", \"lastName\": \"Harris\", \"plans\": {\"taxes\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2024-05-30\", \"enrolledDate\": \"2024-06-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 18:31:45\", \"subscriptionId\": \"6357070\", \"price\": 22.03, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"\", \"total\": 22.03, \"totalPrice\": 22.03, \"totalTax\": 0, \"grandTotal\": 22.03, \"type\": \"100% Company Paid\", \"taxStatement1\": \"\", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2002, \"id\": 5883, \"planId\": 765, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 1, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": true, \"taxSubscriptionId\": null, \"isBulk\": false, \"created\": \"2024-05-30 18:31:45\", \"modified\": \"2025-01-20 18:28:09\", \"misc\": null, \"planObject\": null, \"customer_id\": 2002, \"plan_id\": 765, \"tax_subscription_id\": null, \"customerPlanProducts\": [{\"customerPlanId\": 5883, \"id\": 4195, \"planCoverage\": null, \"price\": 22.03, \"productId\": 2, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5883, \"product_id\": 2, \"product\": {\"backgroundColor\": null, \"code\": \"pstonhealthinsurance\", \"color\": null, \"fusebillId\": \"126201\", \"glCode\": \"53211\", \"id\": 2, \"name\": \"PST on Health Insurance\", \"price\": 0, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": null, \"includedProducts\": null}}], \"planName\": \"Taxes\", \"name\": \"Taxes\", \"planCode\": \"taxes1\", \"packageId\": null}]}}}, \"overall_taxes\": {\"Total\": 122.51, \"PST on Health Insurance\": 122.51}}",
                "individual_taxes": {
                    "198": {
                        "plans": {
                            "taxes": []
                        },
                        "lastName": "Avery",
                        "firstName": "Christopher",
                        "customerId": 198,
                        "staxbillId": "11663678"
                    },
                    "2000": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 5879,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 56.42,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 56.42,
                                    "scope": null,
                                    "total": 56.42,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 10:44:17",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-21 12:52:52",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 56.42,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2000,
                                    "grandTotal": 56.42,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2023-01-23",
                                    "taxForPlan": 0,
                                    "totalPrice": 56.42,
                                    "createdDate": "2024-05-30 10:44:17",
                                    "customer_id": 2000,
                                    "enrolledDate": "2023-03-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6356148",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "Complete Executive Care (<60)",
                                        "Protect 200",
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": null,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4191,
                                            "price": 56.42,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 5879,
                                            "customer_plan_id": 5879
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Avery",
                        "firstName": "Christopher",
                        "customerId": 2000,
                        "staxbillId": "13195516"
                    },
                    "2002": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 5883,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 22.03,
                                    "scope": null,
                                    "total": 22.03,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-05-30 18:31:45",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 18:28:09",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2002,
                                    "grandTotal": 22.03,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-05-30",
                                    "taxForPlan": 0,
                                    "totalPrice": 22.03,
                                    "createdDate": "2024-05-30 18:31:45",
                                    "customer_id": 2002,
                                    "enrolledDate": "2024-06-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-06-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6357070",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 1,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4195,
                                            "price": 22.03,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 5883,
                                            "customer_plan_id": 5883
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Harris",
                        "firstName": "Shannon",
                        "customerId": 2002,
                        "staxbillId": "13196440"
                    },
                    "2124": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 6049,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 22.03,
                                    "scope": null,
                                    "total": 22.03,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-06-18 11:51:55",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 18:28:09",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2124,
                                    "grandTotal": 22.03,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-06-18",
                                    "taxForPlan": 0,
                                    "totalPrice": 22.03,
                                    "createdDate": "2024-06-18 11:51:55",
                                    "customer_id": 2124,
                                    "enrolledDate": "2024-07-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-07-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6378369",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 1,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4342,
                                            "price": 22.03,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 6049,
                                            "customer_plan_id": 6049
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Illes",
                        "firstName": "Agnes",
                        "customerId": 2124,
                        "staxbillId": "13248991"
                    },
                    "2132": {
                        "plans": {
                            "taxes": [
                                {
                                    "id": 6061,
                                    "gst": null,
                                    "hst": null,
                                    "pst": 22.03,
                                    "qst": null,
                                    "tax": 0,
                                    "misc": null,
                                    "name": "Taxes",
                                    "type": "100% Company Paid",
                                    "count": 1,
                                    "price": 22.03,
                                    "scope": null,
                                    "total": 22.03,
                                    "isBulk": false,
                                    "planId": 765,
                                    "status": "Active",
                                    "tierId": null,
                                    "created": "2024-06-20 15:39:18",
                                    "plan_id": 765,
                                    "stateId": 12,
                                    "summary": null,
                                    "taxCode": null,
                                    "taxName": "PST on Health Insurance",
                                    "version": null,
                                    "coverage": "SINGLE",
                                    "modified": "2025-01-20 18:28:09",
                                    "parentId": "198",
                                    "planCode": "taxes1",
                                    "planName": "Taxes",
                                    "quantity": 1,
                                    "taxPrice": 22.03,
                                    "totalTax": 0,
                                    "coverage1": "-",
                                    "packageId": null,
                                    "customerId": 2132,
                                    "grandTotal": 22.03,
                                    "gstTaxRate": null,
                                    "hstTaxRate": null,
                                    "planObject": null,
                                    "pstTaxRate": 8,
                                    "qstTaxRate": null,
                                    "signupDate": "2024-06-20",
                                    "taxForPlan": 0,
                                    "totalPrice": 22.03,
                                    "createdDate": "2024-06-20 15:39:18",
                                    "customer_id": 2132,
                                    "enrolledDate": "2024-07-01",
                                    "taxStatement": "",
                                    "bulkPlanLevel": null,
                                    "paidByCompany": 1,
                                    "taxStatement1": "",
                                    "activationDate": "2024-07-01 04:00:00",
                                    "paidByEmployee": null,
                                    "subscriptionId": "6381134",
                                    "workingStateId": 12,
                                    "bundledProducts": [
                                        "All-in Gold"
                                    ],
                                    "lastBillingDate": null,
                                    "nextBillingDate": null,
                                    "terminationDate": null,
                                    "cancellationDate": null,
                                    "coveredByCompany": null,
                                    "nextBillingPrice": null,
                                    "restrictedAccess": null,
                                    "isSubscriptionTax": true,
                                    "reinstatementDate": null,
                                    "taxSubscriptionId": null,
                                    "terminationReason": null,
                                    "reinstatementReason": null,
                                    "tax_subscription_id": null,
                                    "aitestproExecutionId": 1,
                                    "customerPlanProducts": [
                                        {
                                            "id": 4357,
                                            "price": 22.03,
                                            "taxSku": null,
                                            "product": {
                                                "id": 2,
                                                "code": "pstonhealthinsurance",
                                                "data": null,
                                                "logo": null,
                                                "name": "PST on Health Insurance",
                                                "color": null,
                                                "price": 0,
                                                "glCode": "53211",
                                                "display": "TITLE",
                                                "published": true,
                                                "fusebillId": "126201",
                                                "backgroundColor": null,
                                                "includedProducts": null
                                            },
                                            "taxCode": null,
                                            "taxName": null,
                                            "version": null,
                                            "productId": 2,
                                            "product_id": 2,
                                            "planCoverage": null,
                                            "customerPlanId": 6061,
                                            "customer_plan_id": 6061
                                        }
                                    ],
                                    "backdatedActivationDate": null,
                                    "backdatedCancellationDate": null
                                }
                            ]
                        },
                        "lastName": "Cullum",
                        "firstName": "Alexandra",
                        "customerId": 2132,
                        "staxbillId": "13252945"
                    }
                },
                "plan_information": "{\"198\": {\"customerId\": 198, \"staxbillId\": \"11663678\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"subscriptions\": []}}, \"2124\": {\"customerId\": 2124, \"staxbillId\": \"13248991\", \"firstName\": \"Agnes\", \"lastName\": \"Illes\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 550.86, \"tax\": 47.56, \"total\": 598.42, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 \"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 47.56, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2024-06-18\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-18 11:51:56\", \"subscriptionId\": \"6378370\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 47.56, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"total\": 322.99, \"totalPrice\": 275.43, \"totalTax\": 47.56, \"grandTotal\": 322.99, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2124, \"id\": 6050, \"planId\": 786, \"tierId\": null, \"status\": \"Active\", \"hst\": 0, \"gst\": 0, \"pst\": 22.03, \"qst\": 0, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 10904, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6378369\", \"isBulk\": false, \"created\": \"2024-06-18 11:51:56\", \"modified\": \"2025-01-20 17:47:31\", \"misc\": null, \"planObject\": null, \"customer_id\": 2124, \"plan_id\": 786, \"tax_subscription_id\": 6378369, \"customerPlanProducts\": [{\"customerPlanId\": 6050, \"id\": 4343, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6050, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}]}}, \"2132\": {\"customerId\": 2132, \"staxbillId\": \"13252945\", \"firstName\": \"Alexandra\", \"lastName\": \"Cullum\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 550.86, \"tax\": 47.56, \"total\": 598.42, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 \"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 47.56, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2024-06-20\", \"enrolledDate\": \"2024-07-01\", \"activationDate\": \"2024-07-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-06-20 15:39:19\", \"subscriptionId\": \"6381135\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 47.56, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"total\": 322.99, \"totalPrice\": 275.43, \"totalTax\": 47.56, \"grandTotal\": 322.99, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2132, \"id\": 6062, \"planId\": 786, \"tierId\": null, \"status\": \"Active\", \"hst\": 0, \"gst\": 0, \"pst\": 22.03, \"qst\": 0, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 11006, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6381134\", \"isBulk\": false, \"created\": \"2024-06-20 15:39:19\", \"modified\": \"2025-01-20 17:47:31\", \"misc\": null, \"planObject\": null, \"customer_id\": 2132, \"plan_id\": 786, \"tax_subscription_id\": 6381134, \"customerPlanProducts\": [{\"customerPlanId\": 6062, \"id\": 4358, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 6062, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}]}}, \"2000\": {\"customerId\": 2000, \"staxbillId\": \"13195516\", \"firstName\": \"Christopher\", \"lastName\": \"Avery\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 0, \"tax\": 0, \"total\": 0, \"taxDescriptionLine\": \"\"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 0, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356146\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 0, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"total\": 275.43, \"totalPrice\": 275.43, \"totalTax\": 0, \"grandTotal\": 275.43, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5882, \"planId\": 786, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 22.03, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6356148\", \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 786, \"tax_subscription_id\": 6356148, \"customerPlanProducts\": [{\"customerPlanId\": 5882, \"id\": 4194, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5882, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}, {\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 60, \"tax\": 4.8, \"total\": 64.8, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $4.80 \"}, \"taxDetailsDB\": {\"pst\": \"4.80\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"4.80\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $4.80\", \"tax\": \"4.80\", \"price\": \"60.00\", \"total\": \"64.80\"}, \"taxForPlan\": 4.8, \"coverage\": \"SINGLE\", \"coverage1\": \"-\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356147\", \"price\": 60, \"quantity\": 1, \"count\": 1, \"tax\": 4.8, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"total\": 64.8, \"totalPrice\": 60, \"totalTax\": 4.8, \"grandTotal\": 64.8, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5881, \"planId\": 776, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 4.8, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 4.8, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6356148\", \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 776, \"tax_subscription_id\": 6356148, \"customerPlanProducts\": [{\"customerPlanId\": 5881, \"id\": 4193, \"planCoverage\": null, \"price\": 60, \"productId\": 17, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5881, \"product_id\": 17, \"product\": {\"backgroundColor\": null, \"code\": \"protect200\", \"color\": null, \"fusebillId\": \"127797\", \"glCode\": \"53210\", \"id\": 17, \"name\": \"Protect 200\", \"price\": 60, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"GroupBenefitz Protect\", \"name\": \"GroupBenefitz Protect\", \"planCode\": \"groupbenefitzprotectsinglesku\", \"packageId\": 4}, {\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 369.85, \"tax\": 29.59, \"total\": 399.44, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $29.59 \"}, \"taxDetailsDB\": {\"pst\": \"29.59\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"29.59\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $29.59\", \"tax\": \"29.59\", \"price\": \"369.85\", \"total\": \"399.44\"}, \"taxForPlan\": 29.59, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2023-01-23\", \"enrolledDate\": \"2023-03-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 10:44:17\", \"subscriptionId\": \"6356145\", \"price\": 369.85, \"quantity\": 1, \"count\": 1, \"tax\": 29.59, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | \", \"total\": 399.44, \"totalPrice\": 369.85, \"totalTax\": 29.59, \"grandTotal\": 399.44, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | \", \"bundledProducts\": [\"Complete Executive Care (<60)\", \"Protect 200\", \"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2000, \"id\": 5880, \"planId\": 772, \"tierId\": null, \"status\": \"Active\", \"hst\": null, \"gst\": null, \"pst\": 29.59, \"qst\": null, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 29.59, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": null, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6356148\", \"isBulk\": false, \"created\": \"2024-05-30 10:44:17\", \"modified\": \"2025-01-21 12:52:52\", \"misc\": null, \"planObject\": null, \"customer_id\": 2000, \"plan_id\": 772, \"tax_subscription_id\": 6356148, \"customerPlanProducts\": [{\"customerPlanId\": 5880, \"id\": 4192, \"planCoverage\": null, \"price\": 369.85, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5880, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"Complete Executive Care (<60)\", \"name\": \"Complete Executive Care (<60)\", \"planCode\": \"completeexecutivecare60\", \"packageId\": 5}]}}, \"2002\": {\"customerId\": 2002, \"staxbillId\": \"13196440\", \"firstName\": \"Shannon\", \"lastName\": \"Harris\", \"plans\": {\"subscriptions\": [{\"stateId\": 12, \"workingStateId\": 12, \"taxDetails\": {\"price\": 550.86, \"tax\": 47.56, \"total\": 598.42, \"taxDescriptionLine\": \"PST on Health Insurance (#709505879) 8% $38.46 HST (#709505879) 13% $9.10 \"}, \"taxDetailsDB\": {\"pst\": \"22.03\", \"gst\": \"0.00\", \"hst\": \"0.00\", \"pstTaxRate\": \"8.00\", \"gstTaxRate\": \"0.00\", \"hstTaxRate\": \"0.00\", \"taxName\": \"PST on Health Insurance\", \"taxPrice\": \"22.03\", \"taxDescriptionLine\": \"PST on Health Insurance 8% $22.03\", \"tax\": \"22.03\", \"price\": \"275.43\", \"total\": \"297.46\"}, \"taxForPlan\": 47.56, \"coverage\": \"SINGLE\", \"coverage1\": \"Single\", \"signupDate\": \"2024-05-30\", \"enrolledDate\": \"2024-06-01\", \"activationDate\": \"2024-06-01 04:00:00\", \"backdatedActivationDate\": null, \"createdDate\": \"2024-05-30 18:31:46\", \"subscriptionId\": \"6357071\", \"price\": 275.43, \"quantity\": 1, \"count\": 1, \"tax\": 47.56, \"taxStatement\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"total\": 322.99, \"totalPrice\": 275.43, \"totalTax\": 47.56, \"grandTotal\": 322.99, \"type\": \"100% Company Paid\", \"taxStatement1\": \"8% PST ON HEALTH INSURANCE | 13% HST | 8% PST ON HEALTH INSURANCE | 13% HST | \", \"bundledProducts\": [\"All-in Gold\"], \"cancellationDate\": null, \"backdatedCancellationDate\": null, \"customerId\": 2002, \"id\": 5884, \"planId\": 786, \"tierId\": null, \"status\": \"Active\", \"hst\": 0, \"gst\": 0, \"pst\": 22.03, \"qst\": 0, \"hstTaxRate\": null, \"gstTaxRate\": null, \"pstTaxRate\": 8, \"qstTaxRate\": null, \"taxPrice\": 22.03, \"lastBillingDate\": null, \"nextBillingDate\": null, \"nextBillingPrice\": null, \"taxCode\": null, \"taxName\": \"PST on Health Insurance\", \"paidByCompany\": 1, \"coveredByCompany\": null, \"paidByEmployee\": null, \"aitestproExecutionId\": 10600, \"bulkPlanLevel\": null, \"terminationReason\": null, \"terminationDate\": null, \"reinstatementReason\": null, \"summary\": null, \"reinstatementDate\": null, \"parentId\": \"198\", \"scope\": null, \"version\": null, \"restrictedAccess\": null, \"isSubscriptionTax\": false, \"taxSubscriptionId\": \"6357070\", \"isBulk\": false, \"created\": \"2024-05-30 18:31:46\", \"modified\": \"2025-01-20 17:47:28\", \"misc\": null, \"planObject\": null, \"customer_id\": 2002, \"plan_id\": 786, \"tax_subscription_id\": 6357070, \"customerPlanProducts\": [{\"customerPlanId\": 5884, \"id\": 4196, \"planCoverage\": \"SINGLE\", \"price\": 275.43, \"productId\": 7, \"taxCode\": null, \"taxName\": null, \"taxSku\": null, \"version\": null, \"customer_plan_id\": 5884, \"product_id\": 7, \"product\": {\"backgroundColor\": \"#212A3E\", \"code\": \"single\", \"color\": null, \"fusebillId\": \"126196\", \"glCode\": \"53211\", \"id\": 7, \"name\": \"Single\", \"price\": 7.25, \"published\": true, \"logo\": null, \"display\": \"TITLE\", \"data\": \"{\\\"additional_instructions\\\": []}\", \"includedProducts\": null}}], \"planName\": \"All-in Gold\", \"name\": \"All-in Gold\", \"planCode\": \"allingold\", \"packageId\": 1}]}}}",
                "lastInvoiceAmount": 1654.08,
                "invoicePaymentDate": "2025-05-01",
                "lastInvoicePayment": 1654.08,
                "contact_information": "{\"stateId\": 12, \"workingProvinceId\": 12, \"state\": \"Ontario\", \"workingProvince\": \"Ontario\"}",
                "handleInvoiceHistory": true
            },
            "filename": "25-05-8170.pdf",
            "customer_id": 198,
            "customerObj": {
                "brokerId": 463,
                "ccExpiry": null,
                "ccExpiryAlertSent": null,
                "companyId": null,
                "companyName": "Avery Law",
                "deleted": null,
                "dob": "Sun Mar 24 1974 00:00:00 GMT+0530 (India Standard Time)",
                "equitableCertificateId": "0000000205",
                "equitableRegistrationStatus": "DONE",
                "firstName": "Christopher",
                "fusebillCustomerId": "11663678",
                "fusebillPaymentId": "1129002462",
                "gender": "Undisclosed",
                "greenshieldMemberId": null,
                "greenshieldRegistrationStatus": null,
                "groupId": null,
                "id": 198,
                "isCorporateAccount": true,
                "lastName": "Avery",
                "maritalStatus": "SINGLE",
                "middleName": null,
                "provincialHealthcardName": null,
                "terminationReason": null,
                "terminationDate": null,
                "reinstatementReason": null,
                "reinstatementDate": null,
                "jobTitle": "Owner",
                "monthlyRecurringRevenue": 0,
                "parentId": null,
                "paymentMethod": "CREDIT_CARD",
                "paymentMethodId": "3123929",
                "paymentMethodName": null,
                "registrationDate": "Thu Nov 07 2024 00:00:00 GMT+0530 (India Standard Time)",
                "backdatedRegistrationDate": null,
                "signature": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACWCAYAAABkW7XSAAAFIElEQVR4Xu3VUU1DQQBE0dYBFnCIA8ABdVgHWGB/QMFM8iYckvc7Wc5ubu83fwQIEBgRuI+c0zEJECBwEyyPgACBGQHBmrkqByVAQLC8AQIEZgQEa+aqHJQAAcHyBggQmBEQrJmrclACBATLGyBAYEZAsGauykEJEBAsb4AAgRkBwZq5KgclQECwvAECBGYEBGvmqhyUAAHB8gYIEJgREKyZq3JQAgQEyxsgQGBGQLBmrspBCRAQLG+AAIEZAcGauSoHJUBAsLwBAgRmBARr5qoclAABwfIGCBCYERCsmatyUAIEBMsbIEBgRkCwZq7KQQkQECxvgACBGQHBmrkqByVAQLC8AQIEZgQEa+aqHJQAAcHyBggQmBEQrJmrclACBATLGyBAYEZAsGauykEJEBAsb4AAgRkBwZq5KgclQECwvAECBGYEBGvmqhyUAAHB8gYIEJgREKyZq3JQAgQEyxsgQGBGQLBmrspBCRAQLG+AAIEZAcGauSoHJUBAsLwBAgRmBARr5qoclAABwfIGCBCYERCsmatyUAIEBMsbIEBgRkCwZq7KQQkQECxvgACBGQHBmrkqByVAQLC8AQIEZgQEa+aqHJQAAcHyBggQmBEQrJmrclACBATLGyBAYEZAsGauykEJEBAsb4AAgRkBwZq5KgclQECwvAECBGYEBGvmqhyUAAHB8gYIEJgREKyZq3JQAgQEyxsgQGBGQLBmrspBCRAQLG+AAIEZAcGauSoHJUDgysF6O9fzfr7P8325KgIFAW+sgNqcvHKwvs8//nK+5/lemwi2/62ANzZ29VcO1u+v3+OYfoy5Ou6GgDe2cU9/p7xysMYoHZcAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAtIFhtYfsECMQEBCtGaYgAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAtIFhtYfsECMQEBCtGaYgAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAtIFhtYfsECMQEBCtGaYgAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAtIFhtYfsECMQEBCtGaYgAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAtIFhtYfsECMQEBCtGaYgAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAtIFhtYfsECMQEBCtGaYgAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAtIFhtYfsECMQEBCtGaYgAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAtIFhtYfsECMQEBCtGaYgAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAtIFhtYfsECMQEBCtGaYgAgbaAYLWF7RMgEBMQrBilIQIE2gKC1Ra2T4BATECwYpSGCBBoCwhWW9g+AQIxAcGKURoiQKAt8AN//gyXFO+nFgAAAABJRU5ErkJggg==",
                "status": "Active",
                "uniqueSinId": null,
                "userId": 189,
                "spendingLimit": null,
                "annualIncome": null,
                "dateOfHiring": null,
                "assignerTier": null,
                "actualTier": null,
                "employeeId": null,
                "billAsCorporate": null,
                "cancellationDate": null,
                "backdatedCancellationDate": null,
                "lockdocsUserId": null,
                "valisignUserId": null,
                "bulkPlanIncluded": false,
                "userName": "christ_000198",
                "customData": null,
                "user_id": 189,
                "parent_id": null,
                "broker_id": 463,
                "actual_tier": null,
                "broker": {
                    "id": 463,
                    "brokerType": "CORPORATE",
                    "contactId": 4455,
                    "deleted": null,
                    "description": null,
                    "discoverable": false,
                    "fusebillCorporateCustomerId": "11663678",
                    "link": "app/resources/images/broker/GroupBenefitz0.png",
                    "logo": "app/resources/images/broker/GroupBenefitz.png",
                    "disclosureAgreement": null,
                    "termsAndConditions": null,
                    "name": "Avery Law",
                    "parentId": 51,
                    "policyStartDate": "2024-05-31T18:30:00.000Z",
                    "published": true,
                    "salesTrackingCode": "0000000015",
                    "salesTrackingType": "Plan Commission",
                    "settingsAllowGroupBenefitsWallet": 0,
                    "settingsGroupBenefitzWalletType": null,
                    "settingsAllowInvoicePaymentMethod": 0,
                    "settingsEnableTieredHealthBenefits": 0,
                    "settingsHealthSpendingAccount": null,
                    "settingsHealthSpendingAllotment": null,
                    "settingsRolloverEmployeeLimitNextYear": 0,
                    "settingsRolloverUnusedWalletFunds": null,
                    "uniqueId": null,
                    "subdomain": "averylaw",
                    "useCreditCardPaymentMethod": true,
                    "useInvoicePaymentMethod": false,
                    "usePadPaymentMethod": false,
                    "userId": 189,
                    "waitTime": 0,
                    "settingsEnableLengthOfServiceTiers": null,
                    "settingsEnableAnnualIncomeTiers": null,
                    "expectedEmployeesCount": 4,
                    "payrollDeduction": "YES",
                    "corporateEmployeeWaittimeOverride": null,
                    "corporateAutoPlanSelection": false,
                    "corporatePlanSelectionLocked": true,
                    "corporateWorkingProvinces": "[12]",
                    "corporateEmployeesInitialSignupWaittime": false,
                    "paymentMethod": "CREDIT_CARD",
                    "paymentMethodId": "2733173",
                    "shared": false,
                    "customData": null,
                    "contact_id": 4455,
                    "parent_id": 51,
                    "user_id": 189
                }
            }
        }
    ]
            }
    this.arrearsData = data.data
    // this.http
    //   .get(
    //     `${
    //       environment.apiUrl
    //     }/api/ap/get-arrears-report/0/${'May'}`,
    //     {
    //       headers: {
    //         Authorization: 'Bearer ' + accessToken,
    //         'Content-Type': 'application/json',
    //       },
    //     }
    //   )
    //   .subscribe({
    //     next: (res: any) => {
    //       console.log(res);
    //       $('#DataTables_Table_1').dataTable().fnDestroy();
    //       this.arrearsData = res;
    //       this.dtTrigger.next(null);
    //     },
    //     error: (error) => {
    //       console.log(error);
    //     },
    //   });
  

}

  // on change events
  onReportTypeChange(event: any) {
    this.filterAdvisors = [];
    this.isViewReport = false;
    if (this.filterReportType === '1') {
      this.getAdvisors();
    } else if (this.filterReportType === '3') {
      this.getPartners();
    }

    // changing table headers
    this.tableHeaders = this.reportTypes.find(
      (el) => el.id === +this.filterReportType
    ).tableHeaders;
    this.actions = [...this.tableHeaders['Action']];

    this.dtTrigger.unsubscribe();
    this.dtTrigger = new Subject<any>();
  }

  onRangeChange() {
    this.filterDateSelection = '';
    this.filterAdvisors = [];
  }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  // get dropdown datas
  getReportTypes() {
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(`${environment.reportApiUrl}/report/report-types`, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe({
        next: (res: any) => {
          this.reportTypes = res;
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  getAdvisors() {
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(`${environment.reportApiUrl}/report/advisors`, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe({
        next: (res: any) => {
          this.advisors = res;
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  getPartners() {
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(`${environment.reportApiUrl}/report/partners`, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe({
        next: (res: any) => {
          this.advisors = res;
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  closePopup() {
    $('#DataTables_Table_2').dataTable().fnDestroy();
  }

  // future reports
  clickGenerateReport() {
    this.generateReport();
    // let selectedDate = new Date();
    // if (this.filterIsMonthRange) {
    //   selectedDate = new Date(this.filterDateSelection[1]);
    // } else {
    //   selectedDate = new Date(this.filterDateSelection);
    // }

    // const year = selectedDate.getFullYear();
    // const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
    // const strDate = `${year}-${month}`;

    // const adv = this.filterAdvisors.map((el) => el.name);

    // Swal.fire({
    //   title: 'Alert',
    //   text: `Generate draft reports for month of ${strDate} for ${adv.join(
    //     ', '
    //   )}`,
    //   showDenyButton: false,
    //   showCancelButton: true,
    //   confirmButtonText: 'Proceed',
    // }).then((result) => {
    //   if (result.isConfirmed) {
    //     setTimeout(() => {
    //       this.generateReport();
    //     }, 1000);
    //   }
    // });
  }

  downloadReports() {
    if(this.data){
      var accessToken = sessionStorage.getItem('accessToken');
      var ids: number[] = [];

      this.data.forEach((element) => {
        ids.push(element.id);
      });

      this.http
      .get(
        `${
          environment.reportApiUrl
        }/report/reports-zip?ids=${ids}&reportType=${this.filterReportType}`,
        {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            //'Content-Type': 'application/zip',
          },
          responseType: 'arraybuffer',
        }
      )
      .subscribe({
        next: (res: any) => {
          const blob = new Blob([res], { type: 'application/zip' });
          let filename = 'reports.zip';
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename; 
          link.click();
          window.URL.revokeObjectURL(url);     
        },
        error: (error) => {
          console.log(error);
        },
      });
    } else {
      Swal.fire({
        title: 'Error',
        text: 'No reports to download',
      });
    }
  }

  generateReport() {
    let selectedDate = new Date();
    if (this.filterIsMonthRange) {
      selectedDate = new Date(this.filterDateSelection[1]);
    } else {
      selectedDate = new Date(this.filterDateSelection);
    }

    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
    const strDate = `${year}-${month}`;

    const adv = this.filterAdvisors.map((el) => el.id);

    var accessToken = sessionStorage.getItem('accessToken');

    const body = {
      date: strDate,
      reportType: this.filterReportType,
      subIds: adv,
    };

    this.http
      .post(`${environment.reportApiUrl}/report/generate`, body, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe({
        next: (res: any) => {
          Swal.fire({
            title: 'Success',
            text: 'The reports are queued to complete. The completion status will be updated in the pane below',
          }).then(() => {
            setTimeout(() => {
              this.applyFilters();
            }, 1000);
          });
        },
        error: (error) => {
          Swal.fire({
            title: 'Error',
            text: error.error.message,
          });
        },
      });
  }

  isShowGenerateReport() {
    // check report type
    if (!this.filterReportType) {
      return false;
    }
    // 1. check month
    const currentMonth = new Date().getMonth() + 1;

    let selectedMonth = -1;

    if (!this.filterDateSelection) {
      return false;
    }

    if (this.filterIsMonthRange) {
      selectedMonth = new Date(this.filterDateSelection[1]).getMonth();
    } else {
      selectedMonth = new Date(this.filterDateSelection).getMonth();
    }

    if (currentMonth > selectedMonth + 2) {
      return false;
    }

    if (this.filterReportType === '1' || this.filterReportType === '3') {
      // 2. check advisors and partners
      if (!this.filterAdvisors || this.filterAdvisors.length === 0) {
        return false;
      }
    }

    return true;
  }

  getReportTypeName(id: number) {
    const item = this.reportTypes.find((el) => el.id === id);
    return item?.reportType;
  }

  getPartnerName(id: number) {
    const item = this.advisors.find((el) => el.id === id);
    return item?.name;
  }

  // Payment
  showPayment(item) {
    this.paymentMonth = item.date;
    if (item.paymentDate) {
      this.paymentDate = new Date(item.paymentDate);
    } else {
      this.paymentDate = new Date();
    }
    this.paymentAmountPaid = item.amountPaid;
    $('#payment-modal').modal('show');
  }
  submitPayment() {}

  resetPayment() {
    this.paymentMonth = '';
    this.paymentDate = new Date();
    this.paymentAmountPaid = 0;
  }

  onSubmitAdjustment() {
    this.service.saveAdjustment(this.formAdjustment.value).subscribe({
      next: (res) => {
        $('#adjustment-modal').modal('hide');

        this.onResetAdjustment();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  onResetAdjustment() {
    this.formAdjustment.reset();
  }

  onVoidAdjustment() {
    const data = this.formAdjustment.value;
    this.service
      .cancelAdjustment(data.reportTypeId, data.month, data.subId)
      .subscribe({
        next: (res) => {
          $('#adjustment-modal').modal('hide');
          this.onResetAdjustment();
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  onHistoryAdjustment() {
    $('#adjustment-history-modal').modal('show');
  }

  sanitizeBase64(str) {
    // Remove any characters not allowed in a base64 encoded string
    let sanitizedStr = str.replace(/[^A-Za-z0-9+/=]/g, '');

    // Ensure proper padding by adding '=' if needed
    while (sanitizedStr.length % 4 !== 0) {
      sanitizedStr += '=';
    }

    return sanitizedStr;
  }
}
